"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const agencyInformation = {
    AA2: {
        name: 'Susan Yap Insurance Agency',
        address: '3750 S. Univeristy Dr. STE 260A',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76109',
        email: 'josh.susanyapinsurance.com@gmail.com',
        phone: '817-708-2277'
    },
    AA3: {
        name: 'Arizona Reliable Insurance Company',
        address: '14122 W. McDowell Rd Ste 100',
        city: 'Goodyear',
        state: 'AZ',
        zip: '85395',
        email: 'insurance@arizonareliable.com',
        phone: '623-900-1791'
    },
    AA4: {
        name: 'Jake Jacobson Insurance LLC',
        address: '2700 S. Woodlands Village Blvd Suite 300-197',
        city: 'Flagstaff',
        state: 'AZ',
        zip: '86001',
        email: 'jakejacobsoninsurance@gmail.com',
        phone: '928-255-8310'
    },
    AA5: {
        name: 'Mothers Insurance',
        address: '7550 E Firefly Way',
        city: 'Prescott Valley',
        state: 'AZ',
        zip: '86315',
        email: 'dennis@motherinsurance.com',
        phone: '928-379-1939'
    },
    AA6: {
        name: 'Bruce Bond Insurance Agency, Inc.',
        address: '17732 Preston Rd Suite 103',
        city: 'Dallas',
        state: 'TX',
        zip: '75252',
        email: 'bbond@bond-ins.com',
        phone: '469-767-1220'
    },
    AA7: {
        name: 'First Line insurance',
        address: '5751 Kroger Dr Ste 285',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76244',
        email: 'brett@firstline.insure',
        phone: '817-618-5480'
    },
    AA8: {
        name: 'Texas Giant Insurance',
        address: '2548 Dickerson Pkwy Suite 204',
        city: 'Carrollton',
        state: 'TX',
        zip: '75006',
        email: 'tom@texasgiantinsurance.com',
        phone: '972-394-9838'
    },
    AAA1: {
        name: 'AAA Ohio Auto Club',
        address: '90 E. Wilson Bridge Rd.',
        city: 'Worthington',
        state: 'OH',
        zip: '43085',
        email: 'inswebquotes@aaaohio.com',
        phone: '(614) 543-8917'
    },
    ADIG1: {
        name: 'Advisor Insurance Group LLC',
        address: '5450 NW Central Dr. #270',
        city: 'Houston',
        state: 'TX',
        zip: '77092',
        email: 'hanadi@advisorus.com',
        phone: '713-688-1660'
    },
    AGHRO: { name: 'Agent Hero', address: '', city: '', state: '', zip: '', email: '', phone: '' },
    AGHRO1: {
        name: 'B & B Insurance Group',
        address: '200 Milwaukee Ave',
        city: 'Buffalo Grove',
        state: 'IL',
        zip: '60089',
        email: 'kbaryash@bnbinsurance.org',
        phone: '(847) 796-9696'
    },
    AGHRO2: {
        name: 'Vim Rise Financial Services',
        address: '957-A Main Street',
        city: 'Stone Mountain',
        state: 'GA',
        zip: '30083',
        email: 'insurance@vimrise.com',
        phone: '(770) 217-9882'
    },
    AGHRO3: {
        name: 'Ben-Kinney Insurance, Mortgage, & Home, LLC',
        address: '3344 E Kleindale Rd Unit 74',
        city: 'Tucson',
        state: 'AZ',
        zip: '85716',
        email: 'support@bkinsurancemortgage.com',
        phone: '(480) 540-7673'
    },
    AGHRO4: {
        name: 'The Way Agency',
        address: '435 N Bardstown Rd',
        city: 'Mount Washington',
        state: 'KY',
        zip: '40047',
        email: 'rebecca@thewayagency.com',
        phone: '(502) 413-5335'
    },
    AGHRO5: {
        name: 'Crestar Investment Corp',
        address: '1745 Texas Parkway',
        city: 'Missouri City',
        state: 'TX',
        zip: '77489',
        email: 'nizar@crestarins.com',
        phone: '(281) 236-2140'
    },
    AGHRO6: {
        name: 'Aspen Gold Insurance Brokers',
        address: '11001 West 120th Ave',
        city: 'Broomfield',
        state: 'CO',
        zip: '80021',
        email: 'caleb@aspengoldins.com',
        phone: '(303) 358-2637'
    },
    AGHRO7: {
        name: 'Renegade Insurance Agency, LLC',
        address: '2345 Boot Jack Rd',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76177',
        email: 'zfarris@renegadeinsurance.net',
        phone: '(682) 267-8787'
    },
    AGHRO8: {
        name: 'David Gebhardt Insurance',
        address: '520 Madison Ave.',
        city: 'New York',
        state: 'NY',
        zip: '10022',
        email: 'arizona-insurance@hotmail.com',
        phone: '(623) 694-2487'
    },
    AGHRO9: {
        name: 'Gary R Miller Insurance Associates LLC',
        address: '550 Norristown Rd.',
        city: 'Spring House',
        state: 'PA',
        zip: '19477',
        email: 'gary@miapro.com',
        phone: '(215) 646-0550'
    },
    AGHRO10: {
        name: 'Premier Insurance Services LLC',
        address: '1703 Hwy 11 N',
        city: 'Picayune',
        state: 'MS',
        zip: '39466',
        email: 'brittani@thepremieragency.com',
        phone: '(769) 242-2702'
    },
    AGHRO11: {
        name: 'Houston Insurance Agency, Inc',
        address: '6430 Richmond Ave Suite 250-12',
        city: 'Houston',
        state: 'TX',
        zip: '77057',
        email: 'rezanazari10@gmail.com',
        phone: '(713) 787-6000'
    },
    AGHRO12: {
        name: 'Alfredo Solis Insurance Agency',
        address: '411 S International Blvd',
        city: 'Hidalgo',
        state: 'TX',
        zip: '78557',
        email: 'asolis@att.net',
        phone: '(956) 867-1280'
    },
    AGHRO13: {
        name: 'Enright Group',
        address: '300 S Main St',
        city: 'Jacksonville',
        state: 'TX',
        zip: '75766',
        email: 'info@enrightgrp.com',
        phone: '(903) 730-6060'
    },
    AGHRO14: {
        name: 'TEXAS INSURANCE BUREAU SERVICES LLC',
        address: '1127 E 9TH ST',
        city: 'MISSION',
        state: 'TX',
        zip: '78572',
        email: 'MARY@TEXASINSURANCEBUREAU.NET',
        phone: '(956) 766-7126'
    },
    AGHRO15: {
        name: 'Nobles Management Group, LLC',
        address: '1713 Briarcrest Drive, Suite 210',
        city: 'Bryan',
        state: 'TX',
        zip: '77802',
        email: 'admin@noblesmngt.com',
        phone: '(979) 557-2289'
    },
    AGHRO16: {
        name: 'Haendiges Insurance Solutions, LLC',
        address: '6 Public Square',
        city: 'Salem',
        state: 'IN',
        zip: '47167',
        email: 'trey@protectwithhis.com',
        phone: '(812) 404-4220'
    },
    AGHRO17: {
        name: 'Guidepoint Agency, Inc',
        address: '2929 N Central Expy, Ste 275',
        city: 'Richardson',
        state: 'TX',
        zip: '75080',
        email: 'chris@gpagents.com',
        phone: '(972) 755-3969'
    },
    AGHRO18: {
        name: 'SWZ Insurance & Risk Management',
        address: '295 E Renfro Stree',
        city: 'Burleson',
        state: 'TX',
        zip: '76028',
        email: 'jtanner@swzinsurance.com',
        phone: '(682) 250-5785'
    },
    AGHRO19: {
        name: 'Mitgo Insurance Agency LLC',
        address: '12 Greenway Plaza',
        city: 'Houston',
        state: 'TX',
        zip: '77046',
        email: 'mitgoinsurance@outlook.com',
        phone: '(832) 407-8736'
    },
    AGHRO20: {
        name: 'ALICO INSURANCE AGENCY OF TEXAS LLC',
        address: '6776 SW FREEWAY STE 365',
        city: 'HOUSTON',
        state: 'TX',
        zip: '77074',
        email: 'ALICOINSTX@AIM.COM',
        phone: '(713) 400-0000'
    },
    AGHRO21: {
        name: 'Nedal Hussein',
        address: '14420 W.Sylvan Field Dr STE 150',
        city: 'Houstob',
        state: 'TX',
        zip: '77014',
        email: 'VNFLLC@gmail.com',
        phone: '(713) 705-4275'
    },
    AGHRO22: {
        name: 'American Advantage Insurance Agency',
        address: '4097 Irish Moss Ln',
        city: 'San Bernardino',
        state: 'CA',
        zip: '92407',
        email: 'bgriffith@aa-ia.com',
        phone: '(909) 646-3522'
    },
    AGHRO23: {
        name: 'THE COLONY GENERAL INSURANCE AGENCY',
        address: '5610 AVIS HILL COURT',
        city: 'FULSHEAR',
        state: 'TX',
        zip: '77441',
        email: 'OAALATAN@YAHOO.COM',
        phone: '(713) 774-1128'
    },
    AGHRO24: {
        name: 'Davis insurance Group Inc',
        address: '1753 Swamp Pike',
        city: 'Gilbertsville',
        state: 'PA',
        zip: '19525',
        email: 'jen@jldavisins.com',
        phone: '(610) 287-8440'
    },
    AGHRO25: {
        name: 'RJM Insurance & Financial Services Inc',
        address: '3510 HOBSON ROAD #301',
        city: 'WOODRIDGE',
        state: 'IL',
        zip: '60517',
        email: 'rjminsurance@gmail.com',
        phone: '(630) 737-1776'
    },
    AGHRO26: {
        name: 'Awesome Insurance Service',
        address: '604 Brandt St',
        city: 'Grandview',
        state: 'Texas',
        zip: '76050',
        email: 'rtanner@myawesomeinsurance.com',
        phone: '(817) 239-8172'
    },
    AGHRO27: {
        name: 'Integrity Insurance Group LLC',
        address: '16 Capital Street',
        city: 'Charleston',
        state: 'WV',
        zip: '25301',
        email: 'chris@iigwv.com',
        phone: '(304) 346-9181'
    },
    AGHRO28: {
        name: 'TUNG NGUYEN',
        address: '10901 N. LAMAR BLVD, STE A107',
        city: 'AUSTIN',
        state: 'TX',
        zip: '78753',
        email: 'baohiem101@gmail.com',
        phone: '(512) 632-0329'
    },
    AGHRO29: {
        name: 'Nowlin Insurance Group LLC',
        address: '2925 Richmond Avenue',
        city: 'Houston',
        state: 'TX',
        zip: '77098',
        email: 'Lance@mytexaspolicy.com',
        phone: '(713) 526-5520'
    },
    AGHRO30: {
        name: 'A to B Financial Services LLC',
        address: '306 S Elm St',
        city: 'Plattsburg',
        state: 'MO',
        zip: '64477',
        email: 'bnorris@a2bfinancialservices.com',
        phone: '(816) 592-9967'
    },
    AGHRO31: {
        name: 'Elite Auto Insurance',
        address: '14360 Bellaire Blvd',
        city: 'Houston',
        state: 'TX',
        zip: '77083',
        email: 'eliteautoins@gmail.com',
        phone: '(832) 422-5322'
    },
    AGHRO32: {
        name: 'Koda Insurance Group',
        address: '2658 Industrial Blvd',
        city: 'Abilene',
        state: 'TX',
        zip: '79605',
        email: 'ruby@kodainsurancegroup.com',
        phone: '(325) 695-9999'
    },
    AGHRO33: {
        name: 'Potomac Insurance X-Change',
        address: '9701 Apollo Drive',
        city: 'Largo',
        state: 'MD',
        zip: '20774',
        email: 'potomacinsuranceexchange@insurer.com',
        phone: '(240) 801-6100'
    },
    AGHRO34: {
        name: 'Kevin S. Dougherty Insurance Agency, Ltd.',
        address: '1000 Jorie Blvd. #109',
        city: 'Oak Brook',
        state: 'IL',
        zip: '',
        email: 'kevin@ksdinsurance.com',
        phone: '(630) 575-0800'
    },
    AGHRO35: {
        name: 'Trinity Property & Casualty Insurance',
        address: '2625 Butterfield',
        city: 'Oak Brook',
        state: 'IL',
        zip: '60523',
        email: 'andrew@trinitypci.com',
        phone: '(630) 748-4600'
    },
    AGHRO36: {
        name: 'Texas Insurance Specialists',
        address: '24718 FM 2100 Rd, Ste 106',
        city: 'Huffman',
        state: 'TX',
        zip: '77336',
        email: 'amy@txinsspecialists.com',
        phone: '(281) 764-5641'
    },
    AGHRO37: {
        name: 'Edna Tyler Agency',
        address: '1973 West Gray #23',
        city: 'Houston',
        state: 'TX',
        zip: '77019',
        email: 'etyler@insurehtown.com',
        phone: '(832) 300-9900'
    },
    AGHRO38: {
        name: 'STARS INSURANCE GROUP',
        address: '251 N Milwaukee Ave',
        city: 'Buffalo Grove',
        state: 'IL',
        zip: '60089',
        email: 'INFO@STARS-INSURANCE.COM',
        phone: '(847) 760-9669'
    },
    AGHRO39: {
        name: 'Dugger Insurance Agency, LLC',
        address: '404 W 67th St',
        city: 'Loveland,',
        state: 'CO',
        zip: '80538',
        email: 'steve.dugger@msn.com',
        phone: '(970) 632-6800'
    },
    AGHRO40: {
        name: 'Thousand Oaks Insurance Agency',
        address: '3525 Old Conejo Road suite 120',
        city: 'Thousand Oaks',
        state: 'CA',
        zip: '91320',
        email: 'pat@etrustedadvisor.com',
        phone: '(805) 480-2616'
    },
    AGHRO41: {
        name: 'Capital Insurance Agency, Inc.',
        address: '6114 McPherson Rd Ste 12',
        city: 'Laredo',
        state: 'TX',
        zip: '78041',
        email: 'gracej@capitalinsa.com',
        phone: '(956) 608-3130'
    },
    AGHRO42: {
        name: 'TC Taylor Consulting LLC',
        address: '800 W 2nd Ave Suite A',
        city: 'Corsicana',
        state: 'TX',
        zip: '75110',
        email: 'tomtaylor56@yahoo.com',
        phone: '(214) 912-9634'
    },
    AGHRO43: {
        name: 'Kevin E. Severance Insurance Agency LLC',
        address: '3027 Marina Bay Dr., Ste., 309',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'kevin@insurancenavigators.com',
        phone: '(281) 333-3100'
    },
    AGHRO44: {
        name: 'AMG Insurance Group',
        address: '25420 KUYKENDAHL RD STE B100',
        city: 'TOMBALL',
        state: 'TX',
        zip: '77375',
        email: 'brian@amginsgroup.com',
        phone: '(832) 257-6336'
    },
    AGHRO45: {
        name: 'RVS Insurance group',
        address: '1801 Contry Place Parkway ste 111',
        city: 'Pearland',
        state: 'TX',
        zip: '77584',
        email: 'rvs@rvsinsgroup.com',
        phone: '(832) 243-4430'
    },
    AGHRO46: {
        name: 'ASEGURA INSURANCE AGENCY, LLC.',
        address: '1125 N ZARAGOZA RD',
        city: 'EL PASO',
        state: 'TX',
        zip: '79907',
        email: 'carlos@asegura-insruance.com',
        phone: '(915) 613-4800'
    },
    AGHRO47: {
        name: 'Faith Alliance Insurance Brokers, LLC',
        address: '314 E Nakoma',
        city: 'San Antonio',
        state: 'TX',
        zip: '78216',
        email: 'faibllc@gmail.com',
        phone: '(210) 920-0782'
    },
    AGHRO48: {
        name: 'Hometown Insurance Services, Inc',
        address: '186 W Hwy 246',
        city: 'Buellton',
        state: 'CA',
        zip: '93427',
        email: 'randy@askhometown.com',
        phone: '(805) 688-6418'
    },
    AGHRO49: {
        name: 'RMIA Inc.',
        address: '9119 Otis Avenue',
        city: 'Indianapolis,',
        state: 'IN',
        zip: '46216',
        email: 'steveday@rmiainc.com',
        phone: '(317) 549-8862'
    },
    AGHRO50: {
        name: 'Wolf Insurance & Financial Services',
        address: '5640 Montana ste G',
        city: 'El Paso,',
        state: 'TX',
        zip: '79925',
        email: 'wolfinsurance10@gmail.com',
        phone: '(915) 352-3886'
    },
    AGHRO51: {
        name: 'Kris Jacobs Agency',
        address: '6925 Dutchland Blvd',
        city: 'Liberty TWP',
        state: 'OH',
        zip: '45044',
        email: 'kris.jacobs@protectmytomorrow.com',
        phone: '(513) 289-1348'
    },
    AGHRO52: {
        name: 'Tomlinson Insurance Agency, Inc',
        address: '90 W Main St',
        city: 'Chillicothe',
        state: 'OH',
        zip: '45601',
        email: 'andy@tomlinsonins.com',
        phone: '(740) 773-4181'
    },
    AGHRO53: {
        name: 'The ONE Insurance Firm',
        address: '1162 Suncast Ln., Suite 1',
        city: 'El Dorado Hills',
        state: 'CA',
        zip: '95762',
        email: 'Brad@TheONEInsuranceFirm.com',
        phone: '(916) 235-1111'
    },
    AGHRO54: {
        name: 'The Insurance Market, LLC',
        address: '8005 W. 110th St.',
        city: 'Overland Park',
        state: 'KS',
        zip: '66210',
        email: 'jim@the-insurance-market.com',
        phone: '(913) 722-2111'
    },
    AGHRO55: {
        name: 'Clear Choice Partners LLC',
        address: '20261 E Ocotillo rd',
        city: 'queen creek',
        state: 'AZ',
        zip: '85142',
        email: 'chris@clearchoiceins.com',
        phone: '(480) 719-2812'
    },
    AGHRO56: {
        name: "Ken's Insurance Agency, LLC",
        address: '4210 Highway 51 South',
        city: 'Hernando',
        state: 'MS',
        zip: '38632',
        email: 'ken.sigler@kensinsuranceagency.net',
        phone: '(662) 292-6271'
    },
    AGHRO57: {
        name: 'Veracity Insurance Group',
        address: '11539 Clayton Court',
        city: 'Frisco',
        state: 'TX',
        zip: '75035',
        email: 'cbondjr@veracityinsgroup.com',
        phone: '(469) 592-0620'
    },
    AGHRO58: {
        name: 'Southland Financial Services Inc.',
        address: '11000 Front St',
        city: 'Mokena',
        state: 'IL',
        zip: '60448',
        email: 'frank.kulak@southlandsavings.biz',
        phone: '(708) 756-0065'
    },
    AGHRO59: {
        name: 'Twogil Agency',
        address: '4482 Woodson Rd',
        city: 'St Louis',
        state: 'MO',
        zip: '63134',
        email: 'trinita@twogilagency.com',
        phone: '(314) 831-9933'
    },
    AGHRO60: {
        name: 'Redding Insurance, Inc.',
        address: '999 W Main St Ste 100',
        city: 'Boise',
        state: 'ID',
        zip: '83702',
        email: 'leroy@reddinginsurance.com',
        phone: '(208) 467-4000'
    },
    AGHRO61: {
        name: 'PTM INSURANCE AGENCY',
        address: '1700 HAMNER AVE. SUITE 103',
        city: 'NORCO',
        state: 'CA',
        zip: '92860',
        email: 'maria@ptmins.com',
        phone: '(951) 279-9090'
    },
    AGHRO62: {
        name: 'Davidson Insurance Agency Ltd',
        address: '606 W Broadway',
        city: 'West Plains',
        state: 'MO',
        zip: '65775',
        email: 'd.davidson@davidsoninsurance.net',
        phone: '(417) 256-2168'
    },
    AGHRO63: {
        name: 'INSURANCEWIDE COMPANY, LLC',
        address: '5901 W INDIAN SCHOOL RD STE 4',
        city: 'PHOENIX',
        state: 'AZ',
        zip: '85033',
        email: 'miguel@insurance-wide.com',
        phone: '(623) 873-1234'
    },
    AGHRO64: {
        name: 'Insurance Corner',
        address: 'P.O. Box 670747',
        city: 'Houston',
        state: 'TX',
        zip: '77267',
        email: 'Ben@northeast-insurance.com',
        phone: '(281) 448-6677'
    },
    AGHRO65: {
        name: 'Insurance Brokerage Service',
        address: '1404 Hunters Branch Road',
        city: 'Antioch',
        state: 'TN',
        zip: '37013',
        email: 'ibsnashville@gmail.com',
        phone: '(615) 445-3674'
    },
    AGHRO66: {
        name: 'HOLMES & HOLMES INSURANCE AGENCY, INC.',
        address: '299 N. FAIRVIEW AVE, 2ND FLR',
        city: 'GOLETA',
        state: 'CA',
        zip: '93117',
        email: 'JHOLMES@HHINS.NET',
        phone: '(805) 681-0505'
    },
    AGHRO67: {
        name: 'Adept Insurance Partners LLC',
        address: '1727 Greenup Street',
        city: 'Covington',
        state: 'KY',
        zip: '41011',
        email: 'ryan@adept.insure',
        phone: '(859) 412-2042'
    },
    AGHRO68: {
        name: 'Champion Insurance Services, LLC DBA Portland Insurance',
        address: '115 E Main St',
        city: 'Portland',
        state: 'Indiana',
        zip: '47371',
        email: 'kyle@portins.com',
        phone: '(260) 726-9345'
    },
    AGHRO69: {
        name: 'Sierra Insurance Group',
        address: '7676 hillmont st ste 240A',
        city: 'Houston',
        state: 'TX',
        zip: '77040',
        email: 'viviana@sierrainsgroup.com',
        phone: '(713) 371-6806'
    },
    AGHRO70: {
        name: 'Atomica Services inc DBA Texas Insurance Agency',
        address: '113 W. Harwood Road',
        city: 'Euless',
        state: 'TX',
        zip: '76039',
        email: 'personal.insurance@gmail.com',
        phone: '(817) 704-3115'
    },
    AGHRO71: {
        name: 'Perrine Agency',
        address: '3981 Zarthan Ave S',
        city: 'St Louis Park',
        state: 'MN',
        zip: '55416',
        email: 'Dperrine@perrineagency.com',
        phone: '(952) 888-3471'
    },
    AGHRO72: {
        name: 'DK Insurance Agency, LLC',
        address: '6901 N Lamar Blvd 134',
        city: 'Austin',
        state: 'Texas',
        zip: '78752',
        email: 'kim9702688@gmail.com',
        phone: '(512) 761-4222'
    },
    AGHRO73: {
        name: 'Magnum Choice Insurance Agency',
        address: '5016 Tennyson Parkway',
        city: 'Plano',
        state: 'Texas',
        zip: '75024',
        email: 'joe@magnumchoice.com',
        phone: '972-801-6878'
    },
    AGHRO74: {
        name: 'Spartan Insurance Solutions',
        address: '2222 PEBBLEBROOK',
        city: 'WESTLAKE',
        state: 'Ohio',
        zip: '44145',
        email: 'nik@spartaninsurancesolutions.com',
        phone: '(330) 942-0405'
    },
    AGHRO75: {
        name: 'Insurance On Demand LLC',
        address: '1600 envoy cir',
        city: 'louisville',
        state: 'Kentucky',
        zip: '40047',
        email: 'stephen@insuranceod.com',
        phone: '(502) 724-5314'
    },
    AGHRO76: {
        name: 'Magno Insurance Group LLC',
        address: '1722 Routh St Suite 900',
        city: 'Dalla',
        state: 'Texas',
        zip: '75201',
        email: 'info@magnoinsgrp.com',
        phone: '(817) 691-4225'
    },
    AGHRO77: {
        name: 'RIGHTSURE',
        address: '5151 E. Broadway',
        city: 'Tucson',
        state: 'Arizona',
        zip: '85711',
        email: 'jeffa@rightsure.com',
        phone: '(520) 901-7010'
    },
    AGHRO78: {
        name: 'Covey Insurance',
        address: '17280 W Lake Houston Parkway',
        city: 'Humble',
        state: 'Texas',
        zip: '77346',
        email: 'ccovey.coveyins@gmail.com',
        phone: '(832) 995-5594'
    },
    AGHRO79: {
        name: 'Orange County Pacific Auto Insurance Brokerage',
        address: '10161 BOLSA AVE 104A',
        city: 'WESTMINSTER',
        state: 'California',
        zip: '92683',
        email: 'KATIE@OCPACIFIC.COM',
        phone: '(714) 531-8999'
    },
    AGHRO80: {
        name: 'Dahlmeier Insurance Agency, Inc',
        address: '1368 Longfellow Ave.',
        city: 'Chico',
        state: 'California',
        zip: '95926',
        email: 'john@dahlmeier.com',
        phone: '(530) 342-6421'
    },
    AGHRO81: {
        name: 'Robert King Insurance Agency',
        address: '6010 W Spring Creek Pkwy',
        city: 'Plano',
        state: 'Texas',
        zip: '75024',
        email: 'robert@bobkingagency.com',
        phone: '(469) 331-0127'
    },
    AGHRO82: {
        name: 'The Insurance Place',
        address: '3251 Lamar Ave Suite D',
        city: 'Paris',
        state: 'Texas',
        zip: '75460',
        email: 'theinsuranceplaceparis@gmail.com',
        phone: '(903) 669-3178'
    },
    AGHRO83: {
        name: 'Francisco Maldonado',
        address: '1242 Tulloch Dr',
        city: 'Tracy',
        state: 'California',
        zip: '95304',
        email: 'fmaldokids@sbcglobal.net',
        phone: '(408) 375-5699'
    },
    AGHRO84: {
        name: 'Roberts Family Insurance',
        address: '3515 PRESTON AVE',
        city: 'PASADENA',
        state: 'Texas',
        zip: '77505',
        email: 'DIANN@ROBERTSFAMILYINSURANCE.NET',
        phone: '(281) 991-0787'
    },
    AGHRO85: {
        name: 'ModernInsurance.io Corp',
        address: '690 E Warner Rd',
        city: 'Gilbert',
        state: 'Arizona',
        zip: '85296',
        email: 'Cameron@ModernIns.io',
        phone: '(480) 812-1998'
    },
    AGHRO86: {
        name: 'Live Oak Insurance Agency',
        address: '211 highland cross dr suite 114',
        city: 'Houston',
        state: 'Texas',
        zip: '77073',
        email: 'texasinsurance1@hotmail.com',
        phone: '(281) 869-4545'
    },
    AGHRO87: {
        name: 'Right Way Insurance Solutions',
        address: '10295 Taliesin Dr. #308',
        city: 'Englewood',
        state: 'Colorado',
        zip: '80112',
        email: 'tracey@rightwayinsurancesolutions.com',
        phone: '(720) 254-0875'
    },
    AGHRO88: {
        name: 'Inshora Financial Group',
        address: '14090 Southwest Freeway Suite 220',
        city: 'Sugar Land',
        state: 'Texas',
        zip: '77478',
        email: 'Imran@Inshoragroup.com',
        phone: '(713) 943-9985'
    },
    AGHRO89: {
        name: 'CityScape Insurance, LLC',
        address: '127 W Juanita Ave #114',
        city: 'Mesa',
        state: 'Arizona',
        zip: '85210',
        email: 'matt@cityscapeinsurance.com',
        phone: '(602) 888-1732'
    },
    AGHRO90: {
        name: 'EVAN J MCKELVEY',
        address: '2241 COUNTRY RD.',
        city: 'BELLEVILLE',
        state: 'Illinois',
        zip: '62221',
        email: 'MCKELVEYINSURANCEGROUP@GMAIL.COM',
        phone: '(618) 623-0080'
    },
    AGHRO91: {
        name: 'J And B Financial',
        address: '12303 Scarsdale',
        city: 'Houston',
        state: 'Texas',
        zip: '77089',
        email: 'jandbinsuranceandtaxes@gmail.com',
        phone: '(281) 397-3294'
    },
    AGHRO92: {
        name: 'KB Insurance',
        address: '1907 caddo village rd',
        city: 'arlington',
        state: 'Texas',
        zip: '76008',
        email: 'KBinscompany@gmail.com',
        phone: '(682) 583-0647'
    },
    AGHRO93: {
        name: 'KO Insurance Agency',
        address: '4235 Cook Rd',
        city: 'Houston',
        state: 'Texas',
        zip: '77072',
        email: 'service@koinsagency.com',
        phone: '(832) 794-1876'
    },
    AGHRO94: {
        name: 'MAR INSURANCE',
        address: '7676 HILMONT ST #240A',
        city: 'HOUSTON',
        state: 'Texas',
        zip: '77040',
        email: 'MADAI@MARINSURANCE.NET',
        phone: '(832) 618-7205'
    },
    AGHRO95: {
        name: 'Texas Insurance Choice',
        address: '8700 Commerce Park Dr.',
        city: 'Houston',
        state: 'Texas',
        zip: '77036',
        email: 'info@texasinsurancechoice.com',
        phone: '(281) 310-5899'
    },
    AGHRO96: {
        name: 'Ullrich Insurance Agency Inc',
        address: '5310 Ward Rd #G07',
        city: 'Arvada',
        state: 'Colorado',
        zip: '80002',
        email: 'tom@ullrichinsuranceagency.com',
        phone: '(303) 425-7568'
    },
    AGHRO97: {
        name: 'SOUND BUSINESS INSURANCE',
        address: '3309 56TH ST',
        city: 'GIG HARBOR',
        state: 'Washington',
        zip: '98335',
        email: 'FRANK@SOUNDBIZ.NET',
        phone: '(253) 858-9988'
    },
    AGHRO98: {
        name: 'TEXAS CASUALTY GROUP LLC',
        address: '1220 Blalock Rd',
        city: 'Houston',
        state: 'Texas',
        zip: '77055',
        email: 'robin@texascasualtyins.com',
        phone: '(281) 769-1574'
    },
    AGHRO99: {
        name: 'Optiumum Insurance Agency LLC',
        address: '409 North Fredonia Ste 124',
        city: 'Longview',
        state: 'Texas',
        zip: '75601',
        email: 'info@oiaagency.com',
        phone: '(903) 289-1100'
    },
    AGHRO100: {
        name: 'Dennis W. Diehl Insurancy Agency',
        address: '2607 Spring Cypress Rd',
        city: 'Spring',
        state: 'Texas',
        zip: '77388',
        email: 'insureyou@aol.com',
        phone: '(281) 651-8000'
    },
    AGHRO101: {
        name: 'Kuzbiel Insurance Brokers LLC',
        address: '1930 Sherman St',
        city: 'Denver',
        state: 'Colorado',
        zip: '80203',
        email: 'daniel@kuzbielinsurance.com',
        phone: '(720) 351-2066'
    },
    AGHRO102: {
        name: 'Brittany Baldwin',
        address: '2511 Pechora Pipit',
        city: 'new braunfels',
        state: 'Texas',
        zip: '78130',
        email: 'bbaldwincapital@gmail.com',
        phone: '(210) 551-7495'
    },
    AGHRO103: {
        name: 'AC Agency Group',
        address: '1912 riverton dr',
        city: 'suwanee',
        state: 'Georgia',
        zip: '30024',
        email: 'Allencraineiii@yahoo.com',
        phone: '(770) 940-1591'
    },
    AGHRO104: {
        name: 'Sphere Insurance Group',
        address: '1376 State Route 28',
        city: 'Loveland',
        state: 'Ohio',
        zip: '45140',
        email: 'zach@sphereinsurancegroup.com',
        phone: '(513) 965-0102'
    },
    AGHRO105: {
        name: 'Commercial Insurance Marketing, Corp.',
        address: '8460 Watson Road - Suite 201',
        city: 'Saint Louis',
        state: 'Missouri',
        zip: '63119',
        email: 'steveinsurance@msn.com',
        phone: '(314) 842-7320'
    },
    AGHRO106: {
        name: 'The Hutch Agency',
        address: '121 Ferry Street',
        city: 'Proctorville',
        state: 'Ohio',
        zip: '45669',
        email: 'hutch@thehutchagency.com',
        phone: '(740) 886-7200'
    },
    AGHRO107: {
        name: 'Insuragy, LLC',
        address: '3901 Buckingham Pl',
        city: 'Colleyville',
        state: 'Texas',
        zip: '76034',
        email: 'dgormley@insuragy.com',
        phone: '(214) 704-6590'
    },
    aghro107: {
        name: 'Insuragy, LLC',
        address: '3901 Buckingham Pl',
        city: 'Colleyville',
        state: 'Texas',
        zip: '76034',
        email: 'dgormley@insuragy.com',
        phone: '(214) 704-6590'
    },
    AGHRO108: {
        name: 'Green Planet Insurance',
        address: '706 E Bell Rd Ste 201',
        city: 'Phoenix',
        state: 'Arizona',
        zip: '85022',
        email: 'daniel@greenplanetinsurance.com',
        phone: '(602) 368-2124'
    },
    AGHRO109: {
        name: 'Rook Insurance Brokers LLC',
        address: '1550 Larimer Street',
        city: 'Denver',
        state: 'Colorado',
        zip: '80202',
        email: 'emil@intp.io',
        phone: '(303) 902-6422'
    },
    AGHRO110: {
        name: 'Combined Insurance Associates',
        address: '1850 Lamar Ave',
        city: 'Paris',
        state: 'Texas',
        zip: '75460',
        email: 'jason@chapmaninsurance.net',
        phone: '(903) 784-5047'
    },
    AGHRO111: {
        name: "Scheer's Insurance Services LLC",
        address: '9420 47th St',
        city: 'Brookfield',
        state: 'Illinois',
        zip: '60513',
        email: 'rscheer@scheersins.com',
        phone: '(708) 852-3083'
    },
    AGHRO112: {
        name: 'Ameriagency Inc.',
        address: '1850 Memorial Blvd',
        city: 'Murfreesboro',
        state: 'Tennessee',
        zip: '37129',
        email: 'baird@ameriagency.com',
        phone: '(888) 851-5572'
    },
    AGHRO113: {
        name: 'The Todd D Tucker Agency, LLC',
        address: 'PO Box 40687',
        city: 'Cincinnati',
        state: 'Ohio',
        zip: '45240',
        email: 'ttucker@todddtuckeragency.com',
        phone: '(513) 223-6947'
    },
    AGHRO114: {
        name: 'Andrew Hollern',
        address: '601 16th St',
        city: 'Golden',
        state: 'Colorado',
        zip: '80401',
        email: 'andrew@lionprideleads.com',
        phone: '(303) 505-0140'
    },
    AGHRO115: {
        name: 'Ozzy Auto Insurance',
        address: '5550 Columbia Pike suite 291',
        city: 'Arlington',
        state: 'Virginia',
        zip: '22204',
        email: 'ozzyautoinsurance@yahoo.com',
        phone: '(865) 696-9885'
    },
    AGHRO116: {
        name: 'Coastal Bend Ins',
        address: '7013 Adcote Drive',
        city: 'Corpus Christi',
        state: 'Texas',
        zip: '78413',
        email: 'lglugo@coastalbendins.com',
        phone: '(361) 288-8807'
    },
    AGHRO117: {
        name: 'MID-OZARK INSURANCE AGENCY INC',
        address: '309 E MAIN STREET',
        city: 'WILLOW SPRINGS',
        state: 'Missouri',
        zip: '65793',
        email: 'RASHANKS@SOCKET.NET',
        phone: '(417) 469-3202'
    },
    AGHRO118: {
        name: 'Mackenzie Holden Insurance Agency',
        address: '1302 Waugh Dr #185',
        city: 'Houston',
        state: 'Texas',
        zip: '77019',
        email: 'mikem@getmhi.com',
        phone: '(346) 221-5514'
    },
    AGHRO119: {
        name: 'TOTAL COVERAGE INSURANCE SERVICES, LLC',
        address: '1431 GREENWAY DR',
        city: 'IRVING',
        state: 'Texas',
        zip: '75038',
        email: 'DAVID@TCITX.COM',
        phone: '(972) 986-1100'
    },
    AGHRO120: {
        name: 'Gary S Bass Inc dba Bass Insurance Connection',
        address: '268 CR 1743',
        city: 'Chico',
        state: 'Texas',
        zip: '76431',
        email: 'blbass@sbcglobal.net',
        phone: '(817) 253-1023'
    },
    AGHRO121: {
        name: 'Crisp and Company Insurance LLC',
        address: '4496 Marie Drive',
        city: 'Middletown',
        state: 'Ohio',
        zip: '45044',
        email: 'ross@crispandcompany.com',
        phone: '(513) 433-3433'
    },
    AGHRO122: {
        name: 'The Wade Agency LLC',
        address: '113 N 1st St',
        city: 'La Grange',
        state: 'Kentucky',
        zip: '40031',
        email: 'Matt@wadeinsurancellc.com',
        phone: '(502) 265-2111'
    },
    AGHRO123: {
        name: 'Spring Select',
        address: '987 Old Eagle School Rd',
        city: 'Wayne',
        state: 'Pennsylvania',
        zip: '19087',
        email: 'adam@springSelectins.com',
        phone: '(484) 864-4070'
    },
    AGHRO124: {
        name: 'Global Insurance Agency LLC II',
        address: '6564 Loisdale Ct Suite 600',
        city: 'Springfield',
        state: 'Virginia',
        zip: '22150',
        email: 'cherif.memene@iglobalinsure.com',
        phone: '(703) 574-1134'
    },
    AGHRO125: {
        name: 'NEST Insurance Agency, LLC',
        address: '3451 S Western',
        city: 'Amarillo',
        state: 'Texas',
        zip: '79109',
        email: 'office@nestinsuranceagency.com',
        phone: '(806) 476-2580'
    },
    AGHRO126: {
        name: 'KINGDOM FINANCIAL BENEFIT SOLUTIONS',
        address: '8021 NAPLES CT',
        city: 'AMARILLO',
        state: 'Texas',
        zip: '79119',
        email: 'JR@JRSPRIGGS.COM',
        phone: '(806) 316-0101'
    },
    AGHRO127: {
        name: 'Michele Taylor Insurance Services',
        address: '2377 Gold Meadow Way Suite 100',
        city: 'Gold River',
        state: 'California',
        zip: '95670',
        email: 'mtaylor@mtisnow.com',
        phone: '(916) 249-4333'
    },
    AGHRO128: {
        name: 'STEVE VITOLA INSURANCE AGENCY INC',
        address: '1505 W Huisache Ave',
        city: 'San Antonio',
        state: 'Texas',
        zip: '78201',
        email: 'stevevitola@gmail.com',
        phone: '(210) 342-3406'
    },
    AGHRO129: {
        name: 'Real Deal Insurance',
        address: '1201 Route 70 W',
        city: 'Cherry Hill',
        state: 'New Jersey',
        zip: '80002',
        email: 'realdealinsuranceus@gmail.com',
        phone: '(856) 229-7035'
    },
    AGHRO130: {
        name: 'Tans Agency',
        address: '6600 Chase Oaks Blvd #150',
        city: 'Plano',
        state: 'Texas',
        zip: '75023',
        email: 'tan@tanagency.com',
        phone: '(972) 510-5346'
    },
    AGHRO131: {
        name: 'Kenneth Clark Insurance Group',
        address: '404 Traveller Street',
        city: 'Hickory Creek',
        state: 'Texas',
        zip: '75065',
        email: 'clark.kennethp@gmail.com',
        phone: '(405) 487-7581'
    },
    AGHRO132: {
        name: 'STONEWATER GROUP INC',
        address: '4639 CORONA DR',
        city: 'CORPUS CHRISTI',
        state: 'Texas',
        zip: '78411',
        email: 'msharp@stonewaterwealth.com',
        phone: '(361) 482-0699'
    },
    AGHRO133: {
        name: 'north texas auto insurance agency, inc DBA lakewood Insurance agency',
        address: '6510 abrams rd 562',
        city: 'dallas',
        state: 'Texas',
        zip: '75231',
        email: 'lakewoodinsurance@yahoo.com',
        phone: '(214) 828-0141'
    },
    AGHRO134: {
        name: 'Jeter Insurance Insurance',
        address: '4135 Wistar Rd',
        city: 'Henrico',
        state: 'Virginia',
        zip: '23228',
        email: 'dennis.jeter@jicva.com',
        phone: '(804) 299-0755'
    },
    AGHRO135: {
        name: 'VanderMolen Insurance Agency LLC DBA Multiple Insurance Solutions of TX',
        address: '3606 S Tyler St',
        city: 'Dallas',
        state: 'Texas',
        zip: '75224',
        email: 'brian@misoftex.com',
        phone: '(972) 572-0777'
    },
    AGHRO136: {
        name: 'Julian Salter Company`',
        address: '3230 Central Mall Dr.',
        city: 'Port Arthur',
        state: 'Texas',
        zip: '77642',
        email: 'keri@juliansalter.com',
        phone: '(409) 729-3298'
    },
    AGHRO137: {
        name: "Bill Quickel's Insurance Plus Agencies Inc",
        address: '114 Court Street,',
        city: 'Pomeroy',
        state: 'Ohio',
        zip: '45769',
        email: 'insplus@insurance-plus.com',
        phone: '(740) 992-6677'
    },
    AGHRO138: {
        name: 'Jason Spencer Insurance Agency',
        address: '3021 Main St',
        city: 'OAKLEY',
        state: 'California',
        zip: '94561',
        email: 'JSpencer@SpencerInsuranceGroup.Net',
        phone: '(925) 705-8788'
    },
    AGHRO139: {
        name: 'Merritt Insurance Services LLC',
        address: '15370 Watson Drive',
        city: 'Kemp',
        state: 'Texas',
        zip: '75143',
        email: 'beckie@merrittins.com',
        phone: '(214) 290-8035'
    },
    AGHRO140: {
        name: 'American Best Insurance',
        address: '330 De Haes Avenue',
        city: 'Dallas',
        state: 'Texas',
        zip: '75224',
        email: 'asonyel@gmail.com',
        phone: '(469) 671-6295'
    },
    AGHRO141: {
        name: 'Dehuc Insurance Services',
        address: '10015 Garden Grove Blvd',
        city: 'Garden Grove',
        state: 'California',
        zip: '92844',
        email: 'jackie@dehuc.com',
        phone: '(714) 716-1963'
    },
    AGHRO142: {
        name: 'TEXMEX INSURANCE',
        address: '5727 BELLAIRE BLVD',
        city: 'HOUSTON',
        state: 'Texas',
        zip: '77081',
        email: 'MSYED@TMAXINSURANCE.COM',
        phone: '(281) 846-6053'
    },
    AGHRO143: {
        name: 'DK Insurance Agency, LLC',
        address: '6901 N Lamar Blvd 134',
        city: 'Austin',
        state: 'Texas',
        zip: '78752',
        email: 'kim9702688@gmail.com',
        phone: '(512) 761-4222'
    },
    AGHRO144: {
        name: 'All Quote Insurance',
        address: '1956 34th St',
        city: 'Lubbock',
        state: 'Texas',
        zip: '79411',
        email: 'allquote@allquoteins.com',
        phone: '(806) 712-3060'
    },
    AGHRO145: {
        name: 'ALOHA INSURANCE AGENCY LLC',
        address: '800 BONAVENTURE WAY',
        city: 'SUGAR LAND',
        state: 'Texas',
        zip: '77479',
        email: 'INFO@ALOHA-INSURANCE.COM',
        phone: '(281) 748-9015'
    },
    AGHRO146: {
        name: 'Capers Insurance Agency',
        address: '3238 Southern Dr.',
        city: 'Garland',
        state: 'Texas',
        zip: '75043',
        email: 'lisa@capersinsuranceagency.com',
        phone: '(972) 220-8024'
    },
    AGHRO147: {
        name: 'ART OF INSURANCE',
        address: '3233 N ARLINGTON HTS RD STE 206',
        city: 'ARLINGTON HTS',
        state: 'Illinois',
        zip: '60004',
        email: 'ARTOFINS@GMAIL.COM',
        phone: '(847) 483-9999'
    },
    AGHRO148: {
        name: 'Kelley Financial',
        address: '16519 Pentonshire Ln',
        city: 'Houston',
        state: 'Texas',
        zip: '77090',
        email: 'james@kelleyfinancial.net',
        phone: '(832) 376-5253'
    },
    AGHRO149: {
        name: 'King of the Court & Associates',
        address: '8460 Watson Rd Ste 230',
        city: 'St. Louis',
        state: 'Missouri',
        zip: '63119',
        email: 'Pkingmsu@yahoo.com',
        phone: '(314) 393-1973'
    },
    AGHRO150: {
        name: 'TEC Insurance Llc',
        address: '531 Benham St',
        city: 'Bonne Terre',
        state: 'Missouri',
        zip: '63628',
        email: 'tecinsurance@gmail.com',
        phone: '(573) 760-7007'
    },
    AGHRO151: {
        name: 'Insurance Depot of Sarasota',
        address: '1183 Brittmoore, #200',
        city: 'Houston',
        state: 'Texas',
        zip: '77043',
        email: 'insurewithmarsha@gmail.com',
        phone: '(941) 773-1895'
    },
    AGHRO152: {
        name: 'JPL Insurance Services',
        address: '3033 5th AVENUE',
        city: 'SAN DIEGO',
        state: 'California',
        zip: '92103',
        email: 'jp@jplinsurance.com',
        phone: '(619) 220-8013'
    },
    AGHRO153: {
        name: 'ROCK INSURANCE AGENCY',
        address: '10700 RICHMOND AVE',
        city: 'HOUSTON',
        state: 'Texas',
        zip: '77042',
        email: 'rockfinancial@yahoo.com',
        phone: '(713) 974-4472'
    },
    AGHRO154: {
        name: 'Prestige Insurance Group Inc',
        address: '12750 SW 128 ST',
        city: 'Miami',
        state: 'Florida',
        zip: '33186',
        email: 'ralph@prestigeinsurancegrp.com',
        phone: '(305) 969-8776'
    },
    AGHRO155: {
        name: 'CALRISK',
        address: '713 W DUARTE RD.',
        city: 'ARCADIA',
        state: 'California',
        zip: '91007',
        email: 'MAIL@CALRISKCENTER.COM',
        phone: '(877) 239-8103'
    },
    AGHRO156: {
        name: 'DIVERSIFIED INSURANCE BROKERAGE SERVICES',
        address: '1305 S KEY AVE',
        city: 'LAMPASAS',
        state: 'Texas',
        zip: '76550',
        email: 'GERALD@EDIBS.NET',
        phone: '(512) 556-3427'
    },
    AGHRO157: {
        name: 'RSS Star enterprise inc DBA Agents United Network of America',
        address: '4009 old Denton rd',
        city: 'Carrollton',
        state: 'Texas',
        zip: '42007',
        email: 'rssstarinc@gmail.com',
        phone: '(469) 722-1737'
    },
    AGHRO158: {
        name: 'Loyalty Insurance & Financial Services, LLC',
        address: '810 W. Ferguson Ave',
        city: 'Pharr',
        state: 'Texas',
        zip: '78577',
        email: 'mloya@loyaltyins-tx.com',
        phone: '(956) 322-8966'
    },
    AGHRO159: {
        name: 'BPT Insurance Services, Inc.',
        address: '251 New Karner Road',
        city: 'Albany',
        state: 'New York',
        zip: '12205',
        email: 'jim@bptinsuranceservices.com',
        phone: '(518) 993-1018'
    },
    AGHRO160: {
        name: 'Lazar Insurance',
        address: '222 W 161st Street',
        city: 'Westfield',
        state: 'Indiana',
        zip: '46074',
        email: 'Jeff@Lazarinsurance.com',
        phone: '(317) 867-1303'
    },
    AGHRO161: {
        name: 'Laskowski Insurance Agency',
        address: '19365 F M 2252, STE #8',
        city: 'Garden Ridge',
        state: 'Texas',
        zip: '78266',
        email: 'emil@Laskowskiins.com',
        phone: '(210) 325-4152'
    },
    AGHRO162: {
        name: 'French Insurance Agency LLC',
        address: '1018 S State Rd 3',
        city: 'Rushville',
        state: 'Indiana',
        zip: '46173',
        email: 'ben@frenchinsuranceagency.com',
        phone: '(765) 932-5913'
    },
    AGHRO163: {
        name: 'Aleman Insurance Services',
        address: '1701 Trenton Rd',
        city: 'McAllen',
        state: 'Texas',
        zip: '78504',
        email: 'joe@aleman.net',
        phone: '(956) 631-8800'
    },
    AGHRO164: {
        name: 'Abbco Insurance Agency',
        address: '2300 Valley View Lane. Suite #405',
        city: 'Irving',
        state: 'Texas',
        zip: '75062',
        email: 'admin@abbcoinsurance.com',
        phone: '(972) 775-7738'
    },
    AGHRO165: {
        name: 'SPR Insurance Group',
        address: '18305 Biscayne Blvd',
        city: 'Aventura',
        state: 'Florida',
        zip: '33160',
        email: 'joseph.hanono@sprinsgroup.com',
        phone: '(305) 397-0500'
    },
    AGHRO166: {
        name: 'Ipex Insurance Services',
        address: '6700 Falbrook Ave',
        city: 'West Hills',
        state: 'California',
        zip: '91307',
        email: 'ron@ipexins.com',
        phone: '(818) 208-3008'
    },
    AGHRO167: {
        name: 'S F HUMA LLC DBA ANNEX INSURANCE',
        address: '8700 COMMERCE PARK DR STE 104A',
        city: 'HOUSTON',
        state: 'Texas',
        zip: '77036',
        email: 'ANNEXINSURANCE@GMAIL.COM',
        phone: '(832) 966-6676'
    },
    AGHRO168: {
        name: 'INSFINITY',
        address: '21902 STATE HIGHWAY 249',
        city: 'HOUSTON',
        state: 'Texas',
        zip: '77070',
        email: 'rob@insfinity.com',
        phone: '(713) 429-0202'
    },
    AGHRO169: {
        name: 'Kevin E Parker Agency',
        address: '6492 Taylor Rd SW',
        city: 'Reynoldsburg',
        state: 'Ohio',
        zip: '43068',
        email: 'kevin@kevep.com',
        phone: '(614) 367-1054'
    },
    AGHRO170: {
        name: 'Sagi Insurance Taxes & More',
        address: '5916 S Cage Blvd Ste B',
        city: 'Pharr',
        state: 'Texas',
        zip: '78577',
        email: 'gonzalezaracely1@hotmail.com',
        phone: '(956) 884-0030'
    },
    AGHRO171: {
        name: 'north texas auto insurance agency, inc DBA lakewood Insurance agency',
        address: '6510 abrams rd 562',
        city: 'dallas',
        state: 'Texas',
        zip: '75231',
        email: 'lakewoodinsurance@gmail.com',
        phone: '(214) 828-0141'
    },
    AGHRO172: {
        name: 'Jason Spencer Insurance Agency',
        address: '3021 Main St',
        city: 'OAKLEY',
        state: 'California',
        zip: '94561',
        email: 'JSpencer@SpencerInsuranceGroup.Net',
        phone: '(925) 705-8788'
    },
    AGHRO173: {
        name: 'D2 Enterprises, LLC dba Brandt Davis Insurance Agency',
        address: '2821 S. Hurstbourne Pkwy. #5',
        city: 'Louisville',
        state: 'Kentucky',
        zip: '40220',
        email: 'brandt@brandtdavisagency.com',
        phone: '(502) 499-6567'
    },
    AGHRO174: {
        name: "YOUNG'S INSURANCE AGENCY",
        address: '6750  West Loop South',
        city: 'Bellaire',
        state: 'Texas',
        zip: '77401',
        email: 'ery@lyins.com',
        phone: '(713) 383-4250'
    },
    AGHRO175: {
        name: 'Preferred Alliance Group',
        address: '5606 Franz Rd.',
        city: 'Katy',
        state: 'Texas',
        zip: '77493',
        email: 'Tom@preferredalliancegroup.com',
        phone: '(281) 391-2332'
    },
    AGHRO176: {
        name: 'Ron J Prestamer Agency Inc.',
        address: '7207 Indianapolis Blvd Ste 1',
        city: 'Hammond',
        state: 'Indiana',
        zip: '46324',
        email: 'Ronjprestamer@gmail.com',
        phone: '(219) 844-0103'
    },
    AGHRO177: {
        name: 'Insurance of DFW',
        address: '1056 E Beltline Rd',
        city: 'Richardson',
        state: 'Texas',
        zip: '75081',
        email: 'tx@insuranceofdfw.com',
        phone: '(214) 432-4155'
    },
    AGHRO178: {
        name: 'ANC INSURANCE AGENCY,LLC',
        address: '10103 FONDREN RD',
        city: 'HOUSTON',
        state: 'Texas',
        zip: '77096',
        email: 'ancga@yahoo.com',
        phone: '(713) 773-1900'
    },
    AGHRO179: {
        name: 'NuFinance LLC',
        address: 'P O Box 301102',
        city: 'Houston',
        state: 'Texas',
        zip: '',
        email: 'nufinancellc@gmail.com',
        phone: '(281) 513-5340'
    },
    AGHRO180: {
        name: 'IPROMICE',
        address: '19602 Little Pine Ln',
        city: 'Katy',
        state: 'Texas',
        zip: '77449',
        email: 'ashlouza@ipromiseins.com',
        phone: '(832) 706-8029'
    },
    AGHRO181: {
        name: 'J&S Marketing Resources',
        address: '25000 EUCLID AVENUE',
        city: 'EUCLID',
        state: 'Ohio',
        zip: '44117',
        email: 'jandsmarketingresources@gmail.com',
        phone: '(440) 497-0454'
    },
    AGHRO182: {
        name: 'platform insurance sevices',
        address: '235 s.san pedro st.',
        city: 'los angeles',
        state: 'California',
        zip: '90012',
        email: 'bobiskander@gmail.com',
        phone: '(310) 926-8180'
    },
    AGHRO183: {
        name: 'Cox Family Solutions, PLLC',
        address: '15331 W Bell Rd',
        city: 'Surprise',
        state: 'Arizona',
        zip: '85374',
        email: 'maritza@coxfamilysolutions.com',
        phone: '(602) 539-2138'
    },
    AGHRO184: {
        name: 'IRM Insurance',
        address: '11002 Kingston pike, Suite 103',
        city: 'Knoxville',
        state: 'Tennessee',
        zip: '37934',
        email: 'insurance@tninsurancestore.com',
        phone: '(865) 579-0500'
    },
    AGHRO185: {
        name: 'Louis Barnett & Associates, Inc. dba Barnett & Associates Insurance and Financial Services',
        address: '2601 Airport Dr. Ste 100',
        city: 'Torrance',
        state: 'California',
        zip: '90505',
        email: 'louisb@barnettassoc.com',
        phone: '(310) 539-8466'
    },
    AGHRO186: {
        name: 'The Canady Agency',
        address: '1300 Starshadow Drive',
        city: 'Richardson',
        state: 'Texas',
        zip: '75081',
        email: 'thecanadyagency@gmail.com',
        phone: '(214) 210-9792'
    },
    AGHRO187: {
        name: 'Texans Insurance & Financial Group Inc',
        address: '101 Southwestern Blvd Ste 230',
        city: 'Sugar Land',
        state: 'Texas',
        zip: '77478',
        email: 'basil@texansinsure.com',
        phone: '(281) 277-7800'
    },
    AGHRO188: {
        name: 'MyShield LLC, dba Texas Shield',
        address: '391 E Las Colinas Blvd, Ste 130',
        city: 'Irving',
        state: 'Texas',
        zip: '75039',
        email: 'danedespain@texasshield.org',
        phone: '(214) 438-4830'
    },
    AGHRO189: {
        name: 'McDermett Insurance Agency',
        address: '10374 Jennifer Cir',
        city: 'Forney',
        state: 'Texas',
        zip: '75126',
        email: 'lee@mcdins.com',
        phone: '(972) 564-6866'
    },
    AGHRO190: {
        name: 'INSKING INTERNATIONAL LIMITED',
        address: '4405 Vista Pl.',
        city: 'La Canada Flintridge',
        state: 'California',
        zip: '91011',
        email: 'info@insking.us',
        phone: '(213) 800-1099'
    },
    AGHRO191: {
        name: 'Mendoza Insurance Store, Inc.',
        address: '5440 Everhart Rd #9',
        city: 'Corpus Christi',
        state: 'Texas',
        zip: '78411',
        email: 'theinsurancestorecc@gmail.com',
        phone: '(361) 992-6477'
    },
    AGHRO192: {
        name: 'Rich-Co Capital Insurance Agency LLC',
        address: '1813 Townhouse Unit B',
        city: 'Monroe',
        state: 'Louisiana',
        zip: '71201',
        email: 'Richcocapitalinsurance@gmail.com',
        phone: '(318) 816-0866'
    },
    AGHRO193: {
        name: 'ARMour Insurance Group, LLC',
        address: '5460 Babcock Rd. Suite 120 #163',
        city: 'San Antonio',
        state: 'Texas',
        zip: '78240',
        email: 'andrewm@armourinsurancetx.com',
        phone: '(210) 544-9432'
    },
    AGHRO194: {
        name: 'RWR Goup Inc',
        address: '702 W Pitt St',
        city: 'Bedford',
        state: 'Pennsylvania',
        zip: '15522',
        email: 'troadman@rwrinsurance.com',
        phone: '(814) 623-1111'
    },
    AGHRO195: {
        name: 'Gannon Insurance Inc',
        address: '2040 County Line Rd',
        city: 'Huntingdon Valley',
        state: 'Pennsylvania',
        zip: '19006',
        email: 'STEVE@TAYLORINSURANCEINC.COM',
        phone: '(215) 396-9000'
    },
    AGHRO196: {
        name: 'TAYLOR INSURANCE INC.',
        address: '10804 US 23 SOUTH',
        city: 'BETSY LAYNE',
        state: 'Kentucky',
        zip: '41605',
        email: 'rightwayinsgroup@gmail.com',
        phone: '(606) 637-3087'
    },
    AGHRO197: {
        name: 'david galmor insurance agency',
        address: '2626 calder ste 103',
        city: 'beaumont',
        state: 'Texas',
        zip: '77702',
        email: 'galdav@hotmail.com',
        phone: '(409) 832-3636'
    },
    AGHRO198: {
        name: '3R Insurance Agency',
        address: '3994 Youngfield St',
        city: 'Wheat Ridge',
        state: 'Colorado',
        zip: '80033',
        email: 'andy@3rinsurance.com',
        phone: '(303) 421-5123'
    },
    AGHRO199: {
        name: 'Hubbard Insurance Agency, Inc.',
        address: '4574 FM 1960 RD E',
        city: 'HUMBLE',
        state: 'Texas',
        zip: '77346',
        email: 'jordan@hubbardagency.com',
        phone: '(281) 852-6000'
    },
    AGHRO200: {
        name: 'ARIAN INSURANCE AGENCY',
        address: '4100 SPRING VALLEY RD STE 260',
        city: 'DALLAS',
        state: 'Texas',
        zip: '75244',
        email: 'valenzuela.ins@gmail.com',
        phone: '(469) 906-6050'
    },
    AGHRO201: {
        name: 'John Walker',
        address: '717 Avalon Drive',
        city: 'Heath',
        state: 'Texas',
        zip: '75032',
        email: 'john.j.walker@hotmail.com',
        phone: '(972) 978-8598'
    },
    AGHRO202: {
        name: 'COOPER INSURES',
        address: '115 N HWY 77',
        city: 'WAXAHACHIE',
        state: 'Texas',
        zip: '75165',
        email: 'VICTOR@COOPERINSURES.COM',
        phone: '(972) 938-9700'
    },
    AGHRO203: {
        name: 'TGI GROUP LLC DBA: TEXAS GUARDIANS INSURANCE',
        address: '9001 AIRPORT BLVD SUITE 706',
        city: 'HOUSTON',
        state: 'Texas',
        zip: '77061',
        email: 'INFO@TGIGROUP-US.COM',
        phone: '(713) 766-6871'
    },
    AGHRO204: {
        name: 'Parson Insurance Agency',
        address: '4779 Higbee Ave NW',
        city: 'Canton',
        state: 'Ohio',
        zip: '44718',
        email: 'John.parson@parsoninsurance.com',
        phone: '(330) 956-4200'
    },
    AGHRO205: {
        name: 'T.K.A. B.B. & Insurance',
        address: '20180 Park Row Dr',
        city: 'Katy',
        state: 'Texas',
        zip: '77491',
        email: 'tkainsurance@gmail.com',
        phone: '(832) 334-9868'
    },
    AGHRO206: {
        name: 'Boss Insurance Agency Inc',
        address: '808 Russell Palmer rd #260',
        city: 'Kingwood',
        state: 'Texas',
        zip: '77339',
        email: 'Jim@4txinsurance.com',
        phone: '(832) 955-7288'
    },
    AGHRO207: {
        name: 'Jones Insurance Agency',
        address: '21134 Birchbank Lane',
        city: 'Katy',
        state: 'Texas',
        zip: '77449',
        email: 'wfjones@jonesinsureagency.com',
        phone: '(281) 793-6278'
    },
    AGHRO208: {
        name: 'CROSBY INSURANCE & BONDING AGENCY',
        address: '11206 LAKE JUNE RD.',
        city: 'BALCH SPRINGS',
        state: 'Texas',
        zip: '75180',
        email: 'crosbyinsurance@sbcglobal.net',
        phone: '(214) 553-0675'
    },
    AGHRO209: {
        name: 'THE SKEEN AGENCY PC',
        address: '102 OAK CREEK LN',
        city: 'LEAGUE CITY',
        state: 'Texas',
        zip: '77573',
        email: 'skeen@theskeenagency.com',
        phone: '(713) 947-1965'
    },
    AGHRO210: {
        name: 'T Gardiner Insurance',
        address: '563a Apache ln',
        city: 'Abilene',
        state: 'Texas',
        zip: '79601',
        email: 't@tgardins.com',
        phone: '(325) 660-8900'
    },
    AGHRO211: {
        name: 'Akhans Enterprise LLc',
        address: '8549 Beechnut st#B',
        city: 'Houston',
        state: 'Texas',
        zip: '77036',
        email: 'akinsurance@yahoo.com',
        phone: '(713) 624-0913'
    },
    AGHRO212: {
        name: 'JJ Insurance & Multi-Services',
        address: '11078 Veterans Memorial Dr # 220',
        city: 'Houston',
        state: 'Texas',
        zip: '77067',
        email: 'jjinsurancetx@gmail.com',
        phone: '(832) 230-3139'
    },
    AGHRO213: {
        name: 'Teresa Brewer & Associates Insurance Solutions',
        address: '363 N Sam Houston Parkway E Suite 1100',
        city: 'Houston',
        state: 'Texas',
        zip: '77060',
        email: 'teresa@teresamymedquote.com',
        phone: '(281) 582-8888'
    },
    AGHRO214: {
        name: 'Abraham & associates PLLC',
        address: '5450 Northwest Central Dr Ste 120',
        city: 'Houston',
        state: 'Texas',
        zip: '77092',
        email: 'abraham@abrahamandassociates.com',
        phone: '(713) 682-2192'
    },
    AGHRO215: {
        name: 'Phong Le',
        address: '800 E Campbell Rd',
        city: 'Richardson',
        state: 'Texas',
        zip: '75081',
        email: '4allinsurances@gmail.com',
        phone: '(469) 427-7668'
    },
    AGHRO216: {
        name: 'SKYMERIDIAN INVESTMENT',
        address: '11500 PETUNIA DR',
        city: 'KELLER',
        state: 'Texas',
        zip: '76244',
        email: 'YOMIFASH1986@GMAIL.COM',
        phone: '(682) 319-9762'
    },
    AGHRO217: {
        name: 'Gopher State Agency LLC',
        address: '1633 County Highway 10 #16',
        city: 'Spring Lake Park',
        state: 'Minnesota',
        zip: '55432',
        email: 'mark@gopherstateagency.com',
        phone: '(612) 991-5139'
    },
    AGHRO218: {
        name: 'BONHAM INSURANCE AGENCY',
        address: '424 WASHINGTON ST',
        city: 'Chillicothe',
        state: 'Missouri',
        zip: '64601',
        email: 'bonhamagency@greenhills.net',
        phone: '(660) 240-9070'
    },
    AGHRO219: {
        name: 'Dyer Agency Inc.',
        address: '411 Lincoln Ave.',
        city: 'Wamego',
        state: 'Kansas',
        zip: '66547',
        email: 'agent.dyeragency@gmail.com',
        phone: '(785) 320-5216'
    },
    AGHRO220: {
        name: 'AS Insurance Agency LLC',
        address: '5610 Derry St  suite 19',
        city: 'Harrisburg',
        state: 'Pennsylvania',
        zip: '17111',
        email: 'tacharya@asureagency.com',
        phone: '(603) 627-8000'
    },
    AGHRO221: {
        name: 'Coady & Lewis Associates, Inc.',
        address: '1241 Butler Rd',
        city: 'League City',
        state: 'Texas',
        zip: '77573',
        email: 'lewisj7@coadyandlewis.com',
        phone: '(281) 286-6060'
    },
    AGHRO222: {
        name: 'Reliant Brokers',
        address: '169 Atchinson Rd',
        city: 'Olean',
        state: 'Missouri',
        zip: '65064',
        email: 'addadeal@hotmail.com',
        phone: '(314) 580-3455'
    },
    AGHRO223: {
        name: 'Trek Insurance Solutions',
        address: '711 N 108th CT',
        city: 'Omaha',
        state: 'Nebraska',
        zip: '68154',
        email: 'ben@trekis.net',
        phone: '(888) 960-0442'
    },
    AGHRO224: {
        name: 'Lad C. Trojacek Agency',
        address: '501 Summit',
        city: 'Schulenburg',
        state: 'Texas',
        zip: '78956',
        email: 'ladtrojacek@gmail.com',
        phone: '(979) 743-2120'
    },
    AGHRO225: {
        name: 'Precise Insurance Group',
        address: '3750 McCart Ave',
        city: 'Fort Worth',
        state: 'Texas',
        zip: '76110',
        email: 'robert@preciseins.com',
        phone: '(817) 350-6265'
    },
    AGHRO226: {
        name: 'Concrete Insurance',
        address: '6405 Belair Rd',
        city: 'Baltimore',
        state: 'Maryland',
        zip: '21206',
        email: 'shawn@concreteinsuranceagency.com',
        phone: '(410) 433-0313'
    },
    AGHRO227: {
        name: 'JORVAL INC DBA GLOBALGREEN INSURANCE AGENCY',
        address: '6542 JOAN DR',
        city: 'BELVIDERE',
        state: 'Illinois',
        zip: '61008',
        email: 'JVALDEZ@GGIAUSA.COM',
        phone: '(779) 552-8421'
    },
    AGHRO228: {
        name: 'DIAMONDBACK FINANCIAL GROUP',
        address: '3957 E SPEEDWAY BLVD. SUITE 208',
        city: 'TUCSON',
        state: 'Arizona',
        zip: '85712',
        email: 'DANIEL@DBACKFG.COM',
        phone: '(520) 792-2344'
    },
    AGHRO229: {
        name: 'ESSEX INSURANCE BROKERS LLC',
        address: '2340 S RIVER RD',
        city: 'DES PLAINES',
        state: 'Illinois',
        zip: '60018',
        email: 'MARKLABNO@ESSEXINSUR.COM',
        phone: '(847) 954-2222'
    },
    AGHRO230: {
        name: 'Argus Insurance',
        address: '595 Spring Creek Rd.',
        city: 'Providence',
        state: 'Utah',
        zip: '84332',
        email: 'matthew@argusinsurancellc.com',
        phone: '(702) 277-8999'
    },
    AGHRO231: {
        name: 'Royal Crown Insurance Agency LLC',
        address: '3513 Kingston Dr',
        city: 'Friendswood',
        state: 'Texas',
        zip: '77546',
        email: 'mheldawy@gmail.com',
        phone: '(832) 339-2937'
    },
    AGHRO232: {
        name: 'AMERICANA INSURANCE GROUP',
        address: '808B N MEMORIAL HWY, SUITE 102B',
        city: 'NEDERLAND',
        state: 'Texas',
        zip: '77627',
        email: 'americanainsurancegroup@gmail.com',
        phone: '(409) 344-9646'
    },
    AGHRO233: {
        name: 'The Burgess Agency LLC',
        address: '115 Broad Street',
        city: 'Sumter',
        state: 'South Carolina',
        zip: '29150',
        email: 'mburgess@rbagency.net',
        phone: '(803) 667-4600'
    },
    AGHRO234: {
        name: 'Jamieson Insurance & Financial Services',
        address: '1534 Columbine Drive',
        city: 'Schaumburg',
        state: 'Illinois',
        zip: '60173',
        email: 'scot@jamiesonservices.com',
        phone: '(847) 838-3797'
    },
    AGHRO235: {
        name: 'Precise Insurance Group',
        address: '3750 McCart Ave',
        city: 'Fort Worth',
        state: 'Texas',
        zip: '76110',
        email: 'robert@preciseins.com',
        phone: '(817) 350-6265'
    },
    AGHRO236: {
        name: 'MetroOKC Insurance',
        address: '11901 N. MacArthur, Suite F2',
        city: 'Oklahoma City',
        state: 'Oklahoma',
        zip: '73162',
        email: 'michael.sohn@metrookcins.com',
        phone: '(405) 603-2176'
    },
    AGHRO237: {
        name: 'DP INSURANCE & TAX',
        address: '4522 HIGHWAY 6 N.',
        city: 'HOUSTON',
        state: 'Texas',
        zip: '77084',
        email: 'DP_INSURANCE@YAHOO.COM',
        phone: '(281) 575-1050'
    },
    AGHRO238: {
        name: 'Concrete Insurance',
        address: '6405 Belair Rd',
        city: 'Baltimore',
        state: 'Maryland',
        zip: '21206',
        email: 'shawn@concreteinsuranceagency.com',
        phone: '(410) 433-0313'
    },
    AGHRO239: {
        name: 'JORVAL INC DBA GLOBALGREEN INSURANCE AGENCY',
        address: '6542 JOAN DR',
        city: 'BELVIDERE',
        state: 'Illinois',
        zip: '61008',
        email: 'JVALDEZ@GGIAUSA.COM',
        phone: '(779) 552-8421'
    },
    AGHRO240: {
        name: 'DIAMONDBACK FINANCIAL GROUP',
        address: '3957 E SPEEDWAY BLVD. SUITE 208',
        city: 'TUCSON',
        state: 'Arizona',
        zip: '85712',
        email: 'DANIEL@DBACKFG.COM',
        phone: '(520) 792-2344'
    },
    AGHRO241: {
        name: 'Steven Monroe',
        address: '205 Meadowview Trail',
        city: 'Springtown',
        state: 'Texas',
        zip: '76082',
        email: 'camperhusband@gmail.com',
        phone: '(817) 754-0341'
    },
    AGHRO242: {
        name: 'Michael Davis Agency, LLC',
        address: '204 West Main Street',
        city: 'Hortonville',
        state: 'Wisconsin',
        zip: '54944',
        email: 'michaeldavis@michaeldavisinsuranceagency.com',
        phone: '(920) 877-7003'
    },
    AGHRO243: {
        name: 'JenG Insurance and Financial Services LLC',
        address: '1 West Baltimore Ave Suite 201',
        city: 'Lansdowne',
        state: 'Pennsylvania',
        zip: '19050',
        email: 'jifs@jenginsuranceandfinancialservices.com',
        phone: '(610) 671-6734'
    },
    AGHRO244: {
        name: 'Cannizzaro Insurance Agency',
        address: '855 E Golf Rd Suite 1142',
        city: 'Arlington Heights',
        state: 'Illinois',
        zip: '60005',
        email: 'sam@cannizzaroagency.com',
        phone: '(847) 621-2101'
    },
    AGHRO245: {
        name: 'Bay Area Benefit Consultants',
        address: '10232 Millport Drive',
        city: 'Tampa',
        state: 'Florida',
        zip: '33626',
        email: 'greg@babc-ins.com',
        phone: '813-434-1902'
    },
    AGHRO246: {
        name: 'EMPIRE INSURANCE SERVICES INC',
        address: '1930 east sunrise blvd',
        city: 'Fort Lauderdale',
        state: 'Florida',
        zip: '33304',
        email: 'BORIS@EMPIREINS.CO',
        phone: '(954) 645-7102'
    },
    AGHRO247: {
        name: 'Sergios Insurance Agency',
        address: '5682 Rainbow Creek Ct',
        city: 'Las Vegas',
        state: 'Nevada',
        zip: '89122',
        email: 'sergio@sergiosinsurance.com',
        phone: '(725) 726-7001'
    },
    AGHRO248: {
        name: 'Frank & Sons Insurance, LLC',
        address: '13525 Grouserun Ln',
        city: 'Bristow',
        state: 'Virginia',
        zip: '20136',
        email: 'Frank@franknsonsinsurance.com',
        phone: '(703) 753-2709'
    },
    AGHRO249: {
        name: 'Almi Group',
        address: 'P.O. Box 942',
        city: 'Mokena',
        state: 'Illinois',
        zip: '60448',
        email: 'lexi@thealmigroup.com',
        phone: '(708) 846-1361'
    },
    AGHRO250: {
        name: 'Bell Insurance Agency, Inc.',
        address: '125 East Bodman St',
        city: 'Bement',
        state: 'Illinois',
        zip: '61813',
        email: 'whbell@mchsi.com',
        phone: '(217) 678-2881'
    },
    AGHRO251: {
        name: 'BizLife Consulting and Insurance LLC',
        address: '642 Lookout Lakes Dr',
        city: 'Jacksonville',
        state: 'Florida',
        zip: '32220',
        email: 'agent.charles904@gmail.com',
        phone: '(904) 383-2878'
    },
    AGHRO252: {
        name: 'KAY REI PROPERTIES',
        address: '4223 Bearden Place Ln',
        city: 'Houston',
        state: 'Texas',
        zip: '77082',
        email: 'nu-insurance@outlook.com',
        phone: '(281) 690-8587'
    },
    AGHRO253: {
        name: 'TEG SERVICES INC',
        address: '18502 GREEN LAND WAY STE A',
        city: 'HOUSTON',
        state: 'Texas',
        zip: '77084',
        email: 'TEGSERVICES@GMAIL.COM',
        phone: '(281) 960-4000'
    },
    AGHRO254: {
        name: 'Jabez Insurance Agency Inc',
        address: '8492 Baltimore National Pike',
        city: 'Ellicott City',
        state: 'Marylad',
        zip: '21043',
        email: 'jsim@jabezins.com',
        phone: '(410) 750-7075'
    },
    AGHRO255: {
        name: 'Almeida Florez Inc',
        address: '3900 W 38th Avenue',
        city: 'Denver',
        state: 'Colorado',
        zip: '80212',
        email: 'oscar@afinc.net',
        phone: '(303) 433-8888'
    },
    AGHRO256: {
        name: 'Brock Insurance Group, LLC',
        address: '820 S. Friendswood Dr',
        city: 'Friendswood',
        state: 'Texas',
        zip: '77546',
        email: 'mark@brockinsurancegrp.com',
        phone: '(281) 482-4244'
    },
    AGHRO257: {
        name: 'StraightEdge Insurance Agency',
        address: '503 Woodland Park',
        city: 'Georgetown',
        state: 'Texas',
        zip: '78633',
        email: 'justin@straightedgeinsurance.com',
        phone: '(512) 280-3500'
    },
    AGHRO258: {
        name: 'HTX AGENCY LLC',
        address: '24624 North Interstate 45 Suite 200',
        city: 'Spring',
        state: 'Texas',
        zip: '77386',
        email: 'aahtxagency@gmail.com',
        phone: '(832) 933-9852'
    },
    AGHRO259: {
        name: 'Compass Insurance & Financial Services LLC',
        address: '3707 Dunsinane Drive',
        city: 'Silver Spring',
        state: 'Maryland',
        zip: '20906',
        email: 'jeff@compassifs.com',
        phone: '(240) 623-1111'
    },
    AGHRO260: {
        name: 'Rightshield Insurance Services, inc.',
        address: '18757 Burbank Blvd Suite 203',
        city: 'Tarzana',
        state: 'California',
        zip: '91356',
        email: 'serj@rightshieldgroup.com',
        phone: '(818) 401-1430'
    },
    AGHRO261: {
        name: 'Jerry Molina Insurance',
        address: '3309 N Ware Rd',
        city: 'McAllen',
        state: 'Texas',
        zip: '78501',
        email: 'jmolina1@jerrymolina.com',
        phone: '(956) 342-9469'
    },
    AGHRO262: {
        name: 'Yanceys Insurance & Business Center',
        address: '2457 N Gettysburg Ave',
        city: 'Dayton',
        state: 'Ohio',
        zip: '45406',
        email: 'Tony@yanceyibc.com',
        phone: '(937) 277-4963'
    },
    AGHRO263: {
        name: 'In the Game Insurance Services',
        address: '2103 Swift Ave',
        city: 'N Kansas City',
        state: 'Missouri',
        zip: '64116',
        email: 'chris@inthegameinsurance.com',
        phone: '(816) 965-2339'
    },
    AGHRO264: {
        name: 'Nextwave Auto Insure LLC',
        address: '3505 sage rd',
        city: 'Houston',
        state: 'Texas',
        zip: '77056',
        email: 'txinsurance@sudomail.com',
        phone: '(832) 202-3612'
    },
    AGHRO265: {
        name: 'HPG Brokerage, LLC',
        address: '17000 El Camino Real',
        city: 'Houston',
        state: 'Texas',
        zip: '77058',
        email: 'damongilmore@hpgbrokerage.com',
        phone: '(832) 915-0915'
    },
    AGHRO266: {
        name: 'Golden Oak Insurance Services Inc',
        address: '2133 E Mores Trail Dr.',
        city: 'Meridian',
        state: 'ID',
        zip: '83642',
        email: 'seth@goldenoakinsurance.com',
        phone: '(208) 471-8800'
    },
    AGHRO267: {
        name: 'Loge Insurance',
        address: '130 W Washington St',
        city: 'Nelsonville',
        state: 'OH',
        zip: '45764',
        email: 'dave@logeinsurance.com',
        phone: '(740) 753-3376'
    },
    AGHRO268: {
        name: 'Volan Insurance Agency, Inc.',
        address: '343 W. Bagley Rd. #208',
        city: 'Berea',
        state: 'OH',
        zip: '44017',
        email: 'richv@volaninsurance.com',
        phone: '(440) 243-7793'
    },
    AGHRO269: {
        name: 'MO SHAFIK INSURANCE SERVICES LLC',
        address: '15987 BRAVERY AVE',
        city: 'CHINO',
        state: 'CA',
        zip: '91708',
        email: 'mosafik@gmail.com',
        phone: '(626) 991-8593'
    },
    AGHRO270: {
        name: 'EnsuranceMax LLC',
        address: '932 Hungerford Dr #23B',
        city: 'Rockville',
        state: 'MD',
        zip: '20850',
        email: 'shaposnyk@gmail.com',
        phone: '(301) 540-8446'
    },
    AGHRO271: {
        name: 'Paradigm Insurance Company LLC',
        address: '2509 W Sylvania Rd',
        city: 'Toledo',
        state: 'Ohio',
        zip: '43613',
        email: 'cheyenneb@paradigmins.com',
        phone: '(419) 930-1354'
    },
    AGHRO272: {
        name: 'Reese Agency',
        address: '6340 Kingsbridge Dr',
        city: 'Oklahoma City',
        state: 'Oklahoma',
        zip: '73162',
        email: 'adam@reeseagency.net',
        phone: '(214) 682-5829'
    },
    AGHRO273: {
        name: 'Champions Agency LLC dba Champions Insurance Group',
        address: '10200 Richmond Ave., Suite 251',
        city: 'Houston',
        state: 'Texas',
        zip: '77042',
        email: 'Ball@championsig.com',
        phone: '(713) 446-9185'
    },
    AGHRO274: {
        name: 'POMPEI INSURANCE AGENCY',
        address: '987 OLD EAGLE SCHOOL ROAD',
        city: 'WAYNE',
        state: 'Pennsylvania',
        zip: '19087',
        email: 'jeffp@pompeiinsurance.com',
        phone: '(610) 992-0214'
    },
    AGHRO275: {
        name: 'PCFG Insurance',
        address: '1429 County Route 38',
        city: 'Parish',
        state: 'New York',
        zip: '13131',
        email: 'liam.obrien@pcfginsurance.com',
        phone: '(877) 717-7234'
    },
    AGHRO276: {
        name: 'Golden Way Insurance Services, Inc',
        address: '10092 Chapman Ave # 2',
        city: 'Garden Grove',
        state: 'California',
        zip: '92840',
        email: 'samy@goldenwayins.com',
        phone: '(888) 440-0411'
    },
    AGHRO277: {
        name: 'Leal Insurance Services, LLC',
        address: '118 Broadway Ste 621',
        city: 'San Antonio',
        state: 'Texas',
        zip: '78205',
        email: 'luis@lealinsurance.com',
        phone: '(210) 277-7544'
    },
    AGHRO278: {
        name: '365 Insurance Agency, LLC',
        address: '1120 Pasadena Blvd',
        city: 'Pasadena',
        state: 'Texas',
        zip: '77506',
        email: 'sergio@get365ins.com',
        phone: '(281) 617-7133'
    },
    AGHRO279: {
        name: 'LBS INSURANCE GROUP INC',
        address: '105 E GONZALES ST #202',
        city: 'SEGUIN',
        state: 'Texas',
        zip: '78155',
        email: 'LBSINSGROUP@GMAIL.COM',
        phone: '(830) 491-9525'
    },
    AGHRO280: {
        name: 'Insurance Partners',
        address: '28579 S H 249',
        city: 'Tomball',
        state: 'Texas',
        zip: '77375',
        email: 'jclink@insurance-partners.com',
        phone: '(281) 351-6565'
    },
    AGHRO281: {
        name: 'Martin & Martin Insurance',
        address: '28144 Sunshine Hollow Dr',
        city: 'Spring',
        state: 'Texas',
        zip: '77386',
        email: 'martinandmartininsurance@gmail.com',
        phone: '(281) 430-4217'
    },
    AGHRO282: {
        name: 'Stackhouse Insurance Group',
        address: '516 S Ohio Ave',
        city: 'Sedalia',
        state: 'Missouri',
        zip: '65301',
        email: 'stackinsgrp@gmail.com',
        phone: '(660) 723-3390'
    },
    AGHRO283: {
        name: 'aNe Insurance',
        address: '1025 Texas Ave',
        city: 'Bridge City',
        state: 'Texas',
        zip: '77611',
        email: 'agent@aneinsurance.com',
        phone: '(409) 735-2010'
    },
    AGHRO284: {
        name: 'Porters Insurance Agency, LLC',
        address: '400 N Broadway, Suite 2',
        city: 'Edmond',
        state: 'Oklahoma',
        zip: '73034',
        email: 'portersinsuranceagency@cox.net',
        phone: '(405) 348-3750'
    },
    AGHRO285: {
        name: 'Insurance For Texas',
        address: '7252 Eden Rd',
        city: 'North Richland Hills',
        state: 'Texas',
        zip: '76182',
        email: 'gbrowninsurance@yahoo.com',
        phone: '(817) 714-3388'
    },
    AGHRO286: {
        name: 'Covered Bridge Insurance Agency, LLC',
        address: '219 Eastgate Plaza',
        city: 'East Alton',
        state: 'Illinois',
        zip: '62024',
        email: 'mclohessy@coveredbridgeagency.com',
        phone: '(618) 900-0528'
    },
    AGHRO287: {
        name: 'Stringer-Chidester-Lowdermilk Insurance Agencies',
        address: '2208 N Main St',
        city: 'Tahoka',
        state: 'Texas',
        zip: '79373',
        email: 'jana@poka.com',
        phone: '(806) 561-5160'
    },
    AGHRO288: {
        name: 'Insurance Medics',
        address: '1797 N University Dr',
        city: 'Plantation',
        state: 'Florida',
        zip: '33322',
        email: 'lou@insurancemedics.com',
        phone: '(866) 396-9140'
    },
    AGHRO289: {
        name: 'david sciolla dba sciolla agency',
        address: '1060 grenoble rd',
        city: 'ivyland',
        state: 'Pennsylvania',
        zip: '18974',
        email: 'davidsciolla@sciollainsurance.com',
        phone: '(215) 322-1963'
    },
    AGHRO290: {
        name: 'Diane R Adams Insurance Agency',
        address: '2134 Main Street',
        city: 'Huntington Beach',
        state: 'California',
        zip: '92648',
        email: 'Diane@Adams-InsuranceAgency.com',
        phone: '(714) 374-3282'
    },
    AGHRO291: {
        name: 'DAVIS INSURANCE SERVICES,LLC',
        address: '249 W CAMP WISDOM',
        city: 'DUNCANVILLE',
        state: 'Texas',
        zip: '75116',
        email: 'milford@davislowins.com',
        phone: '(972) 296-4517'
    },
    AGHRO292: {
        name: 'Zein Insurance Services Inc',
        address: '21800 Oxnard Street, Suite 170',
        city: 'Woodland Hills',
        state: 'California',
        zip: '91367',
        email: 'hisham@zisinsurance.com',
        phone: '(818) 887-8780'
    },
    AGHRO293: {
        name: 'Steve Campbell Insurance Agency Inc',
        address: '13100 Wortham Center Dr',
        city: 'Houston',
        state: 'Texas',
        zip: '77065',
        email: 'steve@stevecampbellinsurance.com',
        phone: '(281) 550-3111'
    },
    AGHRO294: {
        name: 'Baccarella Insurance Services, Inc.',
        address: '3610 Central Ave Ste 200',
        city: 'Riverside',
        state: 'California',
        zip: '92506',
        email: 'john@bacins.com',
        phone: '(877) 687-6987'
    },
    AGHRO295: {
        name: 'Zo Knows Insurance',
        address: '16406 Noblewood Ct',
        city: 'Sugar Land',
        state: 'TX',
        zip: '77498',
        email: 'info@zoknowsinsurance.com',
        phone: '(832) 463-0986'
    },
    AGHRO296: {
        name: 'Rizo Insurance Group',
        address: '1380 Pantheon Way Ste 200',
        city: 'San Antonio',
        state: 'TX',
        zip: '78232',
        email: 'FERNIE@RIZOISMYAGENT.COM',
        phone: '(210) 610-7496'
    },
    AGHRO297: {
        name: 'Canyon State Insurance LLC',
        address: '2473 S Higley Rd 104-401',
        city: 'Gilbert',
        state: 'Arizona',
        zip: '85295',
        email: 'ryan@mycanyonstate.com',
        phone: '(480) 981-5525'
    },
    AGHRO298: {
        name: 'Conexion latina',
        address: '207 w king st',
        city: 'Lancaster',
        state: 'Pennsylvania',
        zip: '17603',
        email: 'clis2011@live.com',
        phone: '(717) 397-0139'
    },
    AGHRO299: {
        name: 'Corner Stone Insurance Agency II',
        address: '308 S Main',
        city: 'South West City',
        state: 'Missouri',
        zip: '64863',
        email: 'linda@thecsiagency.com',
        phone: '(417) 762-3268'
    },
    AGHRO300: {
        name: 'Eagle National Insurance Group, Inc.',
        address: '9521 Riverside Pkwy Suite B-231',
        city: 'Tulsa',
        state: 'Oklahoma',
        zip: '74137',
        email: 'jim.stout@stoutins.org',
        phone: '(918) 410-9890'
    },
    AGHRO301: {
        name: 'GB GROUP INC',
        address: '3932 N Lincoln Av',
        city: 'Chicago',
        state: 'Illinois',
        zip: '60613',
        email: 'german@gb-group.com',
        phone: '(773) 477-7400'
    },
    AGHRO302: {
        name: 'HBW Insurance Group, Inc',
        address: '2 E Rolling Crossroads',
        city: 'Catonsville',
        state: 'Marylad',
        zip: '21228',
        email: 'howard@hbwins.com',
        phone: '(410) 744-4313'
    },
    AGHRO303: {
        name: 'John Aellen and Associates Inc.',
        address: '703 Giddings Ave Suite L-4',
        city: 'Annapolis',
        state: 'Maryland',
        zip: '21401',
        email: 'john@aelleninsurance.com',
        phone: '(410) 280-0500'
    },
    AGHRO304: {
        name: 'King Insurance Agency I',
        address: '2514Cedar Drive',
        city: 'La Marque',
        state: 'Texas',
        zip: '77568',
        email: 'liabilitypro@outlook.com',
        phone: '(281) 910-4517'
    },
    AGHRO305: {
        name: 'Meyer Insurance Services, Inc.',
        address: '9312 Tesson Ferry Rd',
        city: 'St Louis',
        state: 'Missouri',
        zip: '63123',
        email: 'gmeyer@meyerins.com',
        phone: '(314) 631-0900'
    },
    AGHRO306: {
        name: 'MiCasa Insurance Agency',
        address: '4300 N Central Expwy',
        city: 'Dallas',
        state: 'Texas',
        zip: '75206',
        email: 'loni@micasainsurance.com',
        phone: '(214) 257-0336'
    },
    AGHRO307: {
        name: 'Monarch Tax  Services, LLC',
        address: '11200 Westheimer Road',
        city: 'Houston',
        state: 'Texas',
        zip: '77042',
        email: 'monarchserviceshouston@gmail.com',
        phone: '(832) 248-6962'
    },
    AGHRO308: {
        name: 'Nathaniel Bingel',
        address: '11184 Huron St Suite 11',
        city: 'Northglenn',
        state: 'Colorado',
        zip: '80234',
        email: 'nbingel@farmersagent.com',
        phone: '(303) 451-8034'
    },
    AGHRO309: {
        name: 'Nicla Insurance',
        address: '506 N 8th St',
        city: 'Sheboygan',
        state: 'Wisconsin',
        zip: '53081',
        email: 'admin@niclainsurance.com',
        phone: '(920) 946-1465'
    },
    AGHRO310: {
        name: 'OLD HARBOR INSURANCE SERVICES LLC',
        address: '43015 BLACKDEER LOOP',
        city: 'TEMECULA',
        state: 'California',
        zip: '92590',
        email: 'CR@OLDHARBORINS.COM',
        phone: '(951) 297-9740'
    },
    AGHRO311: {
        name: 'PC Woodlands Insurance',
        address: '2306 Hannover Way',
        city: 'Spring',
        state: 'Texas',
        zip: '77388',
        email: 'aapalma00@gmail.com',
        phone: '(713) 589-3105'
    },
    AGHRO312: {
        name: 'People First Insurance Family',
        address: '1611 Gerstner Memorial Dr.',
        city: 'Lake Charles',
        state: 'Louisiana',
        zip: '70601',
        email: 'deitrick@peoplefirstfamily.com',
        phone: '(337) 735-3911'
    },
    AGHRO313: {
        name: 'Prominent Insurance Agency LLC',
        address: '1812 athena llc',
        city: 'Lancaster',
        state: 'Texas',
        zip: '75134',
        email: 'lloyd@prominentinsuranceagencyllc.com',
        phone: '(972) 632-6444'
    },
    AGHRO314: {
        name: 'PROSURANCE INC DBA AMERICAN INSURANCE',
        address: '120 PUEBLO AVE',
        city: 'COLORADO SPRINGS',
        state: 'Colorado',
        zip: '80903',
        email: 'AMERICANSR22INS@GMAIL.COM',
        phone: '(719) 444-8788'
    },
    AGHRO315: {
        name: 'Stallion & Associates',
        address: '4617 HWY 6 N.',
        city: 'Houston',
        state: 'Texas',
        zip: '77084',
        email: 'ricardoperalta@sbcglobal.net',
        phone: '(281) 855-2228'
    },
    AGHRO316: {
        name: 'Sylvia Flores and Amco Insurance LLC',
        address: '702 S Zapata Hwy',
        city: 'Laredo',
        state: 'Texas',
        zip: '78043',
        email: 'sylvia@sylviaflores.com',
        phone: '(956) 712-3333'
    },
    AGHRO317: {
        name: 'TODITO INSURANCE AGENCY',
        address: '215 N Conway Ste B',
        city: 'Mission',
        state: 'Texas',
        zip: '78572',
        email: 'toditoinsurance@gmail.com',
        phone: '(956) 731-8888'
    },
    AGHRO318: {
        name: 'United Auto Insurance Agency LLC',
        address: '2562 FM 1960 Rd E',
        city: 'Houston',
        state: 'Texas',
        zip: '77073',
        email: 'snorman@thenormansgroup.com',
        phone: '(832) 669-2888'
    },
    AGHRO319: {
        name: 'Velasco Insurance Group',
        address: '5696 S. Archer Ave',
        city: 'Chicago',
        state: 'Illinois',
        zip: '60638',
        email: 'Sergio@Vigchicago.com',
        phone: '(708) 980-9266'
    },
    AGHRO320: {
        name: 'YOUNGS INSURANCE AGENCY',
        address: '6750  West Loop South',
        city: 'Bellaire',
        state: 'Texas',
        zip: '77401',
        email: 'ery@lyins.com',
        phone: '(713) 383-4250'
    },
    AGHRO321: {
        name: 'Zamin Insurance Agency',
        address: '105 W Walnut St',
        city: 'Oglesby',
        state: 'Illinois',
        zip: '61348',
        email: 'Mike@ZaminIns.com',
        phone: '(815) 883-3514'
    },
    AGHRO322: {
        name: 'Premier Risk Advisors LLC',
        address: '1715 Indian Wood Circle',
        city: 'Maumee',
        state: 'Ohio',
        zip: '43537',
        email: 'jgrespin@premierra.com',
        phone: '(833) 774-6787'
    },
    AGHRO323: {
        name: 'Realty Group Insurance',
        address: '10765 Lantern Road',
        city: 'Fishers',
        state: 'Indiana',
        zip: '46038',
        email: 'paul@realtygroupinsurance.com',
        phone: '(317) 224-2780'
    },
    AGHRO324: {
        name: 'T&L Financial Group, LLC.',
        address: '6901 Corporate Drive',
        city: 'Houston',
        state: 'Texas',
        zip: '77036',
        email: 'jimmy@oneagencyinsurance.com',
        phone: '(832) 998-2288'
    },
    AGHRO325: {
        name: 'Mueller Insurance Agency Inc.',
        address: '409 Chez Paree Drive',
        city: 'Hazelwood',
        state: 'Missouri',
        zip: '63042',
        email: 'muelins@swbell.net',
        phone: '(314) 831-8200'
    },
    AGHRO326: {
        name: 'FAIRWAY INS AGENCY',
        address: '7001 CORPORATE DR#251',
        city: 'HOUSTON',
        state: 'Texas',
        zip: '77036',
        email: 'JWANG@TWFG.COM',
        phone: '(713) 272-9996'
    },
    AGHRO327: {
        name: 'Anderson Rogers, LLC',
        address: '8403 Shoal Creek Blvd',
        city: 'Austin',
        state: 'Texas',
        zip: '78757',
        email: 'michael@anderson-rogers.com',
        phone: '(512) 298-3200'
    },
    AGHRO328: {
        name: 'Mooney Insurance Agency, LLC',
        address: '306 N Center St',
        city: 'Forney',
        state: 'Texas',
        zip: '75126',
        email: 'Stephanie@1stci.com',
        phone: '(972) 564-3333'
    },
    AGHRO329: {
        name: 'The Vale Group LLC',
        address: '4100 Spring Valley Rd',
        city: 'Dallas',
        state: 'Texas',
        zip: '75244',
        email: 'edgarv@valegroup.net',
        phone: '(469) 458-0024'
    },
    AGHRO330: {
        name: 'Quantum Source Insurance Group',
        address: '470 Streets Run Road',
        city: 'Pittsburgh',
        state: 'Pennsylvania',
        zip: '15236',
        email: 'charles@qsagent.com',
        phone: '(412) 386-8256'
    },
    AGHRO331: {
        name: 'Spiziri Associates, Inc',
        address: '226 West Chestnut St',
        city: 'Lancaster',
        state: 'Pennsylvania',
        zip: '17603',
        email: 'john@spiziri.com',
        phone: '(717) 572-0470'
    },
    AGHRO332: {
        name: 'Spiziri Associates, Inc',
        address: '226 West Chestnut St',
        city: 'Lancaster',
        state: 'Pennsylvania',
        zip: '17603',
        email: 'john@spiziri.com',
        phone: '(717) 572-0470'
    },
    AGHRO333: {
        name: '5 star agency llc',
        address: '15 south main street',
        city: 'marlboro',
        state: 'New Jersey',
        zip: '7746',
        email: 'osovsky@aol.com',
        phone: '(732) 576-6250'
    },
    AGHRO334: {
        name: 'Tristate Insurance Store',
        address: '2824 Cottman ave',
        city: 'Philadelphia',
        state: 'Pennsylvania',
        zip: '19149',
        email: 'kamal@gmail.com',
        phone: '(267) 737-9661'
    },
    AGHRO335: {
        name: 'LOGAN DUSTIN AGENCY LLC',
        address: '494 MONMOUTH RD UNIT 7',
        city: 'MILLSTONE',
        state: 'New Jersey',
        zip: '8510',
        email: 'LOGAN@DUSTINAGENCY.COM',
        phone: '(732) 231-5017'
    },
    AGHRO336: {
        name: 'Bambrick Insurance Agency, Inc.',
        address: '5001 Mayfield Road',
        city: 'Lyndhurst',
        state: 'Ohio',
        zip: '44124',
        email: 'Mike@Bambrickinsurance.com',
        phone: '(216) 291-9850'
    },
    AGHRO337: {
        name: 'Reggie White Insurance Agency',
        address: '626 W Wheatland Rd',
        city: 'Duncanville',
        state: 'Texas',
        zip: '75116',
        email: 'reggie.white17@yahoo.com',
        phone: '(972) 422-9412'
    },
    AGHRO338: {
        name: 'Total Client Satisfaction Insurance Brokers, Inc.',
        address: '2680 N. Tracy Blvd.',
        city: 'Tracy',
        state: 'California',
        zip: '95376',
        email: 'domingo@tcsib.com',
        phone: '(209) 207-0577'
    },
    AGHRO339: {
        name: 'Intrust Insurance Agency',
        address: '202 Blum Ct',
        city: 'Bel AIr',
        state: 'Maryland',
        zip: '21014',
        email: 'cass@intrustins.com',
        phone: '(410) 776-7650'
    },
    AGHRO340: {
        name: 'Babu Varghese Insurance Agency LLC',
        address: '4230 Lyndon B Jhonson fwy, suite 614',
        city: 'Dallas',
        state: 'Texas',
        zip: '75244',
        email: 'agency.bv@gmail.com',
        phone: '(972) 503-3400'
    },
    AGHRO341: {
        name: 'Hedges Insurance Agency LLC',
        address: '22491 Timberlake Rd',
        city: 'Lynchburg',
        state: 'Virginia',
        zip: '24502',
        email: 'trish@hedgesinsurance.net',
        phone: '(434) 237-2021'
    },
    AGHRO342: {
        name: 'Jackson Insurance Agency Inc',
        address: '1021 N Lincoln Ave',
        city: 'Lovelandagent.com',
        state: 'Colorado',
        zip: '80537',
        email: 'dennise@lovelandagent.com',
        phone: '(970) 667-3680'
    },
    AGHRO343: {
        name: 'Karl Booker Agency',
        address: '10350 Sandalwood Drive',
        city: 'Twinsburg',
        state: 'Ohio',
        zip: '44087',
        email: 'klbooker1@msn.com',
        phone: '(330) 353-9130'
    },
    AGHRO344: {
        name: 'Defy Insurance Agency',
        address: '116 Village Blvd, Ste 200',
        city: 'Princeton',
        state: 'New Jersey',
        zip: '8540',
        email: 'anass@defyinsurance.com',
        phone: '(877) 780-4626'
    },
    AGHRO345: {
        name: 'Dorsey Insurance Agency, Ltd.',
        address: '503 Jefferson Terrace Blvd',
        city: 'New Iberia',
        state: 'Louisiana',
        zip: '70560',
        email: 'david_d@dorseyagency.com',
        phone: '(337) 364-4563'
    },
    AGHRO346: {
        name: 'Hunziker-Nagel Insurance Solutions Inc',
        address: '220 Channahon St.',
        city: 'Shorewood',
        state: 'Illinois',
        zip: '60404',
        email: 'heather@HNinsurancesolutions.com',
        phone: '(815) 255-2322'
    },
    AGHRO347: {
        name: 'Insurance Depot Center',
        address: '14435 Sherman Way Ave unit 204A',
        city: 'Van Nuys',
        state: 'California',
        zip: '91405',
        email: 'insurancedepotcenter@gmail.com',
        phone: '(747) 247-8788'
    },
    AGHRO348: {
        name: 'Michael Martz Agency LLC',
        address: 'W163N11516 Rivercrest, STE 212',
        city: 'Germantown',
        state: 'Wisconsin',
        zip: '53022',
        email: 'martzfit50@gmail.com',
        phone: '(414) 412-1495'
    },
    AGHRO349: {
        name: 'AGJ Insurance Agency',
        address: '2041 E 114th Pl',
        city: 'Northglenn',
        state: 'Colorado',
        zip: '80233',
        email: 'agjinsuranceagency@gmail.com',
        phone: '(720) 408-1117'
    },
    AGHRO350: {
        name: 'Kling Insurance LLC',
        address: '3300 Carrollton Rd',
        city: 'Hampstead',
        state: 'Maryland',
        zip: '21074',
        email: 'jkling@klinginsurance.com',
        phone: '(443) 244-0072'
    },
    AGHRO351: {
        name: 'South Coast Insurance Agency',
        address: '7336 Highland Rd.',
        city: 'Baton Rouge',
        state: 'Louisiana',
        zip: '70808',
        email: 'mike@southcoastagency.com',
        phone: '(225) 302-8800'
    },
    AGHRO352: {
        name: 'Sanguinity Financial LLC.',
        address: '203 James Dr.',
        city: 'Roland',
        state: 'Oklahoma',
        zip: '74954',
        email: 'glenmcginnis@trimerica.net',
        phone: '(918) 255-0057'
    },
    AGHRO353: {
        name: 'Williams Insurance Services, LLC',
        address: '19622 Sumrall Pl',
        city: 'Westfield',
        state: 'Indiana',
        zip: '46074',
        email: 'joe@willinsureyou.net',
        phone: '(317) 520-9744'
    },
    AGHRO354: {
        name: 'Direct Solutions agency llc',
        address: '2045 columbus hwy',
        city: 'dawson',
        state: 'Georgia',
        zip: '39842',
        email: 'dirsolagency@gmail.com',
        phone: '(470) 636-3553'
    },
    AGHRO355: {
        name: 'Dolan Agency',
        address: '655 Rockland Rd Ste 211',
        city: 'LAKE BLUFF',
        state: 'Illinois',
        zip: '60044',
        email: 'tdolan@farmersagent.com',
        phone: '(847) 735-1100'
    },
    AGHRO356: {
        name: 'Foursquare Insurance',
        address: '5272 S Lewis Ave',
        city: 'Suite 216',
        state: 'Oklahoma',
        zip: '74105',
        email: 'david@foursquareinsurance.com',
        phone: '(918) 292-8888'
    },
    AGHRO357: {
        name: 'RICHARD AUTO INSURANCE AGENCY',
        address: '475 ETNA ST',
        city: 'SAINT PAUL',
        state: 'Minnesota',
        zip: '55106',
        email: 'RICHARD.LOR2010@GMAIL.COM',
        phone: '(651) 756-7391'
    },
    AGHRO358: {
        name: 'Smart Stop Brokers P.C.',
        address: '5775 Wayzata Blvd',
        city: 'St. Louis Park',
        state: 'Minnesota',
        zip: '55416',
        email: 'fdahdal@smartstopbrokers.com',
        phone: '(763) 703-3119'
    },
    AGHRO359: {
        name: 'SeguroHub',
        address: '415 E. Airport Freeway',
        city: 'Irving',
        state: 'Texas',
        zip: '75062',
        email: 'juandiaz@jdtres.com',
        phone: '(469) 514-0802'
    },
    AGHRO360: {
        name: 'Advance Financial solutions Corp',
        address: '8110 38th st N',
        city: 'Lake Elmo',
        state: 'Minnesota',
        zip: '55042',
        email: 'yiacyang@msn.com',
        phone: '(651) 493-3985'
    },
    AGHRO361: {
        name: 'C. Gosa Agency, LLC',
        address: '525 West Main St',
        city: 'Mesa',
        state: 'Arizona',
        zip: '85201',
        email: 'cgosaagency@gmail.com',
        phone: '(417) 239-6800'
    },
    AGHRO362: {
        name: 'Ingrained Insurance',
        address: '11493 New Biddinger Rd',
        city: 'Harrison',
        state: 'Ohio',
        zip: '45030',
        email: 'jasonwlsn32@gmail.com',
        phone: '(513) 278-7277'
    },
    AGHRO363: {
        name: 'Scott Park Insurance Agency',
        address: '3100 Chino Hills Pkwy',
        city: 'Chino Hills',
        state: 'California',
        zip: '91709',
        email: 'scottpark@scottparkfinancial.com',
        phone: '(213) 282-8636'
    },
    AGHRO364: {
        name: 'Aggressive Insurance Services LLC',
        address: '1057 Millcreek Dr',
        city: 'Feasterville',
        state: 'Pennsylvania',
        zip: '19053',
        email: 'casey@aissvcs.com',
        phone: '(215) 322-4446'
    },
    AGHRO365: {
        name: 'NEIO INC',
        address: '501 Cambria Avenue-Suite 115',
        city: 'Bensalem',
        state: 'Pennsylvania',
        zip: '19020',
        email: 'marcseid@verizon.net',
        phone: '(215) 360-1180'
    },
    AGHRO366: {
        name: 'Mehta Insurance Agency LLC',
        address: '175 W. Absecon Blvd. Ste 12',
        city: 'Absecon',
        state: 'New Jersey',
        zip: '8201',
        email: 'smehta@miagency.com',
        phone: '(609) 872-1369'
    },
    AGHRO367: {
        name: 'Driscoll Insurance Services, LLC',
        address: '2738 South Park Road',
        city: 'Bethel Park',
        state: 'Pennsylvania',
        zip: '15102',
        email: 'customerservice@driscollfinancial.com',
        phone: '(412) 833-1500'
    },
    AGHRO368: {
        name: 'My Preferred Insurance & HomeSolutions',
        address: '9840 Old Perry Highway',
        city: 'Wexford',
        state: 'Pennsylvania',
        zip: '15090',
        email: 'vince@mypreferred-insurance.com',
        phone: '(412) 548-1570'
    },
    AIS: {
        name: 'American Insurance Strategies',
        address: '76 Marco Lane',
        city: 'Centerville',
        state: 'OH',
        zip: '45458',
        email: 'dmanley@aiscorporate.com',
        phone: '937-886-6454'
    },
    AIS1: {
        name: 'American Insurance Strategies',
        address: '76 Marco Lane',
        city: 'Centerville',
        state: 'OH',
        zip: '45458',
        email: 'dmanley@aiscorporate.com',
        phone: '937-886-6454'
    },
    ALNK1: {
        name: 'ALINK Insurance Service',
        address: '2407 W Colorado Ave',
        city: 'Colorado Springs',
        state: 'CO',
        zip: '80904',
        email: 'AlinkReceptionist@ALINK2ins.com',
        phone: '(719) 473-6262'
    },
    AMS1: {
        name: 'AmSuisse',
        address: '830 S. Mason Road, Suite A-1',
        city: 'Katy',
        state: 'TX',
        zip: '77450',
        email: 'jhamann@amsuisse.com',
        phone: '281-394-1756'
    },
    AMS2: {
        name: 'GILBERT DLG, LLC',
        address: '22503 Katy Fwy Suite 57',
        city: 'Katy',
        state: 'TX',
        zip: '77450',
        email: 'info@gilbertdlg.com',
        phone: '713-262-5366'
    },
    AMS3: {
        name: 'Thrive Insurance Group',
        address: '6445 FM 1463 Ste 160-201',
        city: 'Katy',
        state: 'TX',
        zip: '77494',
        email: 'john@thriveinsurancegroup.com',
        phone: '281-640-3733'
    },
    AMS4: {
        name: 'WIEMERS INSURANCE GROUP',
        address: '23227 RED RIVER DRIVE',
        city: 'KATY',
        state: 'TX',
        zip: '77494',
        email: 'DAVID@WIEMERSINSURANCE.COM',
        phone: '281-344-2557'
    },
    AMS5: {
        name: 'Worthen Insurance Group, Inc',
        address: '104 Melody Lane',
        city: 'Friendswood',
        state: 'TX',
        zip: '77546',
        email: 'carriers@worthenadvisors.com',
        phone: '281-845-2770'
    },
    AMS6: {
        name: 'BECKY GLASS INSURANCE AGENCY',
        address: '32903 WESTWOOD SQ E DR',
        city: 'MAGNOLIA, ',
        state: 'TX',
        zip: '77354',
        email: 'BECKYGLASS77354@YAHOO.COM',
        phone: '7134787250'
    },
    AMS7: {
        name: 'Adrian Hackett Insurance Agency, LLC.',
        address: '3033 Chimney Rock Rd, Ste 438',
        city: 'Houston',
        state: 'TX',
        zip: '77056',
        email: 'adrian.hackett@adrianhackettagency.com',
        phone: '8320358-4529'
    },
    AMS8: {
        name: 'Crown Insurance Agency',
        address: '10998 S Wilcrest Dr. Ste 120',
        city: 'Houston',
        state: 'TX',
        zip: '77099',
        email: 'rfarishta@crowninsuranceagency.net',
        phone: '832-534-2401'
    },
    AMS9: {
        name: 'Coy Insurance Agency',
        address: '6215 Spring Cypress',
        city: 'Spring',
        state: 'Texas',
        zip: '77379',
        email: 'Rivet@CoyIns.com',
        phone: '281.440.0000'
    },
    AMS10: {
        name: 'Salgado Insurance Agency',
        address: '1200 N 10th Street, Ste A',
        city: 'McAllen',
        state: 'TX',
        zip: '78501',
        email: 'rafael@rsalgadoins.com',
        phone: '956 616-5552'
    },
    AMS11: {
        name: 'Z.A.R.D. Insurance',
        address: '507 N Sam Houston Parkway E, Suite 315',
        city: 'Houston',
        state: 'TX',
        zip: '77060',
        email: 'info@zardinsurance.com',
        phone: '8322243512'
    },
    AMS12: {
        name: 'Turrentine Insurance Agency',
        address: '4003 Center St',
        city: 'Deer Park',
        state: 'TX',
        zip: '77536',
        email: 'david@turrentineinsuranceagency.com',
        phone: '281-476-0557'
    },
    AMS13: {
        name: 'Barry Insurance Group',
        address: '4418 Broadway St',
        city: 'Pearland',
        state: 'TX',
        zip: '77581',
        email: 'jeff.barry@barryinsurancegroup.com',
        phone: '281-464-3384'
    },
    AMS14: {
        name: 'Texins Agency LLC',
        address: '10333 Harwin Drive Suite 150',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'hd@mytexinsagency.com',
        phone: '281-498-4500'
    },
    AMS15: {
        name: 'A to Z Insurance Endeavors, LLC',
        address: '5625 Betty Jean Drive',
        city: 'Corpus Christi',
        state: 'Texas',
        zip: '78411',
        email: 'javier@atozinsurancegroup.com',
        phone: '(361) 945-1979'
    },
    AMS16: {
        name: 'Prosafe Insurance ',
        address: '3 Sugar Creek Center Blvd #100',
        city: 'Sugar Land ',
        state: 'Tx',
        zip: '77478',
        email: 'info@prosafeinsurance.com',
        phone: '281.720.8508 x100'
    },
    AMS17: {
        name: 'Dennis Huffman Insurance',
        address: '20015 Standing Cypress',
        city: 'Spring',
        state: 'TX',
        zip: '77379',
        email: 'huffmanins@aol.com',
        phone: '281-370-8400'
    },
    AMS18: {
        name: 'Integrity Advisors Agency',
        address: '8327 Monument Oak',
        city: 'Fair Oaks',
        state: 'TX',
        zip: '78015',
        email: 'sreese@iaainsurance.net',
        phone: '210-641-4000'
    },
    AMS19: {
        name: 'Salazar Insurance Aency',
        address: '6421 N. 10th ST. Ste 160',
        city: 'McAllen',
        state: 'TX',
        zip: '78504',
        email: 'nancy@salazarinsuranceagency.com',
        phone: '956-631-0004'
    },
    AMS20: {
        name: 'ABM Insurance & Benefit Services, Inc.',
        address: '333 N Sam Houston Pkwy #750',
        city: 'Houston',
        state: 'TX',
        zip: '77060',
        email: 'mike.alexanderjr@cobensrv.com',
        phone: '281-448-3040'
    },
    AMS21: {
        name: 'PolicyPro Inc',
        address: '830 North Blvd. #2937',
        city: 'Universal City',
        state: 'TX',
        zip: '78148',
        email: 'bobby.fazio@policypro.com',
        phone: '210-585-2301'
    },
    AMS22: {
        name: 'Pracht Insurance Agency LLC',
        address: '8955 Katy Freeway #110',
        city: 'Houston',
        state: 'TX',
        zip: '77024',
        email: 'scott@prachtinsurance.com',
        phone: '(713)290-0070'
    },
    AMS23: {
        name: 'Gulfcoast Insurance Solutions Limited Liability Company',
        address: '7706 Granite Ridge Ln',
        city: 'Houston',
        state: 'TX',
        zip: '77095',
        email: 'mboudreaux@gcisllc.com',
        phone: '(713) 791-3885'
    },
    AMS24: {
        name: 'Texan Insurance',
        address: '6161 Savoy Dr Ste 960',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'rvirani@texaninsurance.com',
        phone: '281-998-2500'
    },
    AMS25: {
        name: 'Reifel Insurance Agency',
        address: '503 S.Brooks St',
        city: 'Brazoria,',
        state: 'Texas',
        zip: '77422',
        email: 'dreifel@brazoriainet.com',
        phone: '979-798-4894'
    },
    AMS26: {
        name: 'AllWide Agency',
        address: '1100 NW Loop 410 Ste 700',
        city: 'San Antonio',
        state: 'TX',
        zip: '78213',
        email: 'DanielR@allwideagency.com',
        phone: '210-890-8808'
    },
    AMS27: {
        name: 'Fampro Insurance',
        address: '222 N. Expy 77/83 Ste. 118',
        city: 'Brownsville',
        state: 'TX',
        zip: '78521',
        email: 'pedrovillalon@famproinsurance.com',
        phone: '956-466-3635'
    },
    AMS28: {
        name: 'MAKEM Insurance',
        address: '210 Odyssey Dr Ste B',
        city: 'Webster',
        state: 'TX',
        zip: '77598',
        email: 'mark@makemins.com',
        phone: '281-229-1301'
    },
    AMS29: {
        name: 'Kingdom Insurance Agency Inc. DBA Alpha Omega Insurance Agency',
        address: '3131 Custer Rd. #275',
        city: 'Plano',
        state: 'Texas',
        zip: '75075',
        email: 'service@alphaomegainsurance.net',
        phone: '972-964-8397'
    },
    AMS30: {
        name: 'MYsurance',
        address: '800 Roosevelt Road, Building A Suite 16',
        city: 'Glen Ellyn',
        state: 'IL',
        zip: '60137',
        email: 'jason@Mysuranceusa.com',
        phone: '312.300.4122'
    },
    AMS31: {
        name: 'Dana Hinds Insurance Agency',
        address: '10730 Potranco Road, Suite 122-555',
        city: 'San Antonio',
        state: 'Texas',
        zip: '78251',
        email: 'danahinds@sbcglobal.net',
        phone: '210-679-5515'
    },
    AMS32: {
        name: 'Trimmers LLC',
        address: '24530 Gosling Rd. ',
        city: 'Spring',
        state: 'Texas',
        zip: '77389',
        email: 'dillon.trimmer@trimmersinsurance.com',
        phone: '(281) 742-2343'
    },
    AMS33: {
        name: 'Dolley Insurance Group',
        address: '1769C FM 1375E',
        city: 'Huntsville',
        state: 'TX',
        zip: '77340',
        email: 'darrelldolley@dolleyinsurancegroup.com',
        phone: '281-639-5583'
    },
    APHW: {
        name: "America's Preferred Home Warranty",
        phone: '855-429-7310'
    },
    APRG1: {
        name: 'The Savings Group (AutoPay/RateGenius)',
        phone: '855-431-3560'
    },
    ARCH1: {
        name: 'Archer Insurance Solutions',
        address: '1408 W Jefferson #3',
        city: 'Waxahachie',
        state: 'Texas',
        zip: '75165',
        email: 'trey@archerinsurancesolutions.com',
        phone: '9724571580'
    },
    ASKOTTO: {
        name: 'AskOtto',
        phone: '833-427-2624'
    },
    ASQ1: {
        name: 'ASQ Technologies LLC',
        address: '2345 Boot Jack Rd.',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76177',
        email: 'zfarris@renegadeinsurance.net',
        phone: '682-267-8787'
    },
    AST1: {
        name: 'Asterion Insurance Services LLC',
        address: '101 E Park Blvd Ste 600',
        city: 'Plano',
        state: 'TX',
        zip: '75074',
        email: 'dgskiba@gmail.com',
        phone: '214-717-5798'
    },
    BAX1: {
        name: 'Baxter Insurance Agency',
        address: '450 N Sam Houston Pkwy E #103',
        city: 'Houston',
        state: 'TX',
        zip: '77060',
        email: 'csr@baxter-ins.com',
        phone: '281-445-1381'
    },
    BCHMRK1: {
        name: 'DBA Merchant Insurance Service',
        address: '6046 Orchard Park Dr',
        city: 'Frisco',
        state: 'Texas',
        zip: '75034',
        email: 'askbenchmark@yahoo.com',
        phone: '469-633-0183'
    },
    BCHMRK2: {
        name: 'DBA Merchant Insurance Service',
        address: '6046 Orchard Park Dr',
        city: 'Frisco',
        state: 'Texas',
        zip: '75034',
        email: 'askbenchmark@yahoo.com',
        phone: '469-633-0183'
    },
    BDDG1: {
        name: 'Bird Dog Insurance Services, LLC',
        address: '120 S College Ave',
        city: 'Tyler',
        state: 'Texas',
        zip: '75702',
        email: 'ryan@birddogins.com',
        phone: '9035345554'
    },
    BPRS1: {
        name: 'Bespros Insurance and Financial Services LLC',
        address: '10704 Copperwood Dr',
        city: 'Frisco',
        state: 'TX',
        zip: '75035',
        email: 'info@bespros.com',
        phone: '972-597-9988'
    },
    BRANS1: {
        name: 'Branscomb & Associates, LLC',
        address: '9307 W. 51st. Ave. #1159',
        city: 'Laveen',
        state: 'AZ',
        zip: '85339',
        email: 'robert@rebagency.com',
        phone: '602995888'
    },
    BRPT1: {
        name: 'Bridgepoint Insurance Solutions',
        address: '50 Francisco Street Suite 257',
        city: 'San Francisco',
        state: 'CA',
        zip: '94133',
        email: 'douglas@bpinsgroup.com',
        phone: '830-428-4208'
    },
    BWB: {
        name: 'Baker Welman Brown - Test',
        address: '204 St. Francis St.',
        city: 'Kennett',
        state: 'MO',
        zip: '62857',
        email: 'cbrown@bwbins.com',
        phone: ''
    },
    CAF1: {
        name: 'Carsfast',
        phone: '855-441-6183'
    },
    CATN1: {
        name: 'Catanzaro Insurance',
        address: '729 S 3rd St',
        city: 'Columbus',
        state: 'OH ',
        zip: '43206',
        email: 'anthony@catanzaroinsurance.com',
        phone: '614-489-8383'
    },
    CAV: {
        name: 'Cavender Insurance',
        address: '4358 Lockhill Selma, Suite 200',
        city: 'San Antonio',
        state: 'TX',
        zip: '78249',
        email: 'mjones@cavenderins.com',
        phone: '210-298-2828'
    },
    CI1: {
        name: 'Cleveland Insurance Brokers, LLC',
        address: '3503 W 99th St',
        city: 'Cleveland',
        state: 'OH',
        zip: '44102',
        email: 'sales@cleinsurancebrokers.com',
        phone: '440-879-7081'
    },
    CINS1: {
        name: 'C1 Insurance Group',
        address: '12700 Park Central Drive, Ste 820',
        city: 'Dallas',
        state: 'TX',
        zip: '75251',
        email: 'mmckee@c1ig.com',
        phone: '214-420-0840'
    },
    CISS: {
        name: 'Colorado Insurance',
        address: '7901 Southpark Plaza #110',
        city: 'Littleton',
        state: 'CO',
        zip: '80120',
        email: 'service@cissinsurance.com',
        phone: '720-283-1722'
    },
    CC1: {
        name: 'Coach Collins Insurance',
        address: '600 N. Broad St. Suite 5 #404',
        city: 'Middletown',
        state: 'DE',
        zip: '19709',
        email: 'isaac.collins@coachcollinsinsurance.com',
        phone: '610-322-3734'
    },
    CMRG1: {
        name: 'Camargo Insurance',
        address: '224 Obannon Ave',
        city: 'Loveland',
        state: 'OH',
        zip: '45140',
        email: 'laura@camargoinsurance.com',
        phone: '937-892-0716'
    },
    COVSAGE: {
        name: 'Renegade Insurance LLC',
        address: '4961 Babcock St NE #7',
        city: 'Palm Bay',
        state: 'FL',
        zip: '32905',
        email: 'uw@renegadeinsurance.com',
        phone: '770-723-3933'
    },
    CRLS1: {
        name: 'CHARALES INSURANCE AGY INC',
        address: '3630 N BELT LINE RD STE.100',
        city: 'SUNNYVALE',
        state: 'TX',
        zip: '75182',
        email: 'CHARALESV@YAHOO.COM',
        phone: '9722262098'
    },
    CROL1: {
        name: 'Carroll Agency Inc',
        address: '4767 S Buchanan St',
        city: 'Aurora',
        state: 'CO',
        zip: '80016',
        email: 'Peyton@CarrollAgencyInsurance.com',
        phone: '720-763-7466'
    },
    DG1: {
        name: 'DG Agency, LLC',
        address: '151 West 4th St.',
        city: 'Cincinnati',
        state: 'OH',
        zip: '45202',
        email: 'damian@dgins-agency.com',
        phone: '513-818-1923'
    },
    DP1: { name: 'Dealer Policy', address: '', city: '', state: '', zip: '', email: '', phone: '' },
    EI1: {
        name: 'Eades Insurance Agency',
        address: '60 W. High St.',
        city: 'London',
        state: 'OH',
        zip: '43140',
        email: 'eadesinsurance@sbcglobal.net',
        phone: '740-852-4090'
    },
    ELD1: {
        name: 'Elder Mitsubishi',
        phone: '855-746-5886'
    },
    EPLR1: {
        name: 'Eppler Insurance Group, LLC',
        address: '38585 Fairway Glenn Blvd',
        city: 'Willoughby ',
        state: 'OH',
        zip: '44094',
        email: 'njeppler@gmail.com',
        phone: '440-346-1939'
    },
    EXEC1: {
        name: 'Executive Insurance Agency',
        address: '4105 W Spring Creek Pkwy # 510',
        city: 'Plano',
        state: 'TX',
        zip: '75024',
        email: 'info@executiveins.net',
        phone: '469-929-9030'
    },
    FREF1: {
        name: 'Firefly Agency LLC',
        address: '614-507-7847',
        city: '655 Metro Place South - Suite 330 ',
        state: 'Dublin',
        zip: 'Ohio ',
        email: 'Mayhill',
        phone: 'rod@fireflyagency.com '
    },
    GH1: {
        name: 'Goosehead Insurance',
        address: '1500 Solana Blvd Suite 4500',
        city: 'Westlake',
        state: 'TX',
        zip: '76262',
        email: 'mailbox@Goosehead.com',
        phone: '800-474-1377'
    },
    GRTRATE: { name: 'Guaranteed Rate', address: '', city: '', state: '', zip: '', email: '', phone: '' },
    HOME1: {
        name: 'Homeowners Insurance Group',
        address: 'PO Box 5327',
        city: 'Scottsdale',
        state: 'AZ',
        zip: '85261',
        email: 'aliesha@homeownersig.com',
        phone: '480-626-9376'
    },
    HRZ1: {
        name: 'Bergen Insurance Agency',
        address: '14545 FM 730 N, Suite 102',
        city: 'Azle',
        state: 'TX',
        zip: '76020',
        email: 'STEVEBERGEN@BIAOFTEXAS.COM',
        phone: '(817) 930-5022'
    },
    HRZ2: {
        name: 'Don Mullins Agency',
        address: '326 US Highway, Suite 1B',
        city: 'Green Brook',
        state: 'NJ',
        zip: '8812',
        email: 'don@donmullinsagency.com',
        phone: '(732) 587-7005'
    },
    HRZ3: {
        name: 'Wyant Insurance Agency',
        address: '11214 Eagle Tree',
        city: 'San Antonio',
        state: 'TX',
        zip: '78245',
        email: 'Brady@wyantinsurance.com',
        phone: '(210) 374-4001'
    },
    HRZ4: {
        name: 'Insureway Insurance',
        address: '104 North Airline Hwy, Suite 173',
        city: 'Gonzales',
        state: 'LA',
        zip: '70737',
        email: 'jamie@insurewayins.com',
        phone: '(225) 416-0911'
    },
    HRZ5: {
        name: 'Texas Savings Insurance Agency LLC',
        address: '5900 Balcones Dr, Suite 4540',
        city: 'Austin',
        state: 'TX',
        zip: '78731',
        email: 'david@texsav.com',
        phone: '(512) 759-0558'
    },
    HRZ6: {
        name: 'Benchmark Insurance Agency & Permit Center',
        address: '703 South FM 88',
        city: 'Progresso',
        state: 'TX',
        zip: '78579',
        email: 'Alanmp@benchmarkiapc.com',
        phone: '(956)-375-7525'
    },
    HRZ7: {
        name: 'Silva Insurance Group',
        address: '2550 W Union Hills Dr Ste 350',
        city: 'Phoenix',
        state: 'AZ',
        zip: '85027',
        email: 'Drew@Silvainsgroup.com',
        phone: '(602) 684-8652'
    },
    HRZ8: {
        name: 'Blue Bear Insurance Advisors',
        address: '25807 Westheimer Pkwy Ste 410',
        city: 'Katy',
        state: 'TX',
        zip: '77494',
        email: 'ryan@bluebearagency.com',
        phone: '(504) 881-4231'
    },
    HRZ9: {
        name: 'Uplift Insurance',
        address: '1840 Stardust Trail',
        city: 'Cumming',
        state: 'GA',
        zip: '30040',
        email: 'nick@upliftinsurancegroup.com',
        phone: '470-542-4570'
    },
    HRZ10: {
        name: 'Bigfoot Agency',
        address: '6844 Meadowdale Circle',
        city: 'Cincinnati',
        state: 'OH',
        zip: '45243',
        email: 'collins.kirkland@bigfootinsuranceagency.com',
        phone: '706-570-2086'
    },
    HRZ11: {
        name: 'Keith Taylor',
        address: '777 Main Street #600',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76102',
        email: 'loans@tarrantmortgage.com',
        phone: '817-980-8535'
    },
    HRZ12: {
        name: 'UpperHill Insurance',
        address: '2312 Houston Drive',
        city: 'Melissa',
        state: 'TX',
        zip: '75454',
        email: 'aparkermunene@upperhillinsurance.com',
        phone: '(972)-804-8770'
    },
    HRZ13: {
        name: 'Midwest Insurance Partners',
        address: '1519 South Dixie Highway',
        city: 'Monroe',
        state: 'MI',
        zip: '48161',
        email: 'mpetree@foureight161.com',
        phone: '(734)-384-3370'
    },
    HRZ14: {
        name: 'Freeman Financial & Insurance',
        address: '210 N 4th Street',
        city: 'Moberly',
        state: 'MO',
        zip: '65270',
        email: 'jeff@ffillc.net',
        phone: '(660)-651-5516'
    },
    HRZ15: {
        name: 'Parachute Insurance Agency',
        address: '250 S Railraod Avenue',
        city: 'Parachute',
        state: 'CO',
        zip: '81635',
        email: 's_loschke@msn.com',
        phone: '(970)-640-3115'
    },
    HRZ16: {
        name: 'Domvo Insurance Agency',
        address: '1900 E. Elms Road, Suite 100-A',
        city: 'Killeen',
        state: 'TX',
        zip: '76549',
        email: 'dom@domvoinsurance.com',
        phone: '(512)-299-1147'
    },
    HRZ17: {
        name: 'Bold Insurance Group, INC',
        address: '1603 E. 19th Street, Suite 108',
        city: 'Edmond',
        state: 'OK',
        zip: '73013',
        email: 'randy@boldcoverage.com',
        phone: '(405)-412-7735'
    },
    HRZ18: {
        name: 'Flywheel Insurance LLC',
        address: '1212 North Ashland Avenue, Suite 202',
        city: 'Chicago',
        state: 'IL',
        zip: '60622',
        email: 'steve@flywheelinsurance.com',
        phone: '(630)-300-8058'
    },
    HRZ19: {
        name: 'The Andrew Korth Agency',
        address: '1317 SW Hidden Creek Court',
        city: 'Blue Springs',
        state: 'MO',
        zip: '64015',
        email: 'akorth24@gmail.com',
        phone: '(816) 355-5001'
    },
    HRZ20: {
        name: 'Schulz Insurance',
        address: '128 W 135th Pl N',
        city: 'Skiatook',
        state: 'OK',
        zip: '74070',
        email: 'tyler@schulz-insurance.com',
        phone: '(918) 978-3557'
    },
    HRZ21: {
        name: 'Bison Ridge Insurance',
        address: '13687 S 285th E Avenue',
        city: 'Coweta',
        state: 'OK',
        zip: '74429',
        email: 'maverick@bisonridgeinsurance.com',
        phone: '918-899-2266'
    },
    HRZ22: {
        name: 'Blooming Insurance Advocates',
        address: '20015 S Lagrange Road #1062',
        city: 'Frankfort',
        state: 'IL',
        zip: '60423',
        email: 'teambloom@bloomingadvocates.com',
        phone: '708-480-7099'
    },
    HRZ23: {
        name: 'Hernandez Texas Insurance Agency',
        address: '2520 West Mount Houston Rd',
        city: 'Houston',
        state: 'TX',
        zip: '77038',
        email: 'chernandez@htxia.com',
        phone: '346-412-9416'
    },
    HRZ24: {
        name: 'Oklahoma Elite Insurance Inc',
        address: '309 Hollowdale',
        city: 'Edmond',
        state: 'OK',
        zip: '73003',
        email: 'montemar99@gmail.com',
        phone: '(405) 724-4646'
    },
    HRZ25: {
        name: 'Campa Insurance and Financial Services LLC',
        address: '7614 Foss Alley',
        city: 'San Antonio',
        state: 'TX',
        zip: '78254',
        email: 'thetexasinsuranceagent@gmail.com',
        phone: '(210) 415-0066'
    },
    HRZ26: {
        name: 'Alpha and Omega Insurance Agency LLC',
        address: '1810 Blue Bell Dr',
        city: 'Cedar Park',
        state: 'TX',
        zip: '78613',
        email: 'bryan_r_johnson7@outlook.com',
        phone: '512-961-2665'
    },
    HRZ27: {
        name: 'Variety Insurance Agency of Arizona LLC',
        address: '5702 N 42nd Ave',
        city: 'Phoenix',
        state: 'AZ',
        zip: '85019',
        email: 'castroisidoro92@gmail.com',
        phone: '(623) 308-9901'
    },
    HRZ28: {
        name: 'Shamrock Insurance Agency',
        address: '20017 Crane Creek Loop',
        city: 'Pflugerville',
        state: 'TX',
        zip: '78660',
        email: 'shamrock@theshamrockagency.com',
        phone: '5127388855'
    },
    HRZ29: {
        name: 'Blue Compass Rose Insurance Agency',
        address: '209 Bandera St',
        city: 'Benbrook',
        state: 'TX',
        zip: '76126',
        email: 'kc121403@icloud.com',
        phone: '(817) 343-1990'
    },
    HRZ30: {
        name: 'Kim Lindemann Insurance',
        address: '1321 Brunswick Dr',
        city: 'Clearwater',
        state: 'FL',
        zip: '33756',
        email: 'kimklinde@gmail.com',
        phone: '(727) 439-5491'
    },
    HRZ31: {
        name: 'iSecure Professional Services LLC',
        address: '1115 River Delta Ln',
        city: 'Rosenberg',
        state: 'TX',
        zip: '77469',
        email: 'isecurehealth@gmail.com',
        phone: '(346) 779-3786'
    },
    HRZ32: {
        name: 'Apple Pie Insurance, LLC',
        address: '9375 E Shea Blvd, Suite 100',
        city: 'Scottsdale',
        state: 'AZ',
        zip: '85260',
        email: 'agency@applepieinsurance.com',
        phone: '(702) 429-1662'
    },
    HRZ33: {
        name: 'Uche Okereke Insurance Agency, Inc.',
        address: '7050 Lakeview Haven Ct Dr, Suite 110',
        city: 'Houston',
        state: 'TX',
        zip: '77095',
        email: 'uchememe@gmail.com',
        phone: '(281) 463-9300'
    },
    HRZ34: {
        name: 'Sanderson Insurance Group',
        address: '1755 Telstar Drive, Ste 300',
        city: 'Colorado Springs',
        state: 'CO',
        zip: '80920',
        email: 'T.SandersonInsurance@gmail.com',
        phone: '(719) 323-9298'
    },
    HRZ35: {
        name: 'United Insurance Agencies of Texas',
        address: '13000 CR 2127, N Lot 47',
        city: 'Henderson',
        state: 'TX',
        zip: '75652',
        email: 'scott.droddy@yahoo.com',
        phone: '(318) 751-4901'
    },
    HRZ36: {
        name: 'A & G Insurance Agency',
        address: '17204 N FM 973',
        city: 'Manor',
        state: 'TX',
        zip: '78653',
        email: 'info@aginsagency.com',
        phone: '(512) 350-2450'
    },
    HRZ37: {
        name: 'Amana Partners',
        address: '3617 Fir Hollow Way',
        city: 'Pearland',
        state: 'TX',
        zip: '77581',
        email: 'm.hussein@amanagroup.info',
        phone: '(713) 367-8992'
    },
    HRZ38: {
        name: 'Ari David Insurance Services, LLC',
        address: '3411 N Kennicott Ave, 3411 N Kennicott Ave, Suite A3',
        city: 'Arlington Heights',
        state: 'IL',
        zip: '60004',
        email: 'aridavidinsurance@gmail.com',
        phone: '(847) 533-1584'
    },
    IAL1: {
        name: 'IAL Insurance',
        address: '1394 N Michigan Road',
        city: 'Shelbyville',
        state: 'IN',
        zip: '46176',
        email: 'ron@ialinsurance.com',
        phone: '317-376-0500'
    },
    IN1: {
        name: 'Insurify',
        address: '222 Third Street #1320',
        city: 'Cambridge',
        state: 'MA',
        zip: '02142',
        phone: '866-749-1973'
    },
    INSMRT1: {
        name: 'Insuremart, Inc',
        address: '2655 S Rainbow #310',
        city: 'Las Vegas',
        state: 'NV',
        zip: '89146',
        email: 'jason@insuremart.net',
        phone: '702-795-1777'
    },
    INSTM1: {
        name: 'The Insurance Team',
        address: '22246 S Ellsworth RD',
        city: 'Queen Creek',
        state: 'AZ',
        zip: '85142',
        email: 'steve@theinsteam.com',
        phone: '480-626-1860'
    },
    INT1: {
        name: 'JYS - Integra Insurance Services',
        address: '3948 Legacy Dr. Suite 106',
        city: 'Plano',
        state: 'TX',
        zip: '75023',
        email: 'john@iysintegra.com',
        phone: '214-233-5971'
    },
    INT2: {
        name: 'Axes Integra',
        address: '16754 Southwest Fwy, B',
        city: 'Sugar Land',
        state: 'TX',
        zip: '77479',
        email: 'azmina@axesinsurance.com',
        phone: '(713) 714-5433'
    },
    INT3: {
        name: 'Bamford Integra',
        address: '301 S Coleman, Ste 40',
        city: 'Prosper',
        state: 'TX',
        zip: '75078',
        email: 'adam@bamfordintegra.com',
        phone: '972-731-2923'
    },
    INT4: {
        name: 'Bergmann Integra',
        address: '242 Sunrise Ridge Cove',
        city: 'Austin',
        state: 'TX',
        zip: '78738',
        email: 'jay@bergmannintegra.com',
        phone: '512-957-1100'
    },
    INT5: {
        name: 'BJ Integra',
        address: '14011 Park Dr., Suite 100 G',
        city: 'Tomball',
        state: 'TX',
        zip: '77377',
        email: 'burt@bjintegra.com',
        phone: '(346) 236-6679'
    },
    INT6: {
        name: 'My Insurance Group',
        address: '18587 Sigma Road, Ste 210',
        city: 'San Antonio',
        state: 'TX',
        zip: '78258',
        email: 'eric@myguynetwork.com',
        phone: '210-708-3203'
    },
    INT7: {
        name: 'Cooley Integra',
        address: '15 Postwood Rd',
        city: 'Austin',
        state: 'TX',
        zip: '78738',
        email: 'lance@cooleyintegra.com',
        phone: '(512) 789-1217'
    },
    INT8: {
        name: 'Dutka Integra',
        address: '5718 Westheimer Rd., Suite 1000',
        city: 'Houston',
        state: 'TX',
        zip: '77057',
        email: 'alex@dutkaintegra.com',
        phone: '281-720-3509'
    },
    INT9: {
        name: 'Ernie Williams Integra',
        address: '917 N Hampton Rd.,Ste. 205',
        city: 'Desoto',
        state: 'TX',
        zip: '75115',
        email: 'ernie@erniewilliamsintegra.com',
        phone: '972-200-7089'
    },
    INT10: {
        name: 'Fry Integra',
        address: '210 S. Main St., Ste. 14',
        city: 'Duncanville',
        state: 'TX',
        zip: '75116',
        email: 'todd@fryintegra.com',
        phone: '972-296-9786'
    },
    INT11: {
        name: 'Jackson Integra',
        address: '8777 W. Rayford Rd., Ste. 200 PMB 301',
        city: 'Spring',
        state: 'TX',
        zip: '77389',
        email: 'bj@jacksonintegra.com',
        phone: '(936) 242-4334'
    },
    INT12: {
        name: 'James Webb Integra',
        address: '13201 NW Freeway #710A',
        city: 'Houston',
        state: 'TX',
        zip: '77040',
        email: 'jimmy@webbintegra.com',
        phone: '(832) 661-8721'
    },
    INT13: {
        name: 'Lonestar Integra',
        address: '444 W. Pasadena Blvd., Suite D',
        city: 'Deer Park',
        state: 'TX',
        zip: '77536',
        email: 'brian@lonestarintegra.com',
        phone: '281-241-6331'
    },
    INT14: {
        name: 'Nick Nguyen Integra',
        address: '13201 NW Freeway #710A',
        city: 'Houston',
        state: 'TX',
        zip: '77040',
        email: 'nick@nicknguyenintegra.com',
        phone: '(832) 661-8721'
    },
    INT15: {
        name: 'Nunley Integra',
        address: '5541 McNeil Dr',
        city: 'Austin',
        state: 'TX',
        zip: '78729',
        email: 'nunleyinsurance@gmail.com',
        phone: '(512) 331-2800'
    },
    INT16: {
        name: "O'Sullivan Integra",
        address: '17150 North Eldridge Pkwy., Suite C',
        city: 'Tomball',
        state: 'TX',
        zip: '77377',
        email: 'chris@osullivanintegra.com',
        phone: '(281) 548-0828'
    },
    INT17: {
        name: 'Premier Integra',
        address: '11757 Katy Freeway, Suite 1300',
        city: 'Houston',
        state: 'TX',
        zip: '77079',
        email: 'rhonda@premierintegra.com',
        phone: '713-527-0789'
    },
    INT18: {
        name: 'The Phoenix Integra',
        address: '11615 Forest Central Dr, #109A',
        city: 'Dallas',
        state: 'TX',
        zip: '75243',
        email: 'aaron@thephoenixinsurance.com',
        phone: '214-253-0570'
    },
    INT19: {
        name: 'Valerie Donaghy Integra',
        address: '1617 Park Place Ave Suite 110KV',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76110',
        email: 'valerie@valeriedonaghyintegra.com',
        phone: '817-887-9883'
    },
    INT20: {
        name: 'Violet Caprio Integra',
        address: '1931 Humble Place, Suite 214',
        city: 'Humble',
        state: 'TX',
        zip: '77338',
        email: 'violet@violetcarpiointegra.com',
        phone: '281-405-0354'
    },
    INT21: {
        name: 'Henry Insurance Integra',
        address: '411 Park Grove, Suite 420',
        city: 'Katy',
        state: 'TX',
        zip: '77450',
        email: 'tammy@henryintegra.com',
        phone: '281-944-9147'
    },
    INT22: {
        name: 'Barouh Integra',
        address: '907 RR 620 S, Suite 202A',
        city: 'Austin',
        state: 'TX',
        zip: '78734',
        email: 'josh@barouhintegra.com',
        phone: '512-399-5218'
    },
    INT23: {
        name: 'Casanueva Integra',
        address: '10707 Corporate Drive, Suite 136',
        city: 'Stafford',
        state: 'TX',
        zip: '77477',
        email: 'jose@casanuevaintegra.com',
        phone: '281-201-2222'
    },
    INT24: {
        name: 'McClain Integra',
        address: '1727 Keller Parkway, Ste 11',
        city: 'Keller',
        state: 'TX',
        zip: '76248',
        email: 'chip@mcclainintegra.com',
        phone: '817-805-3335'
    },
    INT25: {
        name: 'Vioana Integra',
        address: '3535 Firewheel Dr. Suite A',
        city: 'Flower Mound',
        state: 'TX',
        zip: '75028',
        email: 'nick@vioana.com',
        phone: '469-390-9300'
    },
    INT26: {
        name: 'John Gentry Integra Insurance',
        address: '15632 Hwy 110 South, Suite 21',
        city: 'Whitehouse',
        state: 'TX',
        zip: '75791',
        email: 'john@johngentryintegra.com',
        phone: '903-871-9828'
    },
    INT27: {
        name: 'Montgomery Integra Insurance',
        address: '1019 Waterwood Parkway, Suite E11',
        city: 'Edmond',
        state: 'OK',
        zip: '73034',
        email: 'steven@montgomeryintegra.com',
        phone: '(281) 235-3982'
    },
    INT28: {
        name: 'Phil Davis Integra',
        address: '262 Carroll St Suite 27',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76107',
        email: 'phil@phildavisintegra.com',
        phone: '817-666-5252'
    },
    INT29: {
        name: 'Boyter Integra',
        address: '10810 Crown',
        city: 'Flint',
        state: 'TX',
        zip: '75762',
        email: 'mike@boyterintegra.com',
        phone: '903-894-5920'
    },
    INT30: {
        name: 'Steven Hurst Integra Insurance',
        address: '4702 Troup Hwy',
        city: 'Tyler',
        state: 'TX',
        zip: '75703',
        email: 'steven@stevenhurstintegra.com',
        phone: '(903) 939-2705'
    },
    INT31: {
        name: 'Debra McCann Integra Insurance',
        address: '105 ACR 145',
        city: 'Palestine',
        state: 'TX',
        zip: '75801',
        email: 'debra@debramccannintegra.com',
        phone: '903-731-9379'
    },
    INT32: {
        name: 'Mark Valdez Integra',
        address: '2653 Sagebrush Dr., Ste 230',
        city: 'Flower Mound',
        state: 'TX',
        zip: '75028',
        email: 'mark@markvaldezintegra.com',
        phone: '972-355-8519'
    },
    IY1: {
        name: 'Insuredly',
        address: '55 S High St, Ste 206',
        city: 'Dublin',
        state: 'OH',
        zip: '43017',
        email: 'info@insuredly.com',
        phone: '888-977-1274'
    },
    JC1: {
        name: 'JC Smith Insurance',
        address: '2915 N High School Rd',
        city: 'Indianapolis',
        state: 'IN',
        zip: '46224',
        email: 'jcsmith@jcsmithinsurance.com',
        phone: '(317) 244-2707'
    },
    JCBS1: {
        name: 'Jacobs Insurance Solutions',
        address: '1000 Texan Trail Suite 105',
        city: 'Grapevine ',
        state: 'TX ',
        zip: '76051',
        email: 'Service@JacobsInsuranceSolutions.com',
        phone: '817-485-8989'
    },
    JD1: {
        name: 'Jared Reynolds Insurance',
        address: '301 S. Main St.',
        city: 'Zanesville',
        state: 'OH',
        zip: '43701',
        email: 'jared@jaredreynoldsins.com',
        phone: '(740) 588-9090'
    },
    JL1: {
        name: 'Jennifer Atkins-Lombardo',
        address: '918 Circle Dr',
        city: 'Circleville',
        state: 'OH',
        zip: '43113',
        email: 'jenlombardo.insurance@gmail.com',
        phone: '614-578-6130'
    },
    JLEE1: {
        name: 'John Lee Insurance Agency LLC',
        address: '999 E Arapaho Rd #340',
        city: 'Richardson',
        state: 'TX',
        zip: '75081',
        email: 'jlee@johnleeins.com',
        phone: '972-918-0308'
    },
    JR1: {
        name: 'Joseph W. Reeves Insurance',
        address: '5700 Granite Parkway STE 200',
        city: 'Plano',
        state: 'TX',
        zip: '75024',
        email: 'jreeves@reevesinsurance.com',
        phone: '(972) 731-2927'
    },
    KLT1: {
        name: 'KLT Insurance',
        address: '35839 Center Ridge Rd. Suite 103',
        city: 'North Ridgeville',
        state: 'OH',
        zip: '44039',
        email: 'chris@kltinsurance.com',
        phone: '440-276-0919'
    },
    KORT1: {
        name: 'Kortsen & Associates LLC',
        address: '1016 W University Ave Ste 102',
        city: 'Flagstaff',
        state: 'AZ',
        zip: '86001',
        email: 'allison@kortsenins.com',
        phone: '928-527-1918'
    },
    KOVKG1: {
        name: 'Kover King',
        address: '7612 Wentworth Dr',
        city: 'Springfield',
        state: 'IL',
        zip: '62711',
        email: 'doug@koverking.com',
        phone: '217-931-8000'
    },
    LBV1: {
        name: 'LBV INSURANCE',
        address: '17308 N MAY AVE  ',
        city: 'EDMOND',
        state: 'OK',
        zip: '73012',
        email: 'CRAIG@LBVINSURE.COM',
        phone: '4053415996'
    },
    LGI1: {
        name: 'Legacy Insures, LLC DBA Legacy Insurance Partners',
        address: '4425 Plano Pkwy Ste 202',
        city: 'Carrollton',
        state: 'TX',
        zip: '75010',
        email: 'Malik@legacyinsures.com',
        phone: '972-999-9090'
    },
    LNSTR1: {
        name: 'Lone Star Insurers',
        address: '8101 Boat Club Road Ste 325',
        city: 'Fort Worth',
        state: 'TX ',
        zip: '76179',
        email: 'paul@lonestarinsurers.com',
        phone: '817-236-2886'
    },
    LOUI1: {
        name: 'Lou Insurance & Financial Services Inc',
        address: '3198 Parkwood Blvd #23054',
        city: 'Frisco',
        state: 'TX',
        zip: '75034',
        email: 'louinsurance@gmail.com',
        phone: '9726699888'
    },
    MATIC1: {
        name: 'Matic',
        address: '',
        city: '',
        state: '',
        zip: '',
        email: 'customerservice@matic.com',
        phone: '(888) 380-6623'
    },
    MCR1: {
        name: 'Mike Crise Agency',
        address: '175 Ridge Road, Ste 600',
        city: 'McKinney',
        state: 'TX',
        zip: '75072',
        email: 'mcrise@farmersinsagent.com',
        phone: '214-726-0468'
    },
    MIL: {
        name: 'The Milnor Insurance Group',
        address: '5516 Stansbury Dr',
        city: 'Dublin',
        state: 'OH',
        zip: '43017',
        email: 'matt@milnorinsurancegroup.com',
        phone: '614-206-1758'
    },
    MILO1: {
        name: 'MILOSEVIC INSURANCE AGENCY',
        address: '6480 e main str. ste D',
        city: 'Reynoldsburg',
        state: 'OH',
        zip: '43068',
        email: 'rajkomilosevic@hotmail.com',
        phone: '614-410-3052'
    },
    MMTCH1: {
        name: 'Mix & Match Insurance Brokerage LLC',
        address: '6401 W Eldorado Pkwy Suite 315',
        city: 'McKinney',
        state: 'TX',
        zip: '75071',
        email: 'info@mixmatchinsurance.com ',
        phone: '4692960116'
    },
    MNSTY1: {
        name: 'Mainstay Insurance Agency',
        address: ' 800 W Airport Freeway, Ste 1100',
        city: 'Irving',
        state: 'TX',
        zip: '75062',
        email: 'Info@mainstayins.com',
        phone: '972-778-8201 '
    },
    MTRO1: {
        name: 'Metroplex Insurance & Financial Group LLC',
        address: '501 Mountain Valley Blvd',
        city: 'Joshua',
        state: 'TX',
        zip: '76058',
        email: 'Sam@metroplexinsurancegroup.com',
        phone: '817-984-3094'
    },
    MVP: {
        name: 'MVP Insurance Agency',
        address: '10 Taunton Cir',
        city: 'Madison',
        state: 'WI',
        zip: '53719',
        email: 'jim@mvpinsuranceagency.com',
        phone: '608-335-0970'
    },
    NMIB1: {
        name: 'NMH Insurance Agency',
        address: 'PO Box 13708',
        city: 'Chandler',
        state: 'AZ',
        zip: '85248',
        email: 'info@gonmhic.com',
        phone: '800-965-1646'
    },
    NMIB2: {
        name: 'NMH Insurance Agency',
        address: 'PO Box 13708',
        city: 'Chandler',
        state: 'AZ',
        zip: '85248',
        email: 'info@gonmhic.com',
        phone: '800-965-1646'
    },
    OAC: {
        name: 'AAA Ohio Auto Club',
        address: '90 E. Wilson Bridge Rd.',
        city: 'Worthington',
        state: 'OH',
        zip: '43085',
        email: 'insurance@aaaohio.com',
        phone: '844-937-2224'
    },
    OAC2: {
        name: 'AAA Ohio Auto Club',
        address: '90 E. Wilson Bridge Rd.',
        city: 'Worthington',
        state: 'OH',
        zip: '43085',
        email: 'bruckel@aaaohio.com',
        phone: '844-937-2224'
    },
    OAC3: {
        name: 'AAA Ohio Auto Club',
        address: '91 E. Wilson Bridge Rd.',
        city: 'Worthington',
        state: 'OH',
        zip: '43086',
        email: 'vmccleery@aaaohio.com',
        phone: '844-937-2224'
    },
    OAC4: {
        name: 'AAA Ohio Auto Club',
        address: '92 E. Wilson Bridge Rd.',
        city: 'Worthington',
        state: 'OH',
        zip: '43087',
        email: 'dhardy@aaaohio.com',
        phone: '844-937-2224'
    },
    OBB1: {
        name: 'Olive Branch Brokerage, LLC',
        address: '11844 Bandera Rd #114',
        city: 'Forney',
        state: 'TX',
        zip: '75126',
        email: 'ryan@obbrokerage.com',
        phone: '210-202-1115'
    },
    PI1: {
        name: 'Partners Insurance',
        address: '11500 Olive Blvd. STE 258',
        city: 'St. Louis',
        state: 'MO',
        zip: '63141',
        email: 'service@partnersinsure.com',
        phone: '314-919-2001'
    },
    PMC: {
        phone: '855-554-353'
    },
    PP1: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Brianna@perfectpolicy.com',
        phone: '(281) 301-5849'
    },
    PP2: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Charlotte@perfectpolicy.com',
        phone: '(409) 767-8855'
    },
    PP3: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Julia@perfectpolicy.com',
        phone: '(281) 316-0039'
    },
    PP4: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Steve@perfectpolicy.com',
        phone: '(281) 316-0039'
    },
    PP5: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Darlene@perfectpolicy.com',
        phone: '(281) 316-0039'
    },
    PP6: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Jada@perfectpolicy.com',
        phone: '(281) 201-4259'
    },
    PP7: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Alma@perfectpolicy.com',
        phone: '(281) 316-0039'
    },
    PP8: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Tricia@perfectpolicy.com',
        phone: '(281) 201-4259'
    },
    PP9: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Holly@perfectpolicy.com',
        phone: '(281) 301-5849'
    },
    PP10: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Jason@perfectpolicy.com',
        phone: '(281) 316-0039'
    },
    PP11: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Nichole@perfectpolicy.com',
        phone: '(281) 316-0039'
    },
    PP12: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Cindy@perfectpolicy.com',
        phone: '(281) 301-5849'
    },
    PP13: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Nancy@perfectpolicy.com',
        phone: '(281) 316-0039'
    },
    PP14: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Alana@perfectpolicy.com',
        phone: '(832) 905-0231'
    },
    PP15: {
        name: 'Perfect Policy',
        address: '920 West Main Street',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'Daniella@perfectpolicy.com',
        phone: '(281) 324-0162'
    },
    PRM1: {
        name: 'Priority Risk Management',
        address: '7050 E 116th St, Ste 50',
        city: 'Fishers',
        state: 'IN',
        zip: '46038',
        email: 'mark@priorityrisk.com',
        phone: '317-713-2959'
    },
    PRTL1: {
        name: 'Portal, LLC',
        address: '951 Goverment St Suite B ',
        city: 'Mobile',
        state: 'AL',
        zip: '36604',
        email: 'bradley@portalinsurance.com',
        phone: '2512643232'
    },
    PVD1: {
        phone: '(855) 811-3465'
    },
    QAONLINE: {
        name: 'Quantum Assurance International, Inc.',
        address: '513 Prince Edward St Suite 100',
        city: 'Fredericksburg',
        state: 'VA',
        zip: '22401',
        email: 'clientcare@quantumassurance.com',
        phone: '8559390055'
    },
    QA1: {
        name: 'Quantum Assurance International, Inc.',
        address: '513 Prince Edward St Suite 100',
        city: 'Fredericksburg',
        state: 'VA',
        zip: '22401',
        email: 'clientcare@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA2: {
        name: 'Quantum Assurance International, Inc.',
        address: '1101 Central Expressway S Suite 250',
        city: 'Allen',
        state: 'TX',
        zip: '75013',
        email: 'clientcare@quantumassurance.com'
    },
    QA3: {
        name: 'Quantum Assurance International, Inc.',
        address: '7311 Clinton Hwy Suite B1',
        city: 'Powell',
        state: 'TN',
        zip: '37849',
        email: 'adam.dickson@quantumassurance.com'
    },
    QA4: {
        name: 'Quantum Assurance International, Inc.',
        address: '816 Camaron St',
        city: 'San Antonio',
        state: 'TX',
        zip: '78212',
        email: 'bryan.montoya@quantumassurance.com'
    },
    QA5: {
        name: 'Quantum Assurance International, Inc.',
        address: '5840 South Memorial Drive Ste 209',
        city: 'Tulsa',
        state: 'OK',
        zip: '74145',
        email: 'bryce.dearington@quantumassurance.com'
    },
    QA6: {
        name: 'Quantum Assurance International, Inc.',
        address: '409 Executive Park',
        city: 'Asheville',
        state: 'NC',
        zip: '28801',
        email: 'buna.mandell@quantumassurance.com'
    },
    QA7: {
        name: 'Quantum Assurance International, Inc.',
        address: '10999 W IH-10 Ste 175',
        city: 'San Antonio',
        state: 'TX',
        zip: '78230',
        email: 'daniel.smith@quantumassurance.com'
    },
    QA8: {
        name: 'Quantum Assurance International, Inc.',
        address: '275 W Campbell Road Ste 250',
        city: 'Richardson',
        state: 'TX',
        zip: '75080',
        email: 'david.montanez@quantumassurance.com'
    },
    QA9: {
        name: 'Quantum Assurance International, Inc.',
        address: '16910 North Dallas Parkway Ste 218',
        city: 'Dallas',
        state: 'TX',
        zip: '75248',
        email: 'jason@quantumassurance.com'
    },
    QA10: {
        name: 'The Loeber Agency',
        address: '500 North Rainbow Blvd Suite 300',
        city: 'Las Vegas',
        state: 'NV',
        zip: '89107',
        email: 'justin.loeber@quantumassurance.com',
        phone: '702-718-6445'
    },
    QA11: {
        name: 'Quantum Assurance International, Inc.',
        address: '3218 Daugherty Drive Ste 100',
        city: 'Lafayette',
        state: 'IN',
        zip: '47909',
        email: 'scott.scales@quantumassurance.com'
    },
    QA12: {
        name: 'Quantum Assurance International, Inc.',
        address: '5700 Tennyson Pkwy Suite 300 Office 46',
        city: 'Plano',
        state: 'TX',
        zip: '75024',
        email: 'renee.lundquist@quantumassurance.com'
    },
    QA13: {
        name: 'Quantum Assurance International, Inc.',
        address: '513 Prince Edward St Suite 100',
        city: 'Fredericksburg',
        state: 'VA',
        zip: '22401',
        email: 'stefanie.parra@quantumassurance.com'
    },
    QA14: {
        name: 'Quantum Assurance International, Inc.',
        address: '2500 North Dallas Parkway Ste 498',
        city: 'Plano',
        state: 'TX',
        zip: '75093',
        email: 'chad.wall@quantumassurance.com',
        phone: '(972) 784-0899'
    },
    QA15: {
        name: 'Quantum Assurance International, Inc.',
        address: '3218 Fannin Rd',
        city: 'Melissa',
        state: 'TX',
        zip: '75454',
        email: 'valinda.kennedy@quantumassurance.com'
    },
    QA17: {
        name: 'Alexander Bucci',
        address: '513 Prince Edward St Suite 100',
        city: 'Fredericksburg',
        state: 'VA',
        zip: '22401',
        email: 'clientcare@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA18: {
        name: 'Brett Hees',
        address: '409 130 N Preston Rd #346',
        city: 'Prosper',
        state: 'TX',
        zip: '75078',
        email: 'clientcare@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA19: {
        name: 'Kelly Wilson',
        address: '1831 E 71st St #4225',
        city: 'Tulsa',
        state: 'OK',
        zip: '74136',
        email: 'clientcare@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA20: {
        name: 'Lauren Carbonell',
        address: '513 Prince Edward St Suite 100',
        city: 'Fredericksburg',
        state: 'VA',
        zip: '22401',
        email: 'clientcare@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA21: {
        name: 'Michael Gagnon',
        address: '1 Verani Way',
        city: 'Londonderry',
        state: 'NH',
        zip: '3053',
        email: 'clientcare@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA22: {
        name: 'TD3 Insurance Agency',
        address: '3895 Prince William Pkwy Ste 205',
        city: 'Woodbridge',
        state: 'VA',
        zip: '22192',
        email: 'clifton.durham@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA23: {
        name: 'Southern Oaks Group, LLC.',
        address: '3 Grove St.',
        city: 'Headland',
        state: 'AL',
        zip: '36345',
        email: 'alex.rainey@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA24: {
        name: 'Thomas Cassidy',
        address: '1903 W Market St',
        city: 'Pottsville',
        state: 'PA',
        zip: '17901',
        email: 'tom.cassidy@quantumassurance.com',
        phone: '570-537-2943'
    },
    QA25: {
        name: 'Michael Massey',
        address: '200 E Main St #K',
        city: 'Crowley',
        state: 'TX',
        zip: '76036',
        email: 'michael.massey@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA26: {
        name: 'Rajendra Sekhawat',
        address: '6560 Market St',
        city: 'Upper Darby',
        state: 'PA',
        zip: '19082',
        email: 'rajendra.sekhawat@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA27: {
        name: 'Next Level Insurance Solutions LLC',
        address: '14743 Old Bandera Rd, # 11-101',
        city: 'Helotes',
        state: 'TX',
        zip: '78023',
        email: 'chris.garcia@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA28: {
        name: '5280 Insurance Group LLC',
        address: '13301 W 43rd Dr #9',
        city: 'Golden',
        state: 'CO',
        zip: '80403',
        email: 'marco.gonzalez@quantumassurance.com',
        phone: '855-939-0055'
    },
    QI1: {
        name: 'QuickInsured',
        address: '500 S Front St. #840',
        city: 'Columbus',
        state: 'OH',
        zip: '43215',
        email: 'service@quickinsured.com',
        phone: '800-831-1670'
    },
    QA29: {
        name: 'Ryan Hamill',
        address: '513 Prince Edward St Suite 100',
        city: 'Fredericksburg',
        state: 'Va',
        zip: '22401',
        email: 'ryan.hamill@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA30: {
        name: 'Southeastern Assurance Group LLC',
        address: '7501 Memorial Pkwy SW #215',
        city: 'Huntsville',
        state: 'AL',
        zip: '35802',
        email: 'david.farris@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA31: {
        name: 'Best Rates Florida LLC',
        address: ' 5701 E Hillsborough Ave Ste 1160',
        city: 'Tampa',
        state: 'FL',
        zip: '33610',
        email: 'matthew.howard@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA32: {
        name: 'Emerald Magnolia Group LLC',
        address: '3142 Golf Ridge Blvd Suite 1A',
        city: 'Douglasville',
        state: 'GA',
        zip: '30135',
        email: 'mingnon.pender@quantumassurance.com',
        phone: '855-939-0055'
    },
    QA33: {
        name: 'Frank Insurance Management LLC',
        address: '432 E Val Ln',
        city: 'Marion',
        state: 'IN',
        zip: '46952',
        email: 'ryan.frank@quantumassurance.com',
        phone: '855-939-0055'
    },
    QWZS: { name: 'QW Insurance Solutions', address: '', city: '', state: '', zip: '', email: '', phone: '' },
    RDRS1: {
        name: 'Red Rose Insurance LLC',
        address: 'PO Box 2082',
        city: 'Lancaster',
        state: 'PA',
        zip: '17608',
        email: 'ben@redroseinsurance.com',
        phone: '717-690-0971'
    },
    RGD1: {
        name: 'Renegade Insurance LLC',
        address: '4961 Babcock St NE #7',
        city: 'Palm Bay,',
        state: 'FL',
        zip: '32905',
        email: 'uw@renegadeinsurance.com',
        phone: '678-679-9942'
    },
    RGTLP1: {
        name: 'Reliance Group Texas, L.P.',
        address: '2770 W. Main St., Ste 111',
        city: 'Frisco',
        state: 'TX',
        zip: '75033',
        email: 'kiran@rgtlp.com',
        phone: '972-556-0556'
    },
    RGTLP2: {
        name: 'Reliance Group Texas, L.P.',
        address: '2770 W. Main St., Ste 111',
        city: 'Frisco',
        state: 'TX',
        zip: '75033',
        email: 'james@rgtlp.com',
        phone: '817-380-4952'
    },
    RGTLP3: {
        name: 'Reliance Group Texas, L.P.',
        address: '2770 W. Main St., Ste 111',
        city: 'Frisco',
        state: 'TX',
        zip: '75033',
        email: 'todd@rgtlp.com',
        phone: '972-315-7299'
    },
    RGTLP4: {
        name: 'Reliance Group Texas, L.P.',
        address: '2770 W. Main St., Ste 111',
        city: 'Frisco',
        state: 'TX',
        zip: '75033',
        email: 'jamie@rgtlp.com',
        phone: '972-790-1929'
    },
    RGTLP5: {
        name: 'Reliance Group Texas, L.P.',
        address: '2770 W. Main St., Ste 111',
        city: 'Frisco',
        state: 'TX',
        zip: '75033',
        email: 'roger@rgtlp.com',
        phone: '972-380-6677'
    },
    RHK1: {
        name: 'Randy House and Associates',
        address: '307 East Washington',
        city: 'Benton',
        state: 'IL',
        zip: '62812',
        email: 'randy@rkhinsurance.com',
        phone: '618-439-2911'
    },
    RHK2: {
        name: 'Randy House and Associates',
        address: '2300 West Main, Suite C',
        city: 'Marion',
        state: 'IL',
        zip: '62959',
        email: 'randy@rkhinsurance.com',
        phone: '618-422-9100'
    },
    RHK3: {
        name: 'Randy House and Associates, DBA TBR Insurance Services LLC',
        address: '105 N. Emerald Lane, Suite B',
        city: 'Carbondale',
        state: 'IL',
        zip: '62901',
        email: 'randy@rkhinsurance.com',
        phone: '618-889-9680'
    },
    RI1: {
        name: 'Rutledge Group',
        address: '2084 Noble Rd. STE B',
        city: 'Cleveland Heights',
        state: 'OH',
        zip: '4344121215',
        email: 'darwin.rutledge@rutledgegrp.com',
        phone: '216.561.4444'
    },
    RIC1: {
        phone: '855-695-5602'
    },
    ROGRSK1: {
        name: 'Rogue Risk LLC',
        address: '24 4th Street',
        city: 'Troy',
        state: 'NY',
        zip: '12180',
        email: 'ryan@roguerisk.com',
        phone: '(518) 960-6600'
    },
    ROND1: {
        name: 'Rondon Insurance Services',
        address: '364 S Kelly Ave ',
        city: 'Edmond',
        state: 'OK',
        zip: '73003',
        email: 'BrandonR@redwoodagencygroup.com',
        phone: '4058618500'
    },
    ROYLT1: {
        name: 'ROYALTY INSURANCE AGENCY',
        address: '5550 GRANITE PKWY STE 120',
        city: 'PLANO',
        state: 'TX',
        zip: '75024',
        email: 'carlos@royaltyinsurance.com',
        phone: '972-801-9188'
    },
    RSWL1: {
        name: 'RiskWell',
        address: '8751 Collin McKinney Pkwy #105',
        city: 'McKinney',
        state: 'TX',
        zip: '75070',
        email: 'james@riskwell.com',
        phone: '4696788001'
    },
    SGIA1: {
        name: 'Southern Group Insurance Agency, Inc.',
        address: '2610 Pasadena Blvd.',
        city: 'Pasadena',
        state: 'Texas',
        zip: '77502',
        email: 'support@sgtexas.com',
        phone: '2818576359'
    },
    SI1: {
        name: 'Obie',
        address: '1134 W Hubbard Street, FL 3',
        city: 'Chicago',
        state: 'IL',
        zip: '60642',
        email: 'service@obierisk.com',
        phone: '773-820-9060'
    },
    SIM1: {
        name: 'Simply Insured, LLC',
        address: '5200 Buffalo Gap Rd',
        city: 'Abilene',
        state: 'TX',
        zip: '79606',
        email: 'Lisa@SimplyInsuredLLC.com',
        phone: '325-260-2870'
    },
    SKYLGHT1: {
        name: 'Skylight Insurance',
        address: '5301 Dempster St. STE 300',
        city: 'Skokie',
        state: 'IL',
        zip: '60077',
        email: 'dmajka@skylightinsurance.com',
        phone: '773-351-2818'
    },
    SMAZ: { name: 'Smart Choice Arizona Main', address: '', city: '', state: '', zip: '', email: '', phone: '' },
    SMAZ1: {
        name: 'Fontanes Insurance Group',
        address: '1020 S. 4th Avenue',
        city: 'Yuma',
        state: 'AZ',
        zip: '85364',
        email: 'rubenfontanes@hotmail.com',
        phone: '9285801731'
    },
    SMAZ2: {
        name: 'Safe Harbor Insurance',
        address: '2771 E Wisteria Drive',
        city: 'Chandler',
        state: 'Arizona',
        zip: '85286',
        email: 'dave@safeharborinsuranceagency.com',
        phone: '480-205-2894'
    },
    SMAZ3: {
        name: 'Cheetah Insurance',
        address: '15105 E Marathon Drive',
        city: 'Fountain Hills',
        state: 'AZ',
        zip: '85268',
        email: 'dawn@cheetah-insurance.com',
        phone: '602-577-2525'
    },
    SMAZ4: {
        name: 'One Family Insurance Services, LLC',
        address: '2215 N 91st Ln',
        city: 'Phoenix',
        state: 'AZ',
        zip: '85037',
        email: 'onefamilyins@gmail.com',
        phone: '602-576-9252'
    },
    SMAZ5: {
        name: 'Premier Insurance Broker',
        address: '12392 N Bufflehead Dr',
        city: 'Marana',
        state: 'AZ',
        zip: '85653',
        email: 'Matt Benjamin <premierinsurancebrokerage@gmail.com>',
        phone: '520-505-5105'
    },
    SMAZ6: {
        name: 'Willow Guard LLC',
        address: '205 S Higley Rd Lot 137',
        city: 'Mesa',
        state: 'AZ',
        zip: '85206',
        email: 'Clarence Young <clarence@willowguard.com>',
        phone: '602-980-4451'
    },
    SMAZ7: {
        name: 'Sublette Financial LLC',
        address: '106 E Lynx Pl',
        city: 'Chandler',
        state: 'AZ',
        zip: '85249',
        email: 'daisha@subfinancial.com',
        phone: '4807727512'
    },
    SMAZ8: {
        name: 'Wishwell Insurance Brokers',
        address: '12045 Peak View Rd',
        city: 'Peoria',
        state: 'AZ',
        zip: '85383',
        email: 'admin@wishwellagency.com',
        phone: '623-444-2454'
    },
    SMAZ9: {
        name: 'Candelaria Insurance Solutions LLC',
        address: '4960 S Gilbert Rd, #1-292',
        city: 'Chandler',
        state: 'AZ',
        zip: '85249',
        email: 'shannyn@candelariainsurance.com',
        phone: '480-772-2941'
    },
    SMAZ10: {
        name: 'Select Choice Insurance Group, LLC',
        address: '1237 S Val Vista Drive Suite 107',
        city: 'Mesa',
        state: 'AZ',
        zip: '85204',
        email: 'amanda@selectchoiceinsurance.com',
        phone: '480-246-0866'
    },
    SMAZ11: {
        name: 'Chainfruit Services',
        address: '2410 W Ruthrauff Rd. #100',
        city: 'Tucson',
        state: 'AZ',
        zip: '85705',
        email: 'daguilera@chainfruitservices.com',
        phone: '(520) 236-3617'
    },
    SMAZ12: {
        name: 'Rhine Insurance Agency',
        address: '3302 N 7th St #340',
        city: 'Phoenix',
        state: 'AZ',
        zip: '85014',
        email: 'wrhine5015@aol.com',
        phone: '6026720570'
    },
    SMAZ13: {
        name: 'Mabey Insurance LLC',
        address: '14631 N Cave Creek Rd Suite 102',
        city: 'Phoenix',
        state: 'AZ',
        zip: '85022',
        email: 'shelly@mabeyinsurance.com',
        phone: '602-741-9890'
    },
    SMAZ14: {
        name: 'Arizona Mutual Insurance LLC',
        address: 'PO Box 3379',
        city: 'Gilbert',
        state: 'AZ',
        zip: '85299',
        email: 'azmutual@gmail.com',
        phone: '480-740-5556'
    },
    SMAZ15: {
        name: 'AZ Insurance Shop',
        address: '30910 N. Zircon Dr',
        city: 'San Tan Valley',
        state: 'AZ',
        zip: '85143',
        email: 'doug@azinsuranceshop.com',
        phone: '480-216-0549'
    },
    SMAZ16: {
        name: 'Right Choice Insurance and Taxes, Inc',
        address: '5027 S River Run Drive',
        city: 'Tucson',
        state: 'AZ',
        zip: '85746',
        email: 'cvelasco@velascoinsurancegroup.com',
        phone: '520-264-8500'
    },
    SMAZ17: {
        name: 'Desert West Insurance, Inc.',
        address: '7530 W Peoria Ave Suite H',
        city: 'Peoria',
        state: 'AZ',
        zip: '85345',
        email: 'desertwestinsurance@gmail.com',
        phone: '623-878-3033'
    },
    SMAZ18: {
        name: 'Rattler Realty & Insurance',
        address: '8821 N 7th St',
        city: 'Phoenix',
        state: 'AZ',
        zip: '85020',
        email: 'Ernie@rattlerrealty.com',
        phone: '602-295-5553'
    },
    SMAZ19: {
        name: 'All U Insure',
        address: '4760 S. Pecos Rd',
        city: 'Las Vegas',
        state: 'NV',
        zip: '89121',
        email: 'info@alluinsure.com',
        phone: '(702) 898-2006'
    },
    SMCH: { name: 'Smart Choice Main', address: '', city: '', state: '', zip: '', email: '', phone: '' },
    SMCH1: {
        name: 'Minus and Associates, Inc.',
        address: '6230 3rd Street NW',
        city: 'Washington',
        state: 'DC',
        zip: '20011',
        email: 'rcminus@hotmail.com',
        phone: '202-722-0377'
    },
    SMIN: { name: 'Smart Choice Indiana Main', address: '', city: '', state: '', zip: '', email: '', phone: '' },
    SMIN1: {
        name: 'Paradise Insurance Group LLC',
        address: '4600 Washington Ave Ste 112-4',
        city: 'Evansville',
        state: 'IN',
        zip: '47714',
        email: 'jdavis@paradiseinsured.com',
        phone: '812-305-2329'
    },
    SMIN2: {
        name: 'Gehlhausen Insurance Agency, LLC',
        address: '215 W. 5th St',
        city: 'Jasper',
        state: 'IN',
        zip: '47546',
        email: 'ryan.gehlhausen@gehlhausenins.com',
        phone: '(812) 482-6144'
    },
    SMIN3: {
        name: 'Myers & Hayden Insurance, Inc',
        address: '3490 Stellhorn Rd',
        city: 'Fort Wayne',
        state: 'IN',
        zip: '46815',
        email: 'jmyers@myersandhaydenins.com',
        phone: '260-486-5255'
    },
    SMIN4: {
        name: 'Integrity Benefit Partners Inc.',
        address: '11925 E. 65th St Ste 5',
        city: 'Indianapolis',
        state: 'IN',
        zip: '46236',
        email: 'ibp@asimplerapproach.com',
        phone: '317-931-8098'
    },
    SMIN5: {
        name: 'Paris Insurance Group, LLC',
        address: '108 E Main St',
        city: 'Westfield',
        state: 'IN',
        zip: '46074',
        email: 'jill@parisinsurance.net',
        phone: '317-418-1062'
    },
    SMIN6: {
        name: 'Warner Insurance Agency LLC',
        address: '111 Ludwig Rd Ste 100',
        city: 'Fort Wayne',
        state: 'IN',
        zip: '46825',
        email: 'dean@warneragency.com',
        phone: '260-633-0728'
    },
    SMIN7: {
        name: 'Kervan Insurance and Real Estate Inc',
        address: '7098 N Shadeland Ave Ste D',
        city: 'Indianapolis',
        state: 'IN',
        zip: '46220',
        email: 'kervanins@gmail.com',
        phone: '317-414-6939'
    },
    SMIN8: {
        name: 'Huckstep Family Insurance LLC',
        address: '5722 US HWY 52 S',
        city: 'Lafayette',
        state: 'IN',
        zip: '47905',
        email: 'courtney.h.huckstep@gmail.com',
        phone: '765-404-4207'
    },
    SMIN9: {
        name: 'The Billy Davis Insurance Group, LLC',
        address: '5544 Broadway',
        city: 'Merriliville',
        state: 'IN',
        zip: '46410',
        email: 'billy@thebdig.com',
        phone: '219-595-2344'
    },
    SMIN10: {
        name: 'Discount Family Insurance, Inc',
        address: '4801 White Oak Ave',
        city: 'East Chicago',
        state: 'IN',
        zip: '46312',
        email: 'keith@discountfamily.com',
        phone: '219-947-2667'
    },
    SMIN11: {
        name: 'Steve Canty Insurance Agency',
        address: '9245 Calumet Ave Ste 100-B',
        city: 'Munster',
        state: 'IN',
        zip: '46321',
        email: 'stevecanty19@me.com',
        phone: '312-523-8792'
    },
    SMIN12: {
        name: 'Acrisure, LLC dba Hoosier Insurance and Financial Services',
        address: '314 E Main St',
        city: 'Washington',
        state: 'IN',
        zip: '47501',
        email: 'alan@hoosierins.com',
        phone: '812-617-1001'
    },
    SMIN13: {
        name: 'Kirk Assurance, LLC',
        address: '4695 Lakewood Hills Dr',
        city: 'Anderson',
        state: 'IN',
        zip: '46017',
        email: 'kirkassurance@yahoo.com',
        phone: '765-620-8670'
    },
    SMIN14: {
        name: 'The Cooper Agency',
        address: '306 Jackson St',
        city: 'Salem',
        state: 'IN',
        zip: '47167',
        email: 'cooperagency@yahoo.com',
        phone: '812-896-4399'
    },
    SMIN15: {
        name: 'Buchs Insurance Agency, LLC',
        address: '1041 W 7th St',
        city: 'Auburn',
        state: 'IN',
        zip: '46706',
        email: 'buchsagency@gmail.com',
        phone: '260-341-1146'
    },
    SMIN16: {
        name: 'First Direct Insurance Agency,Inc',
        address: '410 E. Main St',
        city: 'Westfield ',
        state: 'IN',
        zip: '46074',
        email: 'keri@firstdirectins.com',
        phone: '816-916-1044'
    },
    SMIN17: {
        name: 'D. Uselman & Associates LLC',
        address: '1301 Johnson St',
        city: 'Elkhart ',
        state: 'IN',
        zip: '46514',
        email: 'duselmanins4u@comcast.net',
        phone: '574-536-9863'
    },
    SMIN18: {
        name: 'Norwood Insurance Services LLC',
        address: '1316 State St',
        city: 'New Albany',
        state: 'IN',
        zip: '47150',
        email: 'bob@norwoodinsuranceservices.com',
        phone: '812-989-3001'
    },
    SMIN19: {
        name: 'Bilingual Consulting LLC',
        address: '11988 Fishers Crossing Dr. Ste 204',
        city: 'Fishers ',
        state: 'IN',
        zip: '46038',
        email: 'catalina@bilingualconsulting.business',
        phone: '(317) 778-7910'
    },
    SMIN20: {
        name: 'Abraham Insurance Services LLC',
        address: '1217 R St',
        city: 'Bedford ',
        state: 'IN',
        zip: '47421',
        email: 'parishk@abrahaminsuranceservices.com',
        phone: '812-653-7306'
    },
    SMIN21: {
        name: 'Honorable Insurance, LLC',
        address: '5610 Mills Rd',
        city: 'Indianapolis ',
        state: 'IN',
        zip: '46221',
        email: 'matthew.scott@honorableinsurance.com',
        phone: '(317) 442-9897'
    },
    SMIN22: {
        name: 'George C Rogge Agency INC',
        address: '1500 E 73rd Ave',
        city: 'Merriliville ',
        state: 'IN',
        zip: '46410',
        email: 'doug@roggeinsurance.com',
        phone: '(219) 781-5442'
    },
    SMIN23: {
        name: 'Drive Now Insurance, LLC',
        address: '1354 S Wallick Rd',
        city: 'Peru',
        state: 'IN',
        zip: '46970',
        email: 'colin@drivenowagency.com',
        phone: '317-650-2542'
    },
    SMIN24: {
        name: 'Mark Burrows Company, Inc.',
        address: '6731 W Hamilton Rd. South',
        city: 'Lakewood',
        state: 'IN',
        zip: '46814',
        email: 'benton@markburrowscompany.com',
        phone: '317-662-0660'
    },
    SMIN25: {
        name: 'Holmes Family Insurance',
        address: '412 S Maple St',
        city: 'Fortville',
        state: 'IN',
        zip: '46040',
        email: 'brandi@holmesfamilyinsurance.com',
        phone: '(317) 273-3101'
    },
    SMIN26: {
        name: 'Coastal Edge LLC',
        address: '8888 Keystone Crossing Ste 1300',
        city: 'Indianapolis ',
        state: 'IN',
        zip: '46240',
        email: 'wassociatesins@gmail.com',
        phone: '(317) 710-0154'
    },
    SMIN27: {
        name: 'Wagner & Hopkins Insurance Inc.',
        address: '505 E. National Highway ',
        city: 'Washington ',
        state: 'IN',
        zip: '47501',
        email: 'tim@waghopins.com',
        phone: '(812) 257-2477'
    },
    SMIN28: {
        name: 'Mathews Insurance Inc.',
        address: '118 West Washington St.',
        city: 'Fairmount ',
        state: 'IN',
        zip: '46928',
        email: 'sr.mathews44@gmail.com',
        phone: '(765) 206-0164'
    },
    SMIN29: {
        name: 'Completely Independent Insurance LLC',
        address: '80 E. Cedar St.',
        city: 'Zionville',
        state: 'IN',
        zip: '46077',
        email: 'wdbeyers@gmail.com',
        phone: '(317) 402-1612'
    },
    SMIN30: {
        name: 'Rutland Insurance Agency',
        address: '4310 N Part Ave',
        city: 'Indianapolis ',
        state: 'IN',
        zip: '46205',
        email: 'rutlandinsurance@gmail.com',
        phone: '317-437-3891'
    },
    SMMD: { name: 'Smart Choice Maryland Main', address: '', city: '', state: '', zip: '', email: '', phone: '' },
    SMMD1: {
        name: 'ZELAYA INSURANCE & BUSINESS SERVICES LLC',
        address: '1401 UNIVERSITY BLVD E STE G123',
        city: 'HYATTSVILLE',
        state: 'MD',
        zip: '20783',
        email: 'ZELAYAINSURANCELL@GMAIL.COM',
        phone: '2403557919'
    },
    SMMD2: {
        name: 'LEON INSURANCE LLC',
        address: '255 N Washington St suite 130',
        city: 'Rockville',
        state: 'MD',
        zip: '20850',
        email: 'javier@leoninsurance.com',
        phone: '2406462591'
    },
    SMMD3: {
        name: 'HCP Insurance Services, Inc.',
        address: '5850 Waterloo Rd, Ste 140',
        city: 'Columbia',
        state: 'MD',
        zip: '21045',
        email: 'chuong@hcpis.com',
        phone: '4436188387'
    },
    SMMD4: {
        name: 'Muhammad U Sohail',
        address: '1724 Woodlawn Dr',
        city: 'Baltimore',
        state: 'MD',
        zip: '21207',
        email: 'umar_sohail@hotmail.com',
        phone: '443-527-1204'
    },
    SMMD5: {
        name: 'Maryland Insurance Group LLC',
        address: '909 Baltimore blvd Suite 100',
        city: 'Westminster',
        state: 'MD',
        zip: '21157',
        email: 'ckoback@mdinsurancegroup.com',
        phone: '301-526-8607'
    },
    SMMD6: {
        name: 'DONNA L EASON AGENCY ',
        address: '502 S 5th AVE',
        city: 'DENTON',
        state: 'MD',
        zip: '21629',
        email: 'deasonagency@yahoo.com',
        phone: '410-253-3683'
    },
    SMMD7: {
        name: 'COMMUNITY MULTI SERVICES, LLC',
        address: '7411 RIGGS RD SUITE 228',
        city: 'HYATTSVILLE',
        state: 'MD',
        zip: '20783',
        email: 'INFO@COMMUNITYMULTI-SERVICES.COM',
        phone: '204674268'
    },
    SMMD8: {
        name: 'Celiane Boston Farmers Insurance Agency',
        address: '10 Crossroads Dr. Suite 117',
        city: 'Owings Mills',
        state: 'MD',
        zip: '21117',
        email: 'bostoncelianefarmersinsurance@gmail.com',
        phone: '4439262687'
    },
    SMMD9: {
        name: 'Jabez Insurance Agency Inc',
        address: '8492 Baltimore National Pike Ste 204',
        city: 'Ellicott City',
        state: 'MD',
        zip: '21043',
        email: 'jsim@jabezins.com',
        phone: '4107507075'
    },
    SMMD10: {
        name: 'OBICHI CONSULTING SERVICES',
        address: '15835 CRABBS BRANCH WAY, SUITE B',
        city: 'DERWOOD',
        state: 'MD',
        zip: '20855',
        email: 'cokorie@obichiinsagency.com',
        phone: '3017611929'
    },
    SMMD11: {
        name: 'Fuller Enterprises',
        address: '438 S Main Street',
        city: 'Bel Air',
        state: 'MD',
        zip: '21014',
        email: 'lisa.fuller@insurewithfuller.com',
        phone: '4109145467'
    },
    SMMD12: {
        name: 'H & M Innovations LLC DBA McCorry Agency',
        address: '602 S Atwood Dr Suite 001',
        city: 'Bel Air',
        state: 'MD',
        zip: '21014',
        email: 'jeff@bargripz.com',
        phone: '410-905-5543'
    },
    SMMD13: {
        name: 'ETHIO INSURANCE AGENCY',
        address: '8120 FENTON STREET',
        city: 'SILVER SPRING',
        state: 'MD',
        zip: '20910',
        email: 'IDEAS234@OUTLOOK.COM',
        phone: '3017684730'
    },
    SMMD14: {
        name: 'Zhicheng Lai',
        address: '1335 Rockville Pike Ste 350',
        city: 'Rockville',
        state: 'MD',
        zip: '20852',
        email: 'zhicheng.lai@gmail.com',
        phone: '2407809145'
    },
    SMMD15: {
        name: 'Topgrade Insurance',
        address: '5764 Stevens forest #224',
        city: 'Columbia',
        state: 'Md',
        zip: '21045',
        email: 'Topgradeins@gmail.com',
        phone: '4438896439'
    },
    SMMD16: {
        name: 'LISBON INSURANCE GROUP LLC',
        address: '2505 AMBER ORCHARD COURT UNIT 103',
        city: 'ODENTON',
        state: 'MD',
        zip: '21113',
        email: 'rodneybrewer32@gmail.com',
        phone: '4102940681'
    },
    SMMD17: {
        name: 'J. Coleman Insurance Group, LLC',
        address: '9693 Gerwig Lane',
        city: 'Columbia',
        state: 'MD',
        zip: '21046',
        email: 'Jcoleman@colemaninsurancegp.com',
        phone: '(301) 329-1258'
    },
    SMMD18: {
        name: 'DLB Insurance Services, LLC',
        address: '8416 Mountain Laurel Rd',
        city: 'Boonsboro',
        state: 'MD',
        zip: '21734',
        email: 'dara@dlbinsuranceservices.com',
        phone: '240-673-6042'
    },
    SMMD19: {
        name: 'Time Insurance',
        address: '6103 Baltimore avenue ste 203',
        city: 'Riverdale',
        state: 'MD',
        zip: '20737',
        email: 'timeinsurance@gmail.com',
        phone: '3012136442'
    },
    SMMD20: {
        name: 'Onetrust Insurance Group',
        address: '10630 Little Patuxent Pkwy Suite 224K',
        city: 'Columbia',
        state: 'MD',
        zip: '21044',
        email: 'ngrant@one-trustins.com',
        phone: '(240) 583-7800'
    },
    SMMD21: {
        name: 'Shelleys Insurance Agency, Inc',
        address: '11812 Edmont Pl',
        city: 'Waldorf',
        state: 'MD',
        zip: '20601',
        email: 'shelleysinsurance2@verizon.net',
        phone: '301-574-5233'
    },
    SMMD22: {
        name: 'NIKO DI GIULIO INSURANCE AGENCY LLC',
        address: '16644 GEORGIA AVE',
        city: 'OLNEY',
        state: 'MD',
        zip: '20832',
        email: 'NIKO@NDSOLUTIONS4INSURANCE.COM',
        phone: '301-924-4252'
    },
    SMMD23: {
        name: 'Mauro Group LLC',
        address: '8118 Woodmont Ave',
        city: 'Bethesda',
        state: 'MD',
        zip: '20814',
        email: 'joe@Migdmvg.com',
        phone: '3015931793'
    },
    SMMD24: {
        name: 'New Era Insurance',
        address: '8204 Fenton St Suite 205',
        city: 'Silver Spring',
        state: 'MD',
        zip: '20910',
        email: 'info@newerainsuranceagency.com',
        phone: '240-670-7733'
    },
    SMMD25: {
        name: 'Devi Dhakal',
        address: '7401 Cedar Grove Lane',
        city: 'Elkridge',
        state: 'MD',
        zip: '21075',
        email: 'devi_dhakal@yahoo.com',
        phone: '443-851-3041'
    },
    SMMD26: {
        name: 'Alfa Insurance Agency, Inc.',
        address: '8313 Governors Run',
        city: 'Ellicott City',
        state: 'MD',
        zip: '21043',
        email: 'lbhatti9@gmail.com',
        phone: '443-618-4232'
    },
    SMMD27: {
        name: 'Brown Insurance Group',
        address: '12118 HERITAGE PARK CIRCLE',
        city: 'SILVER SPRING',
        state: 'MD',
        zip: '20906',
        email: 'WINSTON@BROWNINSURANCEGROUP.COM',
        phone: '3019335500'
    },
    SMOH1: {
        name: 'T.A. Swain Insurance Agency',
        address: '260 S State St #906',
        city: 'Westerville',
        state: 'OH',
        zip: '43086',
        email: 'travis@taswain.com',
        phone: '614-224-1329'
    },
    SMOH2: {
        name: 'Woodcox Insurance Agency',
        address: '431 Ohio Pike #134',
        city: 'Cincinnati',
        state: 'OH',
        zip: '45255',
        email: 'gwoodcox@gmail.com',
        phone: '513-528-9717'
    },
    SMOH3: {
        name: 'Glowyne Financial Services LLC',
        address: '6556 Centennial Dr',
        city: 'Reynoldsburg',
        state: 'OH',
        zip: '43068',
        email: 'gloria@glowynefinancialservices.com',
        phone: '614-256-3633'
    },
    SMOH4: {
        name: 'Taylor & Associates Insurance Agency',
        address: '221 N. Commerce St',
        city: 'Lewisburg',
        state: 'OH',
        zip: '45338',
        email: 'bill@tayloragy.com',
        phone: '937-533-7000'
    },
    SMOH5: {
        name: 'Platinum Insurance Agency LLC',
        address: '131 Harding Way East',
        city: 'Galion',
        state: 'OH',
        zip: '44833',
        email: 'mmountsinsurance@gmail.com',
        phone: '419-512-0322'
    },
    SMOH6: {
        name: 'Melting Pot Insurance LLC',
        address: '592 Prairie Rose Dr.',
        city: 'Perrysburg',
        state: 'OH',
        zip: '43613',
        email: 'caitlyn@mpinsllc.com',
        phone: '740-319-1227'
    },
    SMOH7: {
        name: 'Platinum Insurance, LLC',
        address: '7200 Center St Ste 328',
        city: 'Mentor',
        state: 'OH',
        zip: '44060',
        email: 'joe@contactplatinum.com',
        phone: '440-339-5370'
    },
    SMOH8: {
        name: 'NRF Holdings LLC',
        address: '890 Laurel Green Dr.',
        city: 'North Canton',
        state: 'OH',
        zip: '44720',
        email: 'hofcity5@gmail.com',
        phone: '440-263-2071'
    },
    SMOH9: {
        name: 'Damion J Ware',
        address: '33 W Salome Ave',
        city: 'Akron',
        state: 'OH',
        zip: '44310',
        email: 'damion@revitalizefinancial.org',
        phone: '330-690-8839'
    },
    SMOH10: {
        name: 'Mark A Inman',
        address: '343 W Bagley Rd. Ste 203',
        city: 'Berea',
        state: 'OH',
        zip: '44017',
        email: 'minman_1@msn.com',
        phone: '440-243-4844'
    },
    SMOH11: {
        name: 'Nathan Johnson',
        address: '517 Trebisky Rd.',
        city: 'Richmond Heights',
        state: 'OH',
        zip: '44143',
        email: 'natejohnsonleads@gmail.com',
        phone: '770-500-6498'
    },
    SMOH12: {
        name: 'Agency Associates, Inc.',
        address: '5634 Broadway Ave',
        city: 'Cleveland',
        state: 'OH',
        zip: '44127',
        email: 'agencyassociatesinc@gmail.com',
        phone: '440-725-0987'
    },
    SMOH13: {
        name: 'Integra Insurance Solutions LLC',
        address: '175 S 3rd St Ste 200',
        city: 'Columbus',
        state: 'OH',
        zip: '43215',
        email: 'james@integrainsagency.com',
        phone: '614-843-1188'
    },
    SMOH14: {
        name: 'Ziskowski Insurance, LLC',
        address: '19 N. Center St. Ste 302',
        city: 'Pickerington',
        state: 'OH',
        zip: '43147',
        email: 'pete@zap-ins.com',
        phone: '614-961-6079'
    },
    SMOH15: {
        name: 'Traxler Insurance Agency',
        address: '207 S Myrtle Ave.',
        city: 'Willard',
        state: 'OH',
        zip: '44890',
        email: 'traxler19@gmail.com',
        phone: '419-744-0379'
    },
    SMOH16: {
        name: 'Oxford Risk, LLC',
        address: '83 North Miller Rd',
        city: 'Fairlawn',
        state: 'OH',
        zip: '44333',
        email: 'jkahoe@oxfordriskllc.com',
        phone: '330-523-9590'
    },
    SMOH17: {
        name: 'Sherri Mamounis',
        address: '2650 San Pedro Dr.',
        city: 'Youngstown',
        state: 'OH',
        zip: '44511',
        email: 'independentagent1082@gmail.com',
        phone: '330-942-1773'
    },
    SMOH18: {
        name: 'Isaam Jaafar',
        address: '7897 Kirkby Ct 3D',
        city: 'Columbus',
        state: 'OH',
        zip: '43085',
        email: 'jaafarissam5@gmail.com',
        phone: '614-966-1049'
    },
    SMOH19: {
        name: 'Resource One Insurance, LLC',
        address: '3388 Center Ridge Rd',
        city: 'North Ridgeville',
        state: 'OH',
        zip: '44039',
        email: 'dan@r1insure.com',
        phone: '440-454-9898'
    },
    SMOH20: {
        name: 'Happy Insurance Agency LLC',
        address: '2021 E Dublin Granville Rd Ste 273',
        city: 'Columbus',
        state: 'OH',
        zip: '43229',
        email: 'happyinsurance111@gmail.com',
        phone: '614-377-8697'
    },
    SMOH21: {
        name: 'Houston Insurance Services LLC',
        address: '53 Ridge Dr.',
        city: 'Fairfield',
        state: 'OH',
        zip: '45014',
        email: 'merlehouston@live.com',
        phone: '330-208-6518'
    },
    SMOH22: {
        name: 'Scott Mitchell Insurance Agency LLC',
        address: '1300 Buckingham Gate Blvd',
        city: 'Cuyahoga Falls',
        state: 'OH',
        zip: '44221',
        email: 'scott@smitchellagency.com',
        phone: '330-255-8717'
    },
    SMOH23: {
        name: 'AEZ Affordable',
        address: '68 E Tallmadge Ave',
        city: 'Akron',
        state: 'OH',
        zip: '44310',
        email: 'daniel@aezaffordableinsurance.com',
        phone: '330-606-7170'
    },
    SMOH24: {
        name: 'Meridian Insurance & Financial Group LLC',
        address: '81 Mill St Ste 135',
        city: 'Gahanna',
        state: 'OH',
        zip: '43230',
        email: 'william.turner@meridianifg.com',
        phone: '614-332-1952'
    },
    SMOH25: {
        name: 'Accumen Financial LLC',
        address: '1414 South Green Rd Ste 203',
        city: 'South Euclid',
        state: 'OH',
        zip: '44121',
        email: 'accumenfinancial@gmail.com',
        phone: '216-929-8512'
    },
    SMOH26: {
        name: 'Debra A Tingler',
        address: '18272 Jefferson Dr.',
        city: 'Walton Hills',
        state: 'OH',
        zip: '44146',
        email: 'debra@tinglerinsurancegroup.com',
        phone: '216-469-2876'
    },
    SMOH27: {
        name: 'N C Nikolaides Insurance Agency Inc',
        address: '504 Elm Rd NE',
        city: 'Warren',
        state: 'OH',
        zip: '44483',
        email: 'nikolaidesinsurance@gmail.com',
        phone: '330-856-3699'
    },
    SMOH28: {
        name: 'Bussell Insurance Company',
        address: '8409 Granite St',
        city: 'Wheelersburg',
        state: 'OH',
        zip: '45694',
        email: 'bussell7@hotmail.com',
        phone: '740-352-7924'
    },
    SMOH29: {
        name: 'The Willowick Agency',
        address: '31803 Vine St',
        city: 'Willowick',
        state: 'OH',
        zip: '44095',
        email: 'brandi@petroneagency.com',
        phone: '440-622-9803'
    },
    SMOH30: {
        name: 'Aato Insurance Agency LLC',
        address: '5659 Emporium Sq.',
        city: 'Columbus',
        state: 'OH',
        zip: '43231',
        email: 'yassin@aatoinsurance.com',
        phone: '614-822-0737'
    },
    SMOH31: {
        name: 'Rutherford Insurance Agency',
        address: '4100 Executive Park Suite 220',
        city: 'Cincinnati',
        state: 'OH',
        zip: '45241',
        email: 'tim@rutherfordinsagency.com',
        phone: '5134523699'
    },
    SMOH32: {
        name: 'Stuart Smith Insurance Agency',
        address: '4601 State Route 43',
        city: 'Kent',
        state: 'OH',
        zip: '44240',
        email: 'smithagency4601@yahoo.com',
        phone: '330-328-1491'
    },
    SMOH33: {
        name: 'Capital Insurance Group, LLC',
        address: '2016 W Washington St',
        city: 'Charleston',
        state: 'WV',
        zip: '25302',
        email: 'don@cigwv.com',
        phone: '304-610-8938'
    },
    SMOH34: {
        name: 'MM Financial Group',
        address: '9150 S Hills Blvd Ste 200',
        city: 'Broadview Heights',
        state: 'OH',
        zip: '44147',
        email: 'mgonzalez@mmfingroup.com',
        phone: '440-731-0321'
    },
    SMOH35: {
        name: 'Bespoke Financial',
        address: '600 Superior Ave. Ste 1300',
        city: 'Celeveland',
        state: 'OH',
        zip: '44114',
        email: 'nguy@its-bespoke.com',
        phone: '216-712-9909'
    },
    SMOH36: {
        name: 'Kelle N Smith Agency, LLC',
        address: '1481 Warrensville Center',
        city: 'S. Euclid',
        state: 'OH',
        zip: '44121',
        email: 'kelle@kellesmith-insurance.com',
        phone: '216-965-9613'
    },
    SMOH37: {
        name: 'Marquita Lyles Insurance Agency LLC',
        address: '4365 Youngstown Rd Ste F',
        city: 'Warren',
        state: 'OH',
        zip: '44484',
        email: 'marquitalyles@icloud.com',
        phone: '330-646-6042'
    },
    SMOH38: {
        name: 'Carrion Insurance',
        address: '600 Broadway',
        city: 'Lorain',
        state: 'OH',
        zip: '44052',
        email: 'tim@timcarrion.com',
        phone: '440-258-9968'
    },
    SMOH39: {
        name: 'Kane Insurance Co',
        address: '2002 Lindbergh Ave',
        city: 'Cuyahoga Falls',
        state: 'OH',
        zip: '44223',
        email: 'bkane1014@yahoo.com',
        phone: '330-701-5582'
    },
    SMOH40: {
        name: 'Denise Jeffery',
        address: '8809 Concord Dr.',
        city: 'Westfield Center',
        state: 'OH',
        zip: '44251',
        email: 'djeffery_1@msn.com',
        phone: '330-242-2459'
    },
    SMOH41: {
        name: 'Robert Forrer',
        address: '10464 LaGrange Rd.',
        city: 'Elyria',
        state: 'OH',
        zip: '44035',
        email: 'forreragency@yahoo.com',
        phone: '440-865-5452'
    },
    SMOH42: {
        name: 'Elevate Insurance',
        address: '4220 State Route 141',
        city: 'Ironton',
        state: 'OH',
        zip: '45638',
        email: 'nate@elevateinsurancellc.com',
        phone: '740-646-8600'
    },
    SMOH43: {
        name: 'Solid Insurance Agency LLC',
        address: '986 Morse Rd.',
        city: 'Columbus',
        state: 'OH',
        zip: '43229',
        email: 'steve@solidinsurance.com',
        phone: '586-899-7504'
    },
    SMOH44: {
        name: 'Spirit Financial Services LLC',
        address: '333 Monroe St. NW',
        city: 'Massillon',
        state: 'OH',
        zip: '44647',
        email: 'lee@spiritfs.biz',
        phone: '330-806-2111'
    },
    SMOH45: {
        name: 'CL Insurance Services',
        address: '24 W Main St',
        city: 'West Jefferson',
        state: 'OH',
        zip: '43162',
        email: 'chockman26@gmail.com',
        phone: '614-843-9331'
    },
    SMOH46: {
        name: 'Rhino Insurance Group LLC',
        address: '7100 E Pleasant Valley Rd Ste 350',
        city: 'Independence',
        state: 'OH',
        zip: '44131',
        email: 'daniel.leslie@lfgro.com',
        phone: '330-697-8522'
    },
    SMOH47: {
        name: 'Ambassador Insurance Group LLC',
        address: '1715 Woodland St. Ne',
        city: 'Warren',
        state: 'OH',
        zip: '44483',
        email: 'dimitri@aigagency.net',
        phone: '330-219-8843'
    },
    SMOH48: {
        name: 'Harrell Insurance Group LLC',
        address: '301 Columbus St',
        city: 'Bedford',
        state: 'OH',
        zip: '44146',
        email: 'harrellinsurancegroup@gmail.com',
        phone: '216-256-6652'
    },
    SMOH49: {
        name: 'Chris Arnott Agency Inc.',
        address: '16519 St Clair Ave',
        city: 'East Liverpool',
        state: 'OH',
        zip: '43920',
        email: 'chris@arnottinsurance.com',
        phone: '330-843-3279'
    },
    SMOH50: {
        name: 'Rogers Insurance LLC',
        address: '7514 IRA Ave',
        city: 'Brooklyn',
        state: 'OH',
        zip: '44144',
        email: 'rogers.edward@outlook.com',
        phone: '216-548-1846'
    },
    SMOH51: {
        name: 'William M Rose',
        address: '619 5th St',
        city: 'Defiance',
        state: 'OH',
        zip: '43512',
        email: 'amanda.roseins@outlook.com',
        phone: '419-789-3447'
    },
    SMOH52: {
        name: 'Moral Insurance Agency',
        address: '6515 E Livingston Ave Ste B-6b',
        city: 'Reynoldsburg',
        state: 'OH',
        zip: '43068',
        email: 'karkiramesh295@gmail.com',
        phone: '380-900-2414'
    },
    SMOH53: {
        name: 'Key Insurance Group',
        address: '16600 W. Sprague Rd. Ste 270',
        city: 'Middleburg Hts',
        state: 'OH',
        zip: '44130',
        email: 'insinv@gmail.com',
        phone: '440-521-0188'
    },
    SMOH54: {
        name: 'Dwayne Webb',
        address: '16 N High St',
        city: 'Chillicothe',
        state: 'OH',
        zip: '45601',
        email: 'dw559805@ohio.edu',
        phone: '740-656-7012'
    },
    SMOH55: {
        name: 'Soteria Insurance LLC',
        address: '24800 Chargrin Blvd Ste 104',
        city: 'Beachwood',
        state: 'OH',
        zip: '44122',
        email: 'soteriaoh@gmail.com',
        phone: '440-477-7794'
    },
    SMOH56: {
        name: 'Pro Insurance Group',
        address: '100 Fernwood Rd',
        city: 'Winterville',
        state: 'OH',
        zip: '43953',
        email: 'vinsurance@gowithproinsurance.com',
        phone: '304-479-2928'
    },
    SMOH57: {
        name: 'Mclvor Insurance Ageny LLC',
        address: '17269 Long Meadow Trail',
        city: 'Chagrin Falls',
        state: 'OH',
        zip: '44023',
        email: 'courtmc_74@yahoo.com',
        phone: '440-279-8184'
    },
    SMOH58: {
        name: 'Aplus Insurance',
        address: '5400 Chester Ave',
        city: 'Cleveland',
        state: 'OH',
        zip: '44103',
        email: 'aplusinsuranceohio@att.net',
        phone: '440-853-3925'
    },
    SMOH59: {
        name: 'Paul Seamster Insurance, LLC',
        address: '439 Lemming Dr',
        city: 'Sunbury',
        state: 'OH',
        zip: '43074',
        email: 'colby.seamsterjr@paulseamsterinsurance.com',
        phone: '614-822-9723'
    },
    SMOH60: {
        name: 'The Heights Insurance Agency',
        address: '1401 Lincoln Rd',
        city: 'Grandview Heights',
        state: 'OH',
        zip: '43212',
        email: 'tiffany@theheightsinsuranceagency.com',
        phone: '(614) 546-8496'
    },
    SMOH61: {
        name: 'EZ2Insure LLC',
        address: '7050 Engle Rd #101',
        city: 'Middleburg Hts',
        state: 'OH',
        zip: '44130',
        email: 'laurap@ez2insure.org',
        phone: '440-396-5138'
    },
    SMOH62: {
        name: 'Rachel Gibson',
        address: '1097 Georgia Ave',
        city: 'Akron',
        state: 'OH',
        zip: '44306',
        email: 'gibson.rachel2021@gmail.com',
        phone: '330-431-1812'
    },
    SMOH63: {
        name: 'Bazemore-Abner Insurance Agency Inc',
        address: '800 Cross Pointe Dr. Ste F',
        city: 'Gahanna',
        state: 'OH',
        zip: '43230',
        email: 'derek@ba-ig.com',
        phone: '614-981-9707'
    },
    SMOH64: {
        name: 'Innovative Quotes and Financial Services',
        address: '25801 Drakefield Ave',
        city: 'Euclid',
        state: 'OH',
        zip: '44132',
        email: 'dianehutchins22@gmail.com',
        phone: '216-678-2653'
    },
    SMOH65: {
        name: 'Limes & Riffle, Independent Insurance Agents LLC',
        address: '8595 Beechmont Ave Ste 300',
        city: 'Cincinnati',
        state: 'OH',
        zip: '46256',
        email: 'dmannerino@lmr-insurance.com',
        phone: '513-910-7923'
    },
    SMOH66: {
        name: 'Carrington Financials LLC',
        address: '949 Diana Ave',
        city: 'Akron',
        state: 'OH',
        zip: '44307',
        email: 'carringtonfinancials@gmail.com',
        phone: '330-701-0806'
    },
    SMOH67: {
        name: 'Solid Direction Insurance Group',
        address: '828 Greenwood Ave',
        city: 'Akron',
        state: 'OH',
        zip: '44320',
        email: 'tomswoope@soliddirectioninsurance.com',
        phone: '330-906-0230'
    },
    SMOH68: {
        name: 'Remedy Insurance Agency, LLC',
        address: '411 N Section Ext',
        city: 'South Lebanon',
        state: 'OH',
        zip: '45065',
        email: 'cody@remedyinsuranceagency.com',
        phone: '513-223-3024'
    },
    SMOH69: {
        name: 'John Penca',
        address: '2092 Ayers Ave',
        city: 'Akron',
        state: 'OH',
        zip: '44313',
        email: 'johnpenca41@gmail.com',
        phone: '330-696-2278'
    },
    SMOH70: {
        name: 'John Kaparic',
        address: '6895 Carriage Hill Dr #E75',
        city: 'Brecksville',
        state: 'OH',
        zip: '44141',
        email: 'jkaparic@gmail.com',
        phone: '440-554-9932'
    },
    SMOH71: {
        name: 'Hurst International LLC',
        address: '930 Amherst Ave NE',
        city: 'Massillon',
        state: 'OH',
        zip: '44646',
        email: 'jackjr@hurstins.com',
        phone: '330-284-9696'
    },
    SMOH72: {
        name: 'E.A. Dorsey Insurance, LLC',
        address: '4807 Rockside Rd',
        city: 'Independence ',
        state: 'OH',
        zip: '44131',
        email: 'info@eadorseyinsurance.com',
        phone: '216-815-2119'
    },
    SMOH73: {
        name: 'S AND C INSURANCE AGENCY LLC',
        address: '6315 Pearl Rd Suite 207 ',
        city: 'Parma',
        state: 'Ohio',
        zip: '44130',
        email: 'SCLLC2020@YAHOO.COM',
        phone: '800-593-2461'
    },
    SMOH74: {
        name: 'Guardian Insurance Solutions',
        address: '1071 Fishinger Rd Suite 112',
        city: 'Columbus',
        state: 'OH',
        zip: '43221',
        email: 'jjustus@guardianinsuranceohio.com',
        phone: '6144517100'
    },
    SMOK: { name: 'Smart Choice Oklahoma Main', address: '', city: '', state: '', zip: '', email: '', phone: '' },
    SMOK1: {
        name: 'Collaboarative Insurance Solutions LLC',
        address: '10416 Greenbrier Pkwy Ste C',
        city: 'Oklahoma City ',
        state: 'OK',
        zip: '73159',
        email: 'jon@collabinsurance.com',
        phone: '4054134680'
    },
    SMPA: { name: 'Smart Choice Pennsylvania Main', address: '', city: '', state: '', zip: '', email: '', phone: '' },
    SMPA1: {
        name: 'STATEWIDE INSURANCE SOLUTIONS LLC',
        address: '230 FERRY ST #106',
        city: 'EASTON',
        state: 'PA',
        zip: '18044',
        email: 'STATEWIDEAGENT@GMAIL.COM',
        phone: '570 242 4983'
    },
    SMPA2: {
        name: 'Frederick Waller',
        address: '2938 Columbia Ave Unit 1101',
        city: 'Lancaster',
        state: 'PA',
        zip: '17603',
        email: 'fredwaller@hotmail.com',
        phone: '7173811018'
    },
    SMPA3: {
        name: 'HENRY SON',
        address: '1000 W. RITNER ST',
        city: 'Philadelphia',
        state: 'PA',
        zip: '19148',
        email: 'HENRYSONAGENCY@OUTLOOK.COM',
        phone: '2156946000'
    },
    SMPA4: {
        name: 'Enan tax & insurance inc',
        address: '223 S 69TH ST',
        city: 'UPPER DARBY',
        state: 'PA',
        zip: '19082',
        email: 'Enaantax@gmail.com',
        phone: '2677216559'
    },
    SMPA5: {
        name: 'Independent Insurance Assoc, Inc',
        address: '531 N Center Ave Suite 104',
        city: 'Somerset',
        state: 'PA',
        zip: '15501',
        email: 'tjs@indins.net',
        phone: '814-233-4553'
    },
    SMPA6: {
        name: 'Tailored Insurance Solutions LLC',
        address: '409 E Market St',
        city: 'Perkasie',
        state: 'PA',
        zip: '18944',
        email: 'dale@tailoredinsurance.solutions',
        phone: '2157687912'
    },
    SMPA7: {
        name: 'REMCO INSURANCE SERVICES INC',
        address: '44 SECOND STREET PIKE SUITE 8',
        city: 'SOUTHAMPTON',
        state: 'PA',
        zip: '18966',
        email: 'MARC@REMCOINSURANCESERVICES.COM',
        phone: '2155289581'
    },
    SMPA8: {
        name: 'Robert Francis Reilly',
        address: '61 North Grant St',
        city: 'Wilkes Barre',
        state: 'PA',
        zip: '18702',
        email: 'RReilly412@gmail.com',
        phone: '570 466 4458'
    },
    SMPA9: {
        name: 'ProVantage Insurance & Financial Services Inc',
        address: '206 Lakeside Park',
        city: 'Southampton',
        state: 'PA',
        zip: '18966',
        email: 'farrellssmith@gmail.com',
        phone: '215-378-1420'
    },
    SMPA10: {
        name: 'Wade Chabassol',
        address: '1100 5th Ave',
        city: 'Coraopolis',
        state: 'PA',
        zip: '15108',
        email: 'wchabassol@gmail.com',
        phone: '4122762222'
    },
    SMPA11: {
        name: 'Lou Simone Jr DBA LSI Agency',
        address: '319 Fairmount Ave',
        city: 'Blackwood',
        state: 'NJ',
        zip: '8012',
        email: 'lsi.agencypa@gmail.com',
        phone: '267-265-0329'
    },
    SMPA12: {
        name: 'Multi-Services of Berks County LLC',
        address: '549 Spring St',
        city: 'Reading',
        state: 'PA',
        zip: '19601',
        email: 'multiservicesofberkscounty@gmail.com',
        phone: '6108640884'
    },
    SMPA13: {
        name: 'ANTHONY GUERIERA JR INSURANCE AGENCY',
        address: '83 FIRST AVENUE',
        city: 'BROOMALL',
        state: 'PA',
        zip: '19008',
        email: 'AGUERIERA1@GMAIL.COM',
        phone: '610-368-4537'
    },
    SMPA14: {
        name: 'Pitman Insurance Services LLC',
        address: '72 Helfenstein Road',
        city: 'Pitman',
        state: 'PA',
        zip: '17964',
        email: 'brendar@pitmanins.com',
        phone: '5705094129'
    },
    SMPA15: {
        name: 'BETHLEHEM STAR INSURANCE AGENCY LLC',
        address: '602 W. BROAD ST',
        city: 'BETHLEHEM',
        state: 'PA',
        zip: '18018',
        email: 'BRENDA@BETHLEHEMSTARINSURANCE.COM',
        phone: '610-216-2553'
    },
    SMPA16: {
        name: 'Portonova Agency LLC',
        address: '801 Midland Ave',
        city: 'Midland',
        state: 'pa',
        zip: '15059',
        email: 'contactus@portonovaagencyllc.com',
        phone: '724-508-0481'
    },
    SMPA17: {
        name: 'A FOR THE PEOPLE INSURANCE AGENCY INC.',
        address: '2514 WYLIE AVE',
        city: 'PITTSBURGH',
        state: 'PA',
        zip: '15219',
        email: 'BILL@AFORTHEPEOPLE.COM',
        phone: '4126215581'
    },
    SMPA18: {
        name: 'CONEXION LATINA INVESTMENT SERVICES',
        address: '207 W KING ST',
        city: 'LANCASTER',
        state: 'PA',
        zip: '17603',
        email: 'CLIS2011@LIVE.COM',
        phone: '7173970139'
    },
    SMPA19: {
        name: 'LW Pocono Insurance Agency LLC',
        address: '100 W BROAD ST#118',
        city: 'HAZLETON',
        state: 'PA',
        zip: '18201',
        email: 'LWPOCONO@GMAIL.COM',
        phone: '5704974099'
    },
    SMPA20: {
        name: 'S Sellitto Insurance LLC d/b/a My Insurance People',
        address: '633 Long Run Rd, Suite 100',
        city: 'McKeesport',
        state: 'PA',
        zip: '15132',
        email: 'scott@my-insurance-people.com',
        phone: '4128299500'
    },
    SMPA21: {
        name: 'OROGOL INSURANCE, INC.',
        address: '4815 Jonestown Rd Ste 202',
        city: 'Harrisburg',
        state: 'PA',
        zip: '17109',
        email: 'kpo@orogol.com',
        phone: '717-610-0550'
    },
    SMPA22: {
        name: 'C G LAUGHLIN & ASSOCIATES LLC',
        address: '121 E LANCASTER AVE',
        city: 'PAOLI',
        state: 'PA',
        zip: '19301',
        email: 'cglinsurance@comcast.net',
        phone: '484-318-7551'
    },
    SMPA23: {
        name: 'National Advisors Group, LLC',
        address: '52 E. Swedesford Road, Suite 100',
        city: 'Malvern',
        state: 'PA',
        zip: '19355',
        email: 'brandonw@naginsure.com',
        phone: '888-766-7844'
    },
    SMPA24: {
        name: 'Keith Jackson',
        address: '2614 W Master St',
        city: 'Philadelphia',
        state: 'PA',
        zip: '19121',
        email: 'keith@keithjackson.net',
        phone: '215-923-1224'
    },
    SMPA25: {
        name: 'Prosperity Industries',
        address: '36 N 3rd St, 1st Floor',
        city: 'Philadelphia',
        state: 'PA',
        zip: '19106',
        email: 'kirk@prosperityreis.com',
        phone: '(215) 515-7761'
    },
    SMRT1: {
        name: 'Smart Insured Solutions, LLC',
        address: '2727 LBJ Freeway, Ste # 730',
        city: 'Dallas',
        state: 'TX',
        zip: '75234',
        email: 'ttran@SmartInsured.pro',
        phone: '(214) 856-8621'
    },
    SMTX1: {
        name: 'Smart Choice Partners - TX LLC',
        address: '24618 Kingsland Blvd',
        city: 'Katy',
        state: 'TX',
        zip: '77494',
        email: 'apayne@smartchoicepartnerstx.com',
        phone: '713-702-3408'
    },
    SMTX2: {
        name: 'Deena Sukenik dba The Sukenik Agency',
        address: '6893 Cortona Ln',
        city: 'Frisco',
        state: 'TX',
        zip: '75034',
        email: 'deena@thesukenikagency.com',
        phone: '214-673-7888'
    },
    SMTX3: {
        name: 'Options Insurance Group LLC',
        address: '4099 McEwen Rd Ste 576',
        city: 'Dallas',
        state: 'TX',
        zip: '75244',
        email: 'paul@oigtexas.com',
        phone: '469-509-2946'
    },
    SMTX4: {
        name: 'ITO P&C Inc.',
        address: '2311 Texas Drive Ste 100',
        city: 'Irving',
        state: 'TX',
        zip: '75062',
        email: 'wjvacek@insteam1.com',
        phone: '469-450-2656'
    },
    SMTX5: {
        name: 'Kristin Wilks dba Family First Insurance Group of Texas',
        address: '610 Uptown Blvd Ste 2000',
        city: 'Cedar Hill',
        state: 'TX',
        zip: '75104',
        email: 'kristin@ffigtx.com',
        phone: '682-367-0256'
    },
    SMTX6: {
        name: 'Tans Agency',
        address: '6921 Indepdendence Pky #210',
        city: 'Plano',
        state: 'TX',
        zip: '75023',
        email: 'sales@tansagency.com',
        phone: '972-510-5346'
    },
    SMTX7: {
        name: 'The Insurance Shop LLC',
        address: '4711 Old Bullard Rd',
        city: 'Tyler',
        state: 'TX',
        zip: '75703',
        email: 'alex@insuranceshoptx.com',
        phone: '903-780-1914'
    },
    SMTX8: {
        name: 'MGA Insurance Group LLC',
        address: '2765 E Trinity Mills Rd Ste 203',
        city: 'Carrollton',
        state: 'TX',
        zip: '75006',
        email: 'mgonzales@mgainsgrp.com',
        phone: '214-613-4050'
    },
    SMTX9: {
        name: "Cassie's Hometown Broker Services LLC",
        address: '225 Modene Avenue',
        city: 'Waxahachie',
        state: 'TX',
        zip: '75165',
        email: 'hometwnins@gmail.com',
        phone: '469-245-8346'
    },
    SMTX10: {
        name: 'DW Insurance & Financial Services',
        address: '5050 Collin McKinney Pkwy, Ste 204',
        city: 'McKinney',
        state: 'TX',
        zip: '75070',
        email: 'info@dwinsuranceagency.com',
        phone: '469-415-2278'
    },
    SMTX11: {
        name: 'Sierra Insurance Agency Corp',
        address: '207 W. Hickory St, Ste 205',
        city: 'Denton',
        state: 'TX',
        zip: '76201',
        email: 'sierraagency@hotmail.com',
        phone: '940-367-0542'
    },
    SMTX12: {
        name: 'Texas Heartland Insurance Services LLC',
        address: '187 Kirkham Circle #C',
        city: 'Kyle',
        state: 'TX',
        zip: '78640',
        email: 'elaine.texasheartland@gmail.com',
        phone: '210-483-0928'
    },
    TATUM1: {
        name: 'TATUM INSURANCE AGENCY, LLC',
        address: '5200 BUFFALO GAP RD',
        city: 'ABILENE',
        state: 'TEXAS',
        zip: '79606',
        email: 'LISA@TATUMINSURANCEGROUP.COM',
        phone: '325-695-5200'
    },
    TATUM2: {
        name: 'TATUM INSURANCE AGENCY, LLC',
        address: '5200 BUFFALO GAP RD',
        city: 'ABILENE',
        state: 'TEXAS',
        zip: '79606',
        email: 'JOHNAUSTIN@TATUMINSURANCEGROUP.COM',
        phone: '325-695-5200'
    },
    TATUM3: {
        name: 'TATUM INSURANCE AGENCY, LLC',
        address: '5200 BUFFALO GAP RD',
        city: 'ABILENE',
        state: 'TEXAS',
        zip: '79606',
        email: 'MICHAELYOUNG@TATUMINSURANCEGROUP.COM',
        phone: '325-695-5200'
    },
    TBDS1: {
        name: 'Tisha Brandes Insurance Services LLC',
        address: '4961 Long Prairie Rd #140',
        city: 'Flower Mound',
        state: 'TX',
        zip: '75028',
        email: 'tisha@brandesagency.com',
        phone: '972-481-1027'
    },
    SMTX13: {
        name: 'Scott A Phillips Enterprises Inc.',
        address: '2220 San Jacinto Blvd, Ste 101',
        city: 'Denton',
        state: 'TX',
        zip: '76205',
        email: 'scott@phillipsins.com',
        phone: '214-695-3137'
    },
    SMTX14: {
        name: 'Hillcrest Insurance Group',
        address: '5700 Tennyson Pkwy Ste 300',
        city: 'Plano',
        state: 'TX',
        zip: '75024',
        email: 'ray@thehillcrestins.com',
        phone: '972-750-1134'
    },
    SMTX15: {
        name: 'Top Gun Insurance Group Inc',
        address: '2002 S. Stemmons Freeway',
        city: 'Lake Dallas',
        state: 'TX',
        zip: '75065',
        email: 'info@mytopgunins.com',
        phone: '940-498-7111'
    },
    SMTX16: {
        name: 'John M Brown Insurance Agency Inc.',
        address: '363 N Sam Houston Pkwy E Ste 1100',
        city: 'Houston',
        state: 'TX',
        zip: '77060',
        email: 'info@farmerbrown.com',
        phone: '312-771-0500'
    },
    SMTX17: {
        name: 'iSURE Insurance Agency LLC',
        address: '4099 McEwen Rd Ste 620',
        city: 'Farmers Branch',
        state: 'TX',
        zip: '75244',
        email: 'info@isureagency.com',
        phone: '972-677-7141'
    },
    SMTX18: {
        name: 'Tom Hoang',
        address: '821 Grand Ave Pkwy #401D',
        city: 'Pflugerville',
        state: 'TX',
        zip: '78660',
        email: 'tomhoang888@gmail.com',
        phone: '512-970-9264'
    },
    SMTX19: {
        name: 'Big State Insurance Agency Inc.',
        address: '104 W Main St',
        city: 'Grand Priaire',
        state: 'TX',
        zip: '75050',
        email: 'a.rodriguez@bigstateinsuranceagency.com',
        phone: '469-999-3985'
    },
    SMTX20: {
        name: 'Brandon Weber dba The Weber Agency Insurance & Risk Solutions',
        address: '11754 Jollyville Rd Ste 100',
        city: 'Austin',
        state: 'TX',
        zip: '78759',
        email: 'brandon@webersite.com',
        phone: '512-963-8000'
    },
    SMTX21: {
        name: 'Katrina Lee dba Legacy Insurance',
        address: '2014 Hobart St.',
        city: 'Pampa',
        state: 'TX',
        zip: '79065',
        email: 'katrina@legacy-ins.com',
        phone: '806-662-7296'
    },
    SMTX22: {
        name: 'Young Insurance Services',
        address: '227 CR 3610',
        city: 'Lovelady',
        state: 'TX',
        zip: '75851',
        email: 'jhyoungfinancial@gmail.com',
        phone: '903-574-0628'
    },
    SMTX23: {
        name: 'Leon Martin Insurance Agency PC',
        address: '3108 Gilmer Rd',
        city: 'Longview',
        state: 'TX',
        zip: '75640',
        email: 'martinagency@att.net',
        phone: '903-720-5975'
    },
    SMTX24: {
        name: 'Benjamin Jia dba Silverlight Insurance',
        address: '1709 Faringdon Dr.',
        city: 'Plano',
        state: 'TX',
        zip: '75075',
        email: 'siadfwgroup@gmail.com',
        phone: '469-600-9231'
    },
    SMTX25: {
        name: 'Addax Investments LLC',
        address: '921 Lake Air Drive',
        city: 'Waco',
        state: 'TX',
        zip: '76710',
        email: 'adam@addaxinsurance.com',
        phone: '254-366-0197'
    },
    SMTX26: {
        name: 'Alisha Bertron',
        address: '5796 E SH 114 Suite A',
        city: 'Haslet',
        state: 'TX',
        zip: '76052',
        email: 'alisha.bertron@outlook.com',
        phone: '940-399-8205'
    },
    SMTX27: {
        name: 'Sunflower Insurance Agency',
        address: '1847 N Garland Ave',
        city: 'Garland',
        state: 'TX',
        zip: '75040',
        email: 'kduongins@gmail.com',
        phone: '469-596-0766'
    },
    SMTX28: {
        name: 'Orlando Williams dba Better Insurance Servicers',
        address: '675 Town Square Suite 200 Building A',
        city: 'Garland',
        state: 'TX',
        zip: '75040',
        email: 'orlando@betterinsuranceservices.com',
        phone: '972-639-8004'
    },
    SMTX29: {
        name: 'David Crabtree dba Swyft Insurance',
        address: '229 East Main Street',
        city: 'Gun Barrel City',
        state: 'TX',
        zip: '75156',
        email: 'swyftinsurance@gmail.com',
        phone: '469-258-3616'
    },
    SMTX30: {
        name: 'ASM Insurance Agency LLC',
        address: '5 Juniper Circle',
        city: 'Holliday',
        state: 'TX',
        zip: '76366',
        email: 'asm0626llc@gmail.com',
        phone: '940-867-7505'
    },
    SMTX31: {
        name: 'P&C Insurance Agency LLC',
        address: '10901 N Lamar Blvd Ste D407',
        city: 'Austin',
        state: 'TX',
        zip: '78753',
        email: 'familyagent14@gmail.com',
        phone: '512-508-0780'
    },
    SMTX32: {
        name: 'George J Hinkle',
        address: '4701 Alta Mesa Blvd Ste 1A',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76133',
        email: 'georgehinkle_554@hotmail.com',
        phone: '817-370-1352'
    },
    SMTX33: {
        name: 'Valerie Rodriquez',
        address: '917 S Abe Ste A6',
        city: 'San Angelo',
        state: 'TX',
        zip: '76903',
        email: 'bestins@suddenlinkmail.com',
        phone: '325-374-6709'
    },
    SMTX34: {
        name: 'Anthony Hernandez Jr. Insurance and Financial Services',
        address: '201 S Lakeline Blvd Sutie 104',
        city: 'Cedar Park',
        state: 'TX',
        zip: '78613',
        email: 'anthony@insurecedarpark.com',
        phone: '512-364-9636'
    },
    SMTX35: {
        name: 'Christy A Fernandez dba Christy Fernandez Agency',
        address: '9101 Dyer Ste 203',
        city: 'El Pase',
        state: 'TX',
        zip: '79924',
        email: 'christyfdz1964@gmail.com',
        phone: '915-613-2116'
    },
    SMTX36: {
        name: 'Natalie Resendez dba Diamante Insurance',
        address: '817 W Jefferson ST',
        city: 'Grand Priaire',
        state: 'TX',
        zip: '75051',
        email: 'natcip9501@gmail.com',
        phone: '469-531-6800'
    },
    SMTX37: {
        name: 'Nina Dayalji dba Dayalji Insurance Agency',
        address: '2304 Bardin Rd.',
        city: 'Grand Priaire',
        state: 'TX',
        zip: '75054',
        email: 'ninadayalji@gmail.com',
        phone: '972-836-9546'
    },
    SMTX38: {
        name: 'Ian Bertini dba BPI Insurance Agency',
        address: '1311 Cadley Ct',
        city: 'San Antonio',
        state: 'TX',
        zip: '78209',
        email: 'professor@bpi-agency.com',
        phone: '210-317-6162'
    },
    SMTX39: {
        name: 'Stephen Platt dba Texas Insurance Options',
        address: '5400 Preston Oaks Rd #1040',
        city: 'Dallas',
        state: 'TX',
        zip: '75254',
        email: 'stephen@texasinsuranceoptions.net',
        phone: '214-229-1382'
    },
    SMTX40: {
        name: 'Elizabeth Miller dba Liz Miller Agency',
        address: '2600 S Shore Blvd. Ste 300',
        city: 'League City',
        state: 'TX',
        zip: '77573',
        email: 'liz@lizmilleragency.com',
        phone: '832-799-8430'
    },
    SMTX41: {
        name: 'Guy Luna Insurance Agency',
        address: '552 W I30 Ste 317',
        city: 'Garland',
        state: 'TX',
        zip: '75043',
        email: 'deb@glinsurance.com',
        phone: '972-613-4911'
    },
    SMTX42: {
        name: 'Ruby A. Hill',
        address: '1200 Goldne Key Circle Ste 214',
        city: 'El Paso',
        state: 'TX',
        zip: '79925',
        email: 'rahill21@yahoo.com',
        phone: '915-472-9779'
    },
    SMTX43: {
        name: 'Benvie Group LLC',
        address: '6902 Kingsford Gable Ct',
        city: 'Richmond',
        state: 'TX',
        zip: '77407',
        email: 'elize.martinez@beneviegroup.com',
        phone: '832-947-3808'
    },
    SMTX44: {
        name: 'Armando Martinez dba Martinez Insurance Agency',
        address: '1620 South Chadbourne',
        city: 'San Angelo',
        state: 'TX',
        zip: '76903',
        email: 'martinezins@yahoo.com',
        phone: '325-374-1593'
    },
    SMTX45: {
        name: 'Oakridge Insurance Agency LLC',
        address: '1424 Berline Lane',
        city: 'Austin',
        state: 'TX',
        zip: '78753',
        email: 'andy@oakridgeagency.com',
        phone: '848-702-7672'
    },
    SMTX46: {
        name: 'Sherry Lou Stapleton dba Rod Whidon Insurance Agency',
        address: '400 E Wheatland RD #A',
        city: 'Duncanville',
        state: 'TX',
        zip: '75137',
        email: 'sherry.rodwhiddonins@yahoo.com',
        phone: '972-977-5957'
    },
    SMTX47: {
        name: 'Jared Obregon dba Cowboy Insurance Agency',
        address: '7916 Spring Valley Rd.',
        city: 'Dallas',
        state: 'TX',
        zip: '75254',
        email: 'jared@cowboyins.com',
        phone: '469-951-6520'
    },
    SMTX48: {
        name: 'Shearer Insurance Services LLC',
        address: '16855 Gresham Circle Ste E',
        city: 'Flint',
        state: 'TX',
        zip: '75762',
        email: 'donna@txsis.com',
        phone: '903-534-5454'
    },
    SMTX49: {
        name: 'Jonthan Williams',
        address: '147 Fieldview Dr.',
        city: 'Crandall',
        state: 'TX',
        zip: '75114',
        email: 'jwilliams2018@gmail.com',
        phone: '214-629-9348'
    },
    SMTX50: {
        name: 'William Howard Fortney dba Fortney Insurance Agency',
        address: '270 Shady Oaks Drive',
        city: 'Mineral Wells',
        state: 'TX',
        zip: '76067',
        email: 'whfortney@sbcglobal.net',
        phone: '940-859-9271'
    },
    SMTX51: {
        name: 'Irelsie Alvarez dba Castillo Insurance & Income Tax Service',
        address: '7116 Lake June Rd.',
        city: 'Dallas',
        state: 'TX',
        zip: '75217',
        email: 'trustcoinsurance@att.net',
        phone: '972-375-5870'
    },
    SMTX52: {
        name: 'Michele Henry Beltz dba Michele Henry Beltz',
        address: '13776 N Hwy 183, 107a',
        city: 'Austin',
        state: 'TX',
        zip: '78750',
        email: 'michele@michelehenrybeltz.com',
        phone: '512-296-7160 '
    },
    SMTX53: {
        name: 'Greta James Maxfield',
        address: '1003 Elm St',
        city: 'Austin',
        state: 'TX',
        zip: '78703',
        email: 'gretajamesmaxfield@gmail.com',
        phone: '512-569-0499'
    },
    SMTX54: {
        name: 'BKM Insurance Agency LLC',
        address: '11111 Katy Fwy Ste 910',
        city: 'Houston',
        state: 'TX',
        zip: '77079',
        email: 'buddi@bmckenzieins.com',
        phone: '409-673-9162'
    },
    SMTX55: {
        name: 'Adam Jasien dba Jasien Insurance',
        address: '5022 Old Railroad Trail',
        city: 'Kaufman',
        state: 'TX',
        zip: '75142',
        email: 'ajasien@jasieninsurance.com',
        phone: '972-816-0868'
    },
    SMTX56: {
        name: 'Roberta Godwin',
        address: '5345 Rendon Rd.',
        city: 'Ft Worth',
        state: 'TX',
        zip: '76140',
        email: 'deerhorninsurance@gmail.com',
        phone: '817-563-0707'
    },
    SMTX57: {
        name: 'Zhang Insurance & Financial Services',
        address: '2435 N. Centeral Expwy Ste 1100',
        city: 'Richardson',
        state: 'TX',
        zip: '75080',
        email: 'zhanginsu@gmail.com',
        phone: '469-666-1221'
    },
    SMTX58: {
        name: 'RSS Star Enterprise Inc.',
        address: '860 Hebron Pkwy Ste 702',
        city: 'Lewisville',
        state: 'TX',
        zip: '75057',
        email: 'rssstarinc@gmail.com',
        phone: '972-467-0104'
    },
    SMTX59: {
        name: 'K&K International Captial Corporation',
        address: '8240 Brashear Trail',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76120',
        email: 'pankaj@kandksolutions.com',
        phone: '817-382-9891'
    },
    SMTX60: {
        name: 'Jacqueline Patterson',
        address: '3214  N Peach Hollow Circle',
        city: 'Pearland',
        state: 'TX',
        zip: '77584',
        email: 'thirtyminsearly@gmail.com',
        phone: '713-370-2357'
    },
    SMTX61: {
        name: 'Harmony National',
        address: '6319 Cypresswodd Dr Ste A',
        city: 'Spring',
        state: 'TX',
        zip: '77379',
        email: 'lee@thepattersonagency.com',
        phone: '281-300-4631 '
    },
    SMTX62: {
        name: 'Sheila Williams',
        address: '210 W Houston',
        city: 'Cleveland',
        state: 'TX',
        zip: '77327',
        email: 'shewill_ins_agt@sbcglobal.net',
        phone: '281-381-5154'
    },
    SMTX63: {
        name: 'The Insurance Guys Brokerage LLC',
        address: '8000 IH 10 West Suite 675',
        city: 'San Antonio',
        state: 'TX',
        zip: '78230',
        email: 'r.madrid@theinsuranceguysllc.com',
        phone: '210-417-7666'
    },
    SMTX64: {
        name: 'Fernando M Almendariz dba Almendariz Insurance',
        address: '11701 Orsinger Lane',
        city: 'San Antonio',
        state: 'TX',
        zip: '478230',
        email: 'fernando@almendarizinsurance.com',
        phone: '210-669-1347'
    },
    SMTX65: {
        name: 'Skyline Insurance Agency',
        address: '3939 US Hwy 80 E Ste 412',
        city: 'Mesquite',
        state: 'TX',
        zip: '75150',
        email: 'skyline_ins@hotmail.com',
        phone: '214-679-4041'
    },
    SMTX66: {
        name: 'Darci Mclin',
        address: '3213 S Medford Dr. Ste 314',
        city: 'Lufkin',
        state: 'TX',
        zip: '75901',
        email: 'dmclin@mclininsuranceagency.com',
        phone: '936-671-0864'
    },
    SMTX67: {
        name: 'Bienvenido Insurance Services LLC',
        address: '251 S WW White Roard',
        city: 'San Antonio',
        state: 'TX',
        zip: '78219',
        email: 'admin@thesafelion.com',
        phone: '210-951-8639'
    },
    SMTX68: {
        name: 'Panther City Insurance Agency LLC',
        address: '4420 Country Hill Rd',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76140',
        email: 'noah@mymanrand.com',
        phone: '817-528-7559'
    },
    SMTX69: {
        name: 'Kalyangel LLC',
        address: '111 N Barry Ave Ste B',
        city: 'Dallas',
        state: 'TX',
        zip: '75214',
        email: 'lidia@expressinsurancedallas.com',
        phone: '214-827-6056'
    },
    SMTX70: {
        name: 'RCDG Enterprises',
        address: 'PO Box 72',
        city: 'Greenville',
        state: 'TX',
        zip: '75403',
        email: 'duane@thegauldenagency.com',
        phone: '469-757-4550'
    },
    SMTX71: {
        name: 'Zenith Brothers Agency LLC',
        address: '7316 Elm Grove Ln',
        city: 'Aubrey',
        state: 'TX',
        zip: '76227',
        email: 'jordan.broome@gmail.com',
        phone: '757-295-8456'
    },
    SMTX72: {
        name: 'Nashional Insurance',
        address: '5900 S Lake Forest Drive Ste 300',
        city: 'McKinney',
        state: 'TX',
        zip: '75070',
        email: 'jeff@nashionalfinancial.com',
        phone: '214-385-5945'
    },
    SMTX73: {
        name: 'Sheila Williams',
        address: '210 W Houston',
        city: 'Cleveland',
        state: 'TX',
        zip: '77327',
        email: 'shewill_ins_agt@sbcglobal.net ',
        phone: '281-381-5154 '
    },
    SMTX74: {
        name: 'Nhuy Insurance & Finance Agency LLC',
        address: '1140 E Pioneer Pkwy Ste 304',
        city: 'Arlington',
        state: 'TX',
        zip: '76010',
        email: 'pchinhnguyen@gmail.com ',
        phone: '972-897-3475'
    },
    SMTX75: {
        name: 'CW Insurance Agency LLC',
        address: '715 Lowell ',
        city: 'Dallas',
        state: 'TX',
        zip: '75214',
        email: 'd.williams@cwinsagency.com',
        phone: '214-865-6729'
    },
    SMTX76: {
        name: 'Insurance Source of Dallas',
        address: '888 S Greenville Ave Suite 140',
        city: 'Richardson',
        state: 'TX',
        zip: '75081',
        email: 'tamer@insdallas.com ',
        phone: '972-907-1100'
    },
    SMTX77: {
        name: 'Sergio Cruz dba Lowmans Insurance & Tax Services',
        address: '1425 Cardigan Ln',
        city: 'Lancaster',
        state: 'TX',
        zip: '75134',
        email: 'lowmasinsuranceagency@gmail.com ',
        phone: '214-208-2676'
    },
    SMTX78: {
        name: 'CN Group Insurance Services LLC',
        address: '1001 W Euless Blvd Ste 407',
        city: 'Euless',
        state: 'TX',
        zip: '76040',
        email: 'cninsurance407@gmail.com ',
        phone: '817-786-8041'
    },
    SMTX79: {
        name: 'Browning Insurance LLC',
        address: '1102 Ranch Rd Ste 212',
        city: 'Forney',
        state: 'TX',
        zip: '75126',
        email: 'browninginsurance@att.net',
        phone: '972-552-9100'
    },
    SMTX80: {
        name: 'Jason Corey Cooper dba Texas Commercial Insurance',
        address: '3211 Wagon Trail Dr. ',
        city: 'Denton',
        state: 'TX',
        zip: '76205',
        email: 'tcia.corey@gmail.com',
        phone: '833-427-2624 '
    },
    SMTX81: {
        name: 'John Paul Lewis dba Lewis Family Insurance Group',
        address: '5335 Bent Tree Forest Dr #225',
        city: 'Dallas',
        state: 'TX',
        zip: '75248',
        email: 'johnpaul@lewisfamilyinsurancegroup.com',
        phone: '972-213-3575'
    },
    SMTX82: {
        name: 'Valerie Banks',
        address: 'PO Box 813',
        city: 'Cedar Hill',
        state: 'TX',
        zip: '75106',
        email: 'amg.insure@gmail.com',
        phone: '214-228-9651'
    },
    SMTX83: {
        name: 'Robert McDonald dba McDonald Insurance & Tax Services',
        address: 'PO Box 1629 ',
        city: 'Converse',
        state: 'TX',
        zip: '78109',
        email: 'info@txpfs.com',
        phone: '(210) 267-1476'
    },
    SMTX84: {
        name: 'The Dinh Agency',
        address: '107 Westminister Ave',
        city: 'Murphy',
        state: 'TX',
        zip: '75094',
        email: 'nancydinh2003@gmail.com ',
        phone: '214-563-3613'
    },
    SMTX85: {
        name: 'Robert G. Brown dba The Brown Legacy Insurance',
        address: '2217 Turtle Mountain Bend',
        city: 'Austin',
        state: 'TX',
        zip: '78745',
        email: 'robert@brownlegacyinsurance.com ',
        phone: '512-800-1934'
    },
    SMTX86: {
        name: 'Dodi De Leon',
        address: '747 Kiser Ln',
        city: 'Marion',
        state: 'TX',
        zip: '78124',
        email: 'dodi@texas-covered.com ',
        phone: '210-860-7575'
    },
    SMTX87: {
        name: 'MAS Insurance',
        address: '4100 Spring Valley Rd Ste 925',
        city: 'Dallas',
        state: 'TX',
        zip: '75244',
        email: 'masinsurancedfw@gmail.com',
        phone: '214-455-5150'
    },
    SMTX88: {
        name: 'Nathan Harbison',
        address: '117 County Road 247A',
        city: 'Jasper',
        state: 'TX',
        zip: '75951',
        email: 'Nate@5starrco.com',
        phone: '559-499-6067'
    },
    SMTX89: {
        name: 'Anthony Reed',
        address: '14811 Green Valley Dr',
        city: 'Balch Springs',
        state: 'TX',
        zip: '75180',
        email: 'anthony@anthonyreedagent.com',
        phone: '214-418-8230'
    },
    SMTX90: {
        name: 'All Coverage Insurance',
        address: '6707 Rufe Snow Dr. #50 ',
        city: 'Watauga',
        state: 'TX',
        zip: '76148',
        email: 'allcoverageins@gmail.com',
        phone: '817-232-7875'
    },
    SMUN1: {
        name: 'Smart Uninversal Insurance',
        address: '312 N. Greenville Ave #300',
        city: 'Richardson',
        state: 'TX',
        zip: '75081',
        email: 'johnpham@smartuniversalinsurance.com',
        phone: '972-987-0893'
    },
    TAS: {
        name: 'Insuritas',
        email: 'dgrimson@insuritas.com'
    },
    TCP1: {
        name: 'The Coverage Pro',
        address: '7434 E Monte Cristo Ave',
        city: 'Scottsdale',
        state: 'AZ',
        zip: '85260',
        email: 'jeff@thecoveragepro.com',
        phone: '(602) 920-2851'
    },
    TEST: {
        name: 'Test Agency',
        address: '875 N High St',
        city: 'Columbus',
        state: 'OH',
        zip: '43215',
        email: 'agent@testagency.com',
        phone: '800-555-5555'
    },
    TEST1: {
        name: 'Test Agency',
        address: '875 N High St',
        city: 'Columbus',
        state: 'OH',
        zip: '43215',
        email: 'agent@testagency.com',
        phone: '800-555-5555'
    },
    TEST2: {
        name: 'Test Agency',
        address: '875 N High St',
        city: 'Columbus',
        state: 'OH',
        zip: '43215',
        email: 'agent@testagency.com',
        phone: '800-555-5555'
    },
    TEST3: {
        name: 'Test Agency',
        address: '875 N High St',
        city: 'Columbus',
        state: 'OH',
        zip: '43215',
        email: 'agent@testagency.com',
        phone: '800-555-5555'
    },
    TEST4: {
        name: 'Test Agency',
        address: '875 N High St',
        city: 'Columbus',
        state: 'OH',
        zip: '43215',
        email: 'agent@testagency.com',
        phone: '800-555-5555'
    },
    TEST5: {
        name: 'Test Agency',
        address: '875 N High St',
        city: 'Columbus',
        state: 'OH',
        zip: '43215',
        email: 'agent@testagency.com',
        phone: '800-555-5555'
    },
    TGS1: {
        name: 'TGS Insurance Agency',
        address: '5500 NW Central Drive',
        city: 'Houston',
        state: 'TX',
        zip: '77092',
        email: 'support@tgsinsruance.com',
        phone: '713-395-4442'
    },
    THRV1: {
        name: 'Thrive Insurance',
        address: '1110 Classen Dr. Suite M',
        city: 'Oklahoma City',
        state: 'OK',
        zip: '73103',
        email: 'chad@thrive.insurance',
        phone: '4052419697'
    },
    TOP: {
        name: 'The Oklahoma Producers Group, Inc.',
        address: 'PO Box 848',
        city: 'Ada',
        state: 'OK',
        zip: '74820',
        email: 'bbonar.btwin01@insuremail.net',
        phone: '5803325181'
    },
    TOP1: {
        name: 'Arnett Insurance Agency, Inc.',
        address: '1116 W. Main, PO BOX 327',
        city: 'Durant',
        state: 'OK',
        zip: '74701',
        email: 'butcha@arnettinsurance.com',
        phone: '580-924-5468'
    },
    TOP2: {
        name: 'Crews Insurance Agency',
        address: '2201 W. Broadway, PO Box 476',
        city: 'Sulphur',
        state: 'OK',
        zip: '73086',
        email: 'Mike@crewsagency.com',
        phone: '580-622-2138'
    },
    TOP3: {
        name: 'InsuranceOne Agency Inc.',
        address: '1214 N. Hwy 81 #106',
        city: 'Duncan',
        state: 'OK',
        zip: '73533',
        email: 'corey@ins1.net',
        phone: '580-255-0001'
    },
    TOP4: {
        name: 'Magill Insurance Agency, Inc.',
        address: '322 E. Main St, PO Drawer 549',
        city: 'Weatherford',
        state: 'OK',
        zip: '73096',
        email: 'wes@magillagency.com',
        phone: '580-772-7101'
    },
    TOP5: {
        name: 'Mollett-Hunter, Inc.',
        address: '501 S 5th',
        city: 'Chickasha',
        state: 'OK',
        zip: '73018',
        email: 'Mark@mhii.com',
        phone: '405-224-5404'
    },
    TOP6: {
        name: 'Multi-County Insurance Center',
        address: '624 W. Independence #106',
        city: 'Shawnee',
        state: 'OK',
        zip: '74801',
        email: 'multic@swbell.net',
        phone: '405-275-2970'
    },
    TOP7: {
        name: 'Sullivan Dollar Agency',
        address: '716 N. Milt Phillips Ave.',
        city: 'Seminole',
        state: 'OK',
        zip: '74868',
        email: 'david@sullivandollar.com',
        phone: '405-382-1680'
    },
    TOP8: {
        name: 'Sullivan Insurance Agency',
        address: '321 W. Broadway, PO Box 1534',
        city: 'Ardmore',
        state: 'OK',
        zip: '73402',
        email: 'lena@johnsullivaninsurance.com',
        phone: '580-223-2187'
    },
    TOP9: {
        name: 'Thompson Agency',
        address: '314 S. Broadway, # 100',
        city: 'Ada',
        state: 'OK',
        zip: '74821',
        email: 'bbonar.btwin01@insuremail.net',
        phone: '580-332-5181'
    },
    TOP10: {
        name: 'Wiedemann Insurance Agency, Inc.',
        address: '112 South 4th Street',
        city: 'Yukon',
        state: 'OK',
        zip: '73099',
        email: 'scott@okinsurancepro.com',
        phone: '405-354-7920'
    },
    TRELC: {
        name: 'Savvy Insurance Solutions, LLP',
        address: '340 S Lemon Avenue #8735',
        city: 'Walnut',
        state: 'CA',
        zip: '91789',
        email: 'licensing@savvy.insure',
        phone: '(706) 873-5547'
    },
    TWFG1: {
        name: 'TWFG Insurance Services, LLC',
        address: '1450 Redbud Blvd, Ste 104',
        city: 'McKinney',
        state: 'TX',
        zip: '75069',
        email: 'joe@twfg.com',
        phone: '(214) 814-0888'
    },
    TWFG2: {
        name: 'TWFG Insurance Services, LLC',
        address: '4410 Kemp Blvd.  Suite A',
        city: 'Wichita Falls',
        state: 'TX',
        zip: '76308',
        email: 'thoang@twfg.com',
        phone: '(940) 691-0042'
    },
    TWFG3: {
        name: 'TWFG Insurance Services, LLC',
        address: '9802 FM 1960, Ste 235',
        city: 'Humble',
        state: 'TX',
        zip: '77338',
        email: 'rguillory@twfg.com',
        phone: '(713) 860-4063'
    },
    TWFG4: {
        name: 'TWFG Insurance Services, LLC',
        address: '1001 W. Loop S. Suite # 105',
        city: 'Houston',
        state: 'TX',
        zip: '77027',
        email: 'akang@twfg.com',
        phone: '(281) 657-4320'
    },
    TWFG5: {
        name: 'TWFG Insurance Services, LLC',
        address: '1201 Lake Woodlands Dr. Ste 4020',
        city: 'The woodlands',
        state: 'TX',
        zip: '77380',
        email: 'sgarner@twfg.com',
        phone: '(281) 478-9988'
    },
    TWFG6: {
        name: 'TWFG Insurance Services, LLC',
        address: '25219 Kuykendahl Rd, Ste 250',
        city: 'Tomball',
        state: 'TX',
        zip: '77375',
        email: 'fmejia@twfg.com',
        phone: '(713) 234-1026'
    },
    TWFG7: {
        name: 'TWFG Insurance Services, LLC',
        address: '101 West 1st  Suite D',
        city: 'Elgin',
        state: 'TX',
        zip: '78621',
        email: 'mcallahan@twfg.com',
        phone: '(512) 281-3769'
    },
    TWFG8: {
        name: 'TWFG Insurance Services, LLC',
        address: '10233 E Northwest Hwy.  #516',
        city: 'Dallas',
        state: 'TX',
        zip: '75238',
        email: 'rwilcox@twfg.com',
        phone: '(214) 340-7333'
    },
    TWFG9: {
        name: 'TWFG Insurance Services, LLC',
        address: '5300 Hollister St, Ste 335',
        city: 'Houston',
        state: 'TX',
        zip: '77040',
        email: 'chernandez@twfg.com',
        phone: '(281) 493-9376'
    },
    TWFG10: {
        name: 'TWFG Insurance Services, LLC',
        address: '1816 Harwood Ct.',
        city: 'Hurst',
        state: 'TX',
        zip: '76054',
        email: 'tstamps@twfg.com',
        phone: '(817) 479-8401'
    },
    TWFG11: {
        name: 'TWFG Insurance Services, LLC',
        address: '2340 East Trinity Mills  Suite 300',
        city: 'Carollton',
        state: 'TX',
        zip: '75006',
        email: 'cbalsley@twfg.com',
        phone: '(972) 478-4304'
    },
    TWFG12: {
        name: 'TWFG Insurance Services, LLC',
        address: '7598 N Mesa St. Suite 203',
        city: 'El Paso',
        state: 'TX',
        zip: '79912',
        email: 'udelafuente@twfg.com',
        phone: '(915) 444-2700'
    },
    TWFG13: {
        name: 'TWFG Insurance Services, LLC',
        address: '7070 Knights Ct.   Suite 503',
        city: 'Missouri City',
        state: 'TX',
        zip: '77459',
        email: 'bthomas@twfg.com',
        phone: '(281) 969-7395'
    },
    TWFG14: {
        name: 'TWFG Insurance Services, LLC',
        address: '19707 Leitersburg Pike, Suite B',
        city: 'Hagerstown',
        state: 'MD',
        zip: '21742',
        email: 'asweeney@twfg.com',
        phone: '(301) 797-5389'
    },
    TWFG15: {
        name: 'TWFG Insurance Services, LLC',
        address: '1201 Lake Woodlands Dr. Suite 4020',
        city: 'The Woodlands',
        state: 'TX',
        zip: '77380',
        email: 'ichambers@twfg.com',
        phone: '(281) 478-9995'
    },
    TWFG16: {
        name: 'TWFG Insurance Services, LLC',
        address: '11602 Bellaire Blvd.  Suite B',
        city: 'Houston',
        state: 'TX',
        zip: '77072',
        email: 'tphan@twfg.com',
        phone: '(281) 564-4229'
    },
    TWFG17: {
        name: 'TWFG Insurance Services, LLC',
        address: '201 S. McDonald Ste. B',
        city: 'McKinney',
        state: 'TX',
        zip: '75069',
        email: 'sbiedma@twfg.com',
        phone: '(972) 562-7062'
    },
    TWFG18: {
        name: 'TWFG Insurance Services, LLC',
        address: '950 Echo Ln, Ste 2012',
        city: 'Houston',
        state: 'TX',
        zip: '77024',
        email: 'sophia@twfg.com',
        phone: '(281) 201-5036'
    },
    TWFG19: {
        name: 'TWFG Insurance Services, LLC',
        address: '33018 Tamina Road',
        city: 'Magnolia',
        state: 'TX',
        zip: '77354',
        email: 'cjenkins@twfg.com',
        phone: '(281) 410-8934'
    },
    TWFG20: {
        name: 'TWFG Insurance Services, LLC',
        address: '271 N Dallas St Suite C',
        city: 'Van Alstyne',
        state: 'TX',
        zip: '75495',
        email: 'jsearls@twfg.com',
        phone: '(214) 396-6595'
    },
    TWFG21: {
        name: 'TWFG Insurance Services, LLC',
        address: '12848 Queensbury Ln #224',
        city: 'Houston',
        state: 'TX',
        zip: '77024',
        email: 'vpaz@twfg.com',
        phone: '(281) 594-7425'
    },
    TWFG22: {
        name: 'TWFG Insurance Services, LLC',
        address: '24044 Cinco Village Center Ste. 2',
        city: 'Laty',
        state: 'TX',
        zip: '77494',
        email: 'hkhaldi@twfg.com',
        phone: '(281) 394-2221'
    },
    TWFG23: {
        name: 'TWFG Insurance Services, LLC',
        address: '14090 Southwest Freeway Suite 300',
        city: 'Sugar Land',
        state: 'TX',
        zip: '77478',
        email: 'tliu@twfg.com',
        phone: '(281) 800-8816'
    },
    TWFG24: {
        name: 'TWFG Insurance Services, LLC',
        address: '115 E Elm',
        city: 'Winnsboro',
        state: 'TX',
        zip: '75494',
        email: 'rhazlewood@twfg.com',
        phone: '(903) 342-3560'
    },
    TWFG25: {
        name: 'TWFG Insurance Services, LLC',
        address: '2040 N Loop 336W #210',
        city: 'Conroe',
        state: 'TX',
        zip: '77304',
        email: 'mwilson@twfg.com',
        phone: '(832) 584-1185'
    },
    TWFG26: {
        name: 'TWFG Insurance Services, LLC',
        address: '1931 Humble Place Dr, Ste 107',
        city: 'Humble',
        state: 'TX',
        zip: '77338',
        email: 'rayala@twfg.com',
        phone: '(832) 651-3530'
    },
    TWFG27: {
        name: 'TWFG Insurance Services, LLC',
        address: '3131 Bell Street #104',
        city: 'Amarillo',
        state: 'TX',
        zip: '79106',
        email: 'kkaiser@twfg.com',
        phone: '(806) 358-1344'
    },
    TWFG28: {
        name: 'TWFG Insurance Services, LLC',
        address: '9894 Bissonnet St, Ste 720',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'shartgrove@twfg.com',
        phone: '(713) 955-4278'
    },
    TWFG29: {
        name: 'TWFG Insurance Services, LLC',
        address: '11511 Katy Freeway Suite 550',
        city: 'Houston',
        state: 'TX',
        zip: '77079',
        email: 'npineda@twfg.com',
        phone: '(281) 493-9375'
    },
    TWFG30: {
        name: 'TWFG Insurance Services, LLC',
        address: '3620 E. 29th St',
        city: 'Bryan',
        state: 'TX',
        zip: '77802',
        email: 'cforman@twfg.com',
        phone: '(979) 822-4912'
    },
    TWFG31: {
        name: 'TWFG Insurance Services, LLC',
        address: '1300 W. Sam Houston Pkwy S #100',
        city: 'Houston',
        state: 'TX',
        zip: '77042',
        email: 'psobhani@twfg.com',
        phone: '(832) 305-3771'
    },
    TWFG32: {
        name: 'TWFG Insurance Services, LLC',
        address: '1060 W Frankford Rd #106',
        city: 'Carrollton',
        state: 'TX',
        zip: '75007',
        email: 'blee@twfg.com',
        phone: '(972) 939-8989'
    },
    TWFG33: {
        name: 'TWFG Insurance Services, LLC',
        address: '6666 Harwin Dr #678',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'mescobar@twfg.com',
        phone: '(713) 781-1231'
    },
    TWFG34: {
        name: 'TWFG Insurance Services, LLC',
        address: '403 Elm Street',
        city: 'Royse City',
        state: 'TX',
        zip: '75189',
        email: 'mcaldwell@twfg.com',
        phone: '(972) 635-6772'
    },
    TWFG35: {
        name: 'TWFG Insurance Services, LLC',
        address: '107 Larson Ln Ste 300-C',
        city: 'Aledo',
        state: 'TX',
        zip: '76008',
        email: 'cjames@twfg.com',
        phone: '(817) 443-9747'
    },
    TWFG36: {
        name: 'TWFG Insurance Services, LLC',
        address: '1902 E Central TX Expwy',
        city: 'Killeen',
        state: 'TX',
        zip: '76542',
        email: 'dconnell@twfg.com',
        phone: '(254) 200-4822'
    },
    TWFG37: {
        name: 'TWFG Insurance Services, LLC',
        address: '10505 Market Street Suite A',
        city: 'Houston',
        state: 'TX',
        zip: '77029',
        email: 'jsalinas@twfg.com',
        phone: '(713) 670-3020'
    },
    TWFG38: {
        name: 'TWFG Insurance Services, LLC',
        address: '10333 Harwin Dr. Suite 460H',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'kli@twfg.com',
        phone: '(832) 677-0699'
    },
    TWFG39: {
        name: 'TWFG Insurance Services, LLC',
        address: '808 Russell Palmer Rd, Ste. 266',
        city: 'Kingwood',
        state: 'TX',
        zip: '77339',
        email: 'rwelborn@twfg.com',
        phone: '(713) 344-0405'
    },
    TWFG40: {
        name: 'TWFG Insurance Services, LLC',
        address: '4420 FM 1960 W Ste 201',
        city: 'Houston',
        state: 'TX',
        zip: '77068',
        email: 'eportillo@twfg.com',
        phone: '(713) 589-9969'
    },
    TWFG41: {
        name: 'TWFG Insurance Services, LLC',
        address: '4610 Sweetwater Blvd #130',
        city: 'Sugar Land',
        state: 'TX',
        zip: '77479',
        email: 'hkhan@twfg.com',
        phone: '(713) 781-3054'
    },
    TWFG42: {
        name: 'TWFG Insurance Services, LLC',
        address: '1100 Nasa Parkway Suite 201B',
        city: 'Houston',
        state: 'TX',
        zip: '77058',
        email: 'mthomas@twfg.com',
        phone: '(281) 404-5511'
    },
    TWFG43: {
        name: 'TWFG Insurance Services, LLC',
        address: '14800 Quorum Dr, Ste 350',
        city: 'Dallas',
        state: 'TX',
        zip: '75254',
        email: 'kmilligan@twfg.com',
        phone: '(972) 770-3199'
    },
    TWFG44: {
        name: 'TWFG Insurance Services, LLC',
        address: '10925 Estate Ln. Suite 148',
        city: 'Dallas',
        state: 'TX',
        zip: '75238',
        email: 'jburridge@twfg.com',
        phone: '(972) 926-5355'
    },
    TWFG45: {
        name: 'TWFG Insurance Services, LLC',
        address: '1233 1/2 Hugh Rd.',
        city: 'Houston',
        state: 'TX',
        zip: '77067',
        email: 'mreyes@twfg.com',
        phone: '(346) 236-1540'
    },
    TWFG46: {
        name: 'TWFG Insurance Services, LLC',
        address: '813 N Main St',
        city: 'Lumberton',
        state: 'TX',
        zip: '77657',
        email: 'tgalvan@twfg.com',
        phone: '(409) 227-3107'
    },
    TWFG47: {
        name: 'TWFG Insurance Services, LLC',
        address: '22503 Katy Freeway, Suite 30',
        city: 'Katy',
        state: 'TX',
        zip: '77450',
        email: 'cchari@twfg.com',
        phone: '(281) 647-0553'
    },
    TWFG48: {
        name: 'TWFG Insurance Services, LLC',
        address: '4200 South Hulen Street, Suite 672',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76109',
        email: 'ttuomey@twfg.com',
        phone: '(817) 224-2912'
    },
    TWFG49: {
        name: 'TWFG Insurance Services, LLC',
        address: '918 Mercury Dr Ste 4',
        city: 'Houston',
        state: 'TX',
        zip: '77029',
        email: 'csalinas@twfg.com',
        phone: '713-485-6440'
    },
    TWFG50: {
        name: 'TWFG Insurance Services, LLC',
        address: '1930 E Rosemeade Parkway Ste 207',
        city: 'Carrollton',
        state: 'TX',
        zip: '75007',
        email: 'ccaster@twfg.com',
        phone: '(214) 619-1700'
    },
    TWFG51: {
        name: 'TWFG Insurance Services, LLC',
        address: '12808 W. Airport Blvd. Ste. 265F',
        city: 'Sugar Land',
        state: 'TX',
        zip: '77478',
        email: 'thuynh@twfg.com',
        phone: '(832) 335-3476'
    },
    TWFG52: {
        name: 'TWFG Insurance Services, LLC',
        address: '1105 Stonewall St, Ste 502A',
        city: 'Garland',
        state: 'TX',
        zip: '75043',
        email: 'nancy@twfg.com',
        phone: '(469) 786-0070'
    },
    TWFG53: {
        name: 'TWFG Insurance Services, LLC',
        address: '13225 Jones Road',
        city: 'Houston',
        state: 'TX',
        zip: '77070',
        email: 'esirafi@twfg.com',
        phone: '(281) 955-2100'
    },
    TWFG54: {
        name: 'TWFG Insurance Services, LLC',
        address: '2620 S Sam Houston Pkwy W',
        city: 'Houston',
        state: 'TX',
        zip: '77047',
        email: 'smarandi@twfg.com',
        phone: '(713) 728-7900'
    },
    TWFG55: {
        name: 'TWFG Insurance Services, LLC',
        address: '3900 S. Stonebridge Dr, Ste 102',
        city: 'McKinney',
        state: 'TX',
        zip: '75070',
        email: 'pwertenberger@twfg.com',
        phone: '(972) 808-7374'
    },
    TWFG56: {
        name: 'TWFG Insurance Services, LLC',
        address: '1201 Lake Woodlands Dr., Suite 4020',
        city: 'The Woodlands',
        state: 'TX',
        zip: '77380',
        email: 'calvin.martin@twfg.com',
        phone: '(713) 930-0627'
    },
    TWFG57: {
        name: 'TWFG Insurance Services, LLC',
        address: '15950 N Dallas Pkwy, Ste 400',
        city: 'Dallas',
        state: 'TX',
        zip: '75248',
        email: 'dterrano@twfg.com',
        phone: '(424) 247-5600'
    },
    TWFG58: {
        name: 'TWFG Insurance Services, LLC',
        address: '9999 Bellaire Blvd Suite 889',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'jxu@twfg.com',
        phone: '(713) 773-0040'
    },
    TWFG59: {
        name: 'TWFG Insurance Services, LLC',
        address: '5900 S Lake Forest Dr. Suite 300',
        city: 'McKinney',
        state: 'TX',
        zip: '75070',
        email: 'dcastillo@twfg.com',
        phone: '(888) 549-2961'
    },
    TWFG60: {
        name: 'TWFG Insurance Services, LLC',
        address: '11509 Bellaire Blvd',
        city: 'Houston',
        state: 'TX',
        zip: '77072',
        email: 'vtruong@twfg.com',
        phone: '(281) 888-0059'
    },
    TWFG61: {
        name: 'TWFG Insurance Services, LLC',
        address: '1620 FM 544, Ste 400',
        city: 'Lewisville',
        state: 'TX',
        zip: '75056',
        email: 'rstuart@twfg.com',
        phone: '(972) 512-0560'
    },
    TWFG62: {
        name: 'TWFG Insurance Services, LLC',
        address: '2006 S Bagdad Rd, Ste 180',
        city: 'Leander',
        state: 'TX',
        zip: '78641',
        email: 'kbordman@twfg.com',
        phone: '(512) 942-9949'
    },
    TWFG63: {
        name: 'TWFG Insurance Services, LLC',
        address: '16225 Park Ten Place Suite 500',
        city: 'Houston',
        state: 'TX',
        zip: '77084',
        email: 'mvu@twfg.com',
        phone: '(713) 338-3452'
    },
    TWFG64: {
        name: 'TWFG Insurance Services, LLC',
        address: '25103 FM 2100',
        city: 'Huffman',
        state: 'TX',
        zip: '77336',
        email: 'jsparks@twfg.com',
        phone: '(281) 324-9119'
    },
    TWFG65: {
        name: 'TWFG Insurance Services, LLC',
        address: '5005 Colleyville Boulevard, Suite 207',
        city: 'Colleyville',
        state: 'TX',
        zip: '76034',
        email: 'tcrum@twfg.com',
        phone: '(817) 888-8752'
    },
    TWFG66: {
        name: 'TWFG Insurance Services, LLC',
        address: '1825 W. Walnut Hill Ln. #120',
        city: 'Irving',
        state: 'TX',
        zip: '75038',
        email: 'hturner@twfg.com',
        phone: '(972) 239-6444'
    },
    TWFG67: {
        name: 'TWFG Insurance Services, LLC',
        address: '5501 LBJ Freeway Suite 200',
        city: 'Dallas',
        state: 'TX',
        zip: '75240',
        email: 'gwilliams@twfg.com',
        phone: '(214) 987-6767'
    },
    TWFG68: {
        name: 'TWFG Insurance Services, LLC',
        address: '4059 Bryan Ave',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76110',
        email: 'atejeda@twfg.com',
        phone: '(817) 829-7049'
    },
    TWFG69: {
        name: 'TWFG Insurance Services, LLC',
        address: '2601 Hilltop #400',
        city: 'Sherman',
        state: 'TX',
        zip: '75090',
        email: 'mark@twfg.com',
        phone: '(903) 328-6650'
    },
    TWFG70: {
        name: 'TWFG Insurance Services, LLC',
        address: '25511 Budde Rd. Ste. 1902',
        city: 'The Woodlands',
        state: 'TX',
        zip: '77380',
        email: 'cherie@twfg.com',
        phone: '(832) 510-5050'
    },
    TWFG71: {
        name: 'TWFG Insurance Services, LLC',
        address: '7920 Belt Line Rd, Ste 520',
        city: 'Dallas',
        state: 'TX',
        zip: '75254',
        email: 'jrzamorano@twfg.com',
        phone: '(972) 270-3333'
    },
    TWFG72: {
        name: 'TWFG Insurance Services, LLC',
        address: '520 N 30th Street',
        city: 'Quincy',
        state: 'IL',
        zip: '62301',
        email: 'debi@twfg.com',
        phone: '(217) 221-5555'
    },
    TWFG73: {
        name: 'TWFG Insurance Services, LLC',
        address: '4815 S. Sheridan, Ste 112',
        city: 'Tulsa',
        state: 'OK',
        zip: '74145',
        email: 'dcook@twfg.com',
        phone: '(918) 710-3953'
    },
    TWFG74: {
        name: 'TWFG Insurance Services, LLC',
        address: '1201 Lake Woodlands Dr. Ste 4020',
        city: 'The woodlands',
        state: 'TX',
        zip: '77380',
        email: 'tming@twfg.com',
        phone: '(936) 931-8093'
    },
    TWFG75: {
        name: 'TWFG Insurance Services, LLC',
        address: '12701 W Elm St',
        city: 'Surprise',
        state: 'AZ',
        zip: '85374',
        email: 'lletcher@twfg.com',
        phone: '(623) 583-0113'
    },
    TWFG76: {
        name: 'TWFG Insurance Services, LLC',
        address: '11231 Bissonnet St, Ste 101A',
        city: 'Houston',
        state: 'TX',
        zip: '77099',
        email: 'ealtaf@twfg.com',
        phone: '(832) 617-7475'
    },
    TWFG77: {
        name: 'TWFG Insurance Services, LLC',
        address: '6626 Silvermine Dr., Suite 500',
        city: 'Austin',
        state: 'TX',
        zip: '78736',
        email: 'phandsel@twfg.com',
        phone: '(512) 301-3899'
    },
    TWFG78: {
        name: 'TWFG Insurance Services, LLC',
        address: '2825 Wilcrest Dr. Ste 669',
        city: 'Houston',
        state: 'TX',
        zip: '77042',
        email: 'msweet@twfg.com',
        phone: '(832) 533-8027'
    },
    TWFG79: {
        name: 'TWFG Insurance Services, LLC',
        address: '1201 Lake Woodlands Dr #4020',
        city: 'The Woodlands',
        state: 'TX',
        zip: '77380',
        email: 'jschmitz@twfg.com',
        phone: '(832) 541-2035'
    },
    TWFG80: {
        name: 'TWFG Insurance Services, LLC',
        address: '871 Texas State Hwy 62 Suite 108',
        city: 'Buna',
        state: 'TX',
        zip: '77612',
        email: 'wearl@twfg.com',
        phone: '(409) 994-8005'
    },
    TWFG81: {
        name: 'TWFG Insurance Services, LLC',
        address: '11078 Veterans Memorial Dr, Ste 265',
        city: 'Houston',
        state: 'TX',
        zip: '77067',
        email: 'dduong@twfg.com',
        phone: '2817411793'
    },
    TWFG82: {
        name: 'TWFG Insurance Services, LLC',
        address: '944 S Fry Rd',
        city: 'Katy',
        state: 'TX',
        zip: '77450',
        email: 'rosie.cantu@twfg.com',
        phone: '(281) 984-5048'
    },
    TWFG83: {
        name: 'TWFG Insurance Services, LLC',
        address: '1201 Lake Woodlands Dr. Ste 4020',
        city: 'The woodlands',
        state: 'TX',
        zip: '77380',
        email: 'spowers@twfg.com',
        phone: '(832) 381-2533'
    },
    TWFG84: {
        name: 'TWFG Insurance Services, LLC',
        address: '6100 Corporate Dr. Ste 319',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'gpan@twfg.com',
        phone: '(713) 370-0693'
    },
    TWFG85: {
        name: 'TWFG Insurance Services, LLC',
        address: '3 Grogans Park Dr Ste 210',
        city: 'The Woodlands',
        state: 'TX',
        zip: '77380',
        email: 'aghazizadeh@twfg.com',
        phone: '(281) 651-5198'
    },
    TWFG86: {
        name: 'TWFG Insurance Services, LLC',
        address: '320 E Peyton St Ste 300',
        city: 'Sherman',
        state: 'TX',
        zip: '75090',
        email: 'kgarland@twfg.com',
        phone: '(903) 870-9020'
    },
    TWFG87: {
        name: 'TWFG Insurance Services, LLC',
        address: '306 Highway 377 N, Ste G',
        city: 'Argyle',
        state: 'TX',
        zip: '76226',
        email: 'chudnall@twfg.com',
        phone: '(469) 948-4848'
    },
    TWFG88: {
        name: 'TWFG Insurance Services, LLC',
        address: '1213 W Slaughter Ln, Ste 140',
        city: 'Austin',
        state: 'TX',
        zip: '78748',
        email: 'sfry@twfg.com',
        phone: '(512) 212-7185'
    },
    TWFG89: {
        name: 'TWFG Insurance Services, LLC',
        address: '3000 N McColl Rd Ste A1',
        city: 'McAllen',
        state: 'TX',
        zip: '78501',
        email: 'jdavila@twfg.com',
        phone: '(956) 683-0584'
    },
    TWFG90: {
        name: 'TWFG Insurance Services, LLC',
        address: '4500 Highway 6',
        city: 'Sugar Land',
        state: 'TX',
        zip: '77478',
        email: 'ckon@twfg.com',
        phone: '(713) 781-2495'
    },
    TWFG91: {
        name: 'TWFG Insurance Services, LLC',
        address: '10916 Fuqua St',
        city: 'Houston',
        state: 'TX',
        zip: '77089',
        email: 'hai@twfg.com',
        phone: '(281) 506-8689'
    },
    TWFG92: {
        name: 'TWFG Insurance Services, LLC',
        address: '13480 Veterans Memorial Dr #F2',
        city: 'Houston',
        state: 'TX',
        zip: '77014',
        email: 'jvu@twfg.com',
        phone: '(281) 444-9300'
    },
    TWFG93: {
        name: 'TWFG Insurance Services, LLC',
        address: '2167 S McColl Rd',
        city: 'Edinburg',
        state: 'TX',
        zip: '78539',
        email: 'edvins@twfg.com',
        phone: '(956) 381-0951'
    },
    TWFG94: {
        name: 'TWFG Insurance Services, LLC',
        address: '2300 Valley View Ln Suite 234',
        city: 'Irving',
        state: 'TX',
        zip: '75062',
        email: 'mhassan@twfg.com',
        phone: '(972) 457-0146'
    },
    TWFG95: {
        name: 'TWFG Insurance Services, LLC',
        address: '12337 Jones Rd, Ste 406',
        city: 'Houston',
        state: 'TX',
        zip: '77070',
        email: 'bmangum@twfg.com',
        phone: '(281) 493-4245'
    },
    TWFG96: {
        name: 'TWFG Insurance Services, LLC',
        address: '1410-D FM 1960 Bypass East',
        city: 'Humble',
        state: 'TX',
        zip: '77338',
        email: 'dratliff@twfg.com',
        phone: '(832) 644-5500'
    },
    TWFG97: {
        name: 'TWFG Insurance Services, LLC',
        address: '2345 Erringer Rd, Ste. 205',
        city: 'Simi Valley',
        state: 'CA',
        zip: '93065',
        email: 'don@twfg.com',
        phone: '(214) 352-8885'
    },
    TWFG98: {
        name: 'TWFG Insurance Services, LLC',
        address: '800 Wilcrest Dr, Ste 130',
        city: 'Houston',
        state: 'TX',
        zip: '77042',
        email: 'ehartgrove@twfg.com',
        phone: '(832) 741-3055'
    },
    TWFG99: {
        name: 'TWFG Insurance Services, LLC',
        address: '1176 E Warner Rd #107',
        city: 'Gilbert',
        state: 'AZ',
        zip: '85296',
        email: 'jcota@twfg.com',
        phone: '(480) 415-1846'
    },
    TWFG100: {
        name: 'TWFG Insurance Services, LLC',
        address: '10300 Westoffice Dr, Ste 105',
        city: 'Houston',
        state: 'TX',
        zip: '77042',
        email: 'atran@twfg.com',
        phone: '(281) 888-3486'
    },
    TWFG101: {
        name: 'TWFG Insurance Services, LLC',
        address: '201 1/2 Virginia Street, Suite 7',
        city: 'McKinney',
        state: 'TX',
        zip: '75069',
        email: 'candrews@twfg.com',
        phone: '(972) 732-6485'
    },
    TWFG102: {
        name: 'TWFG Insurance Services, LLC',
        address: '6012 Reef Point Lane Suite K',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76135',
        email: 'awhite@twfg.com',
        phone: '(817) 841-8709'
    },
    TWFG103: {
        name: 'TWFG Insurance Services, LLC',
        address: '9600 Longpoint Rd, Suite 170',
        city: 'Houston',
        state: 'TX',
        zip: '77055',
        email: 'gore@twfg.com',
        phone: '(832) 397-5245'
    },
    TWFG104: {
        name: 'TWFG Insurance Services, LLC',
        address: '9550 Forest Ln. Ste. 715J',
        city: 'Dallas',
        state: 'TX',
        zip: '75243',
        email: 'phuongly@twfg.com',
        phone: '(214) 299-9020'
    },
    TWFG105: {
        name: 'TWFG Insurance Services, LLC',
        address: '18756 Stone Oak Pkwy Suite 200',
        city: 'San Antonio',
        state: 'TX',
        zip: '78258',
        email: 'dgarza@twfg.com',
        phone: '(210) 390-0015'
    },
    TWFG106: {
        name: 'TWFG Insurance Services, LLC',
        address: '907 E Main Street',
        city: 'Humble',
        state: 'TX',
        zip: '77338',
        email: 'croane@twfg.com',
        phone: '(281) 973-9326'
    },
    TWFG107: {
        name: 'TWFG Insurance Services, LLC',
        address: '1529 East IH-30, Ste 107',
        city: 'Garland',
        state: 'TX',
        zip: '75043',
        email: 'ccernat@twfg.com',
        phone: '(469) 857-5915'
    },
    TWFG108: {
        name: 'TWFG Insurance Services, LLC',
        address: '407 E Methvin Dr',
        city: 'Longview',
        state: 'TX',
        zip: '75601',
        email: 'mjackson@twfg.com',
        phone: '(903) 452-6077'
    },
    TWFG109: {
        name: 'TWFG Insurance Services, LLC',
        address: '9440 Bellaire Blvd. Ste 222',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'ahong@twfg.com',
        phone: '(713) 922-8272'
    },
    TWFG110: {
        name: 'TWFG Insurance Services, LLC',
        address: '18477 W Lake Houston Pkwy #30',
        city: 'Humble',
        state: 'TX',
        zip: '77346',
        email: 'bjohnson1@twfg.com',
        phone: '(281) 852-3333'
    },
    TWFG111: {
        name: 'TWFG Insurance Services, LLC',
        address: '9100 A N Garnett Rd.,  Ste A',
        city: 'Owasso',
        state: 'OK',
        zip: '74055',
        email: 'bstamper@twfg.com',
        phone: '(918) 609-5000'
    },
    TWFG112: {
        name: 'TWFG Insurance Services, LLC',
        address: '4500 Mercantile Plaza  Suite 300',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76137',
        email: 'bharrell@twfg.com',
        phone: '(817) 839-2848'
    },
    TWFG113: {
        name: 'TWFG Insurance Services, LLC',
        address: '8 S Law St.',
        city: 'Aberdeen',
        state: 'MD',
        zip: '21001',
        email: 'pdelatado@twfg.com',
        phone: '(410) 914-7959'
    },
    TWFG114: {
        name: 'TWFG Insurance Services, LLC',
        address: '9391 Grogans Mill Rd,  Ste A5',
        city: 'The Woodlands',
        state: 'TX',
        zip: '77380',
        email: 'rortiz@twfg.com',
        phone: '(936) 697-1463'
    },
    TWFG115: {
        name: 'TWFG Insurance Services, LLC',
        address: '14405 Walters Rd, Suite 870',
        city: 'Houston',
        state: 'TX',
        zip: '77014',
        email: 'mvo@twfg.com',
        phone: '(832) 652-3939'
    },
    TWFG116: {
        name: 'TWFG Insurance Services, LLC',
        address: '135 SW Anderson St, Ste 101',
        city: 'Burleson',
        state: 'TX',
        zip: '76028',
        email: 'ematthews@twfg.com',
        phone: '(817) 783-3369'
    },
    TWFG117: {
        name: 'TWFG Insurance Services, LLC',
        address: '701 Cedar Lake Blvd. Suite 131',
        city: 'Oklahoma City',
        state: 'OK',
        zip: '73114',
        email: 'jminer@twfg.com',
        phone: '(405) 594-8214'
    },
    TWFG118: {
        name: 'TWFG Insurance Services, LLC',
        address: '10700 Richmond Ave Suite 115',
        city: 'Houston',
        state: 'TX',
        zip: '77042',
        email: 'llee@twfg.com',
        phone: '(510) 759-6372'
    },
    TWFG119: {
        name: 'TWFG Insurance Services, LLC',
        address: '920 N University Dr, Ste A',
        city: 'Nacogdoches',
        state: 'TX',
        zip: '75961',
        email: 'pgonzalez@twfg.com',
        phone: '(936) 305-5180'
    },
    TWFG120: {
        name: 'TWFG Insurance Services, LLC',
        address: '1609 1/2 N Center St.  Ste. A',
        city: 'Bonham',
        state: 'TX',
        zip: '75418',
        email: 'rpendergrass@twfg.com',
        phone: '(903) 583-2004'
    },
    TWFG121: {
        name: 'TWFG Insurance Services, LLC',
        address: '1701 Gateway Blvd, Ste 391',
        city: 'Richardson',
        state: 'TX',
        zip: '75080',
        email: 'kdumanski@twfg.com',
        phone: '(972) 768-2815'
    },
    TWFG122: {
        name: 'TWFG Insurance Services, LLC',
        address: '2770 Main St, Ste 208',
        city: 'Frisco',
        state: 'TX',
        zip: '75033',
        email: 'cfitch@twfg.com',
        phone: '(972) 512-3760'
    },
    TWFG123: {
        name: 'TWFG Insurance Services, LLC',
        address: '2306 Guthrie Rd, Ste 260-G1',
        city: 'Garland',
        state: 'TX',
        zip: '75043',
        email: 'cstidham@twfg.com',
        phone: '(469) 769-3939'
    },
    TWFG124: {
        name: 'TWFG Insurance Services, LLC',
        address: '4501 Cartwright Rd  Suite 203',
        city: 'Missouri City',
        state: 'TX',
        zip: '77459',
        email: 'rcosta@twfg.com',
        phone: '(281) 261-9005'
    },
    TWFG125: {
        name: 'TWFG Insurance Services, LLC',
        address: '2925 Richmond Ave #1200',
        city: 'Houston',
        state: 'TX',
        zip: '77098',
        email: 'rrichardson@twfg.com',
        phone: '(281) 893-6720'
    },
    TWFG126: {
        name: 'TWFG Insurance Services, LLC',
        address: '1200 Summit Ave, Ste 780',
        city: 'Fort Worth',
        state: 'TX',
        zip: '76102',
        email: 'srebosio@twfg.com',
        phone: '(817) 624-4667'
    },
    TWFG127: {
        name: 'TWFG Insurance Services, LLC',
        address: '6901 CORPORATE DR Ste. 122',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'wxue@twfg.com',
        phone: '(713) 561-3798'
    },
    TWFG128: {
        name: 'TWFG Insurance Services, LLC',
        address: '10700 Richmond Dr.  Suite 218',
        city: 'Houston',
        state: 'TX',
        zip: '77042',
        email: 'jlam@twfg.com',
        phone: '(713) 781-8388'
    },
    TWFG129: {
        name: 'TWFG Insurance Services, LLC',
        address: '621 S. Bryan Belt Line Rd #101',
        city: 'Mesquite',
        state: 'TX',
        zip: '75149',
        email: 'cecilhutson@twfg.com',
        phone: '(972) 222-1200'
    },
    TWFG130: {
        name: 'TWFG Insurance Services, LLC',
        address: '2500 Tanglewilde St. Suite 450',
        city: 'Houston',
        state: 'TX',
        zip: '77063',
        email: 'schaskin@twfg.com',
        phone: '(713) 339-9963'
    },
    TWFG131: {
        name: 'TWFG Insurance Services, LLC',
        address: '2189 Cypress Creek Pkwy, Ste 200',
        city: 'Houston',
        state: 'TX',
        zip: '77090',
        email: 'amojica@twfg.com',
        phone: '(832) 447-1238'
    },
    TWFG132: {
        name: 'TWFG Insurance Services, LLC',
        address: '306 N Main St, Ste. B',
        city: 'Dayton',
        state: 'TX',
        zip: '77535',
        email: 'rmurphree@twfg.com',
        phone: '(936) 257-5445'
    },
    TWFG133: {
        name: 'TWFG Insurance Services, LLC',
        address: '2552 Stonebrook Pkwy  502B',
        city: 'Frisco',
        state: 'TX',
        zip: '75034',
        email: 'smccuiston@twfg.com',
        phone: '(214) 919-2288'
    },
    TWFG134: {
        name: 'TWFG Insurance Services, LLC',
        address: '3802 Cartwright Rd #102B',
        city: 'Missouri City',
        state: 'TX',
        zip: '77459',
        email: 'cmathews@twfg.com',
        phone: '(832) 342-9983'
    },
    TWFG135: {
        name: 'TWFG Insurance Services, LLC',
        address: '6001 Summerside Dr. Ste 100',
        city: 'Dallas',
        state: 'TX',
        zip: '75252',
        email: 'dbarfield@twfg.com',
        phone: '(469) 579-4982'
    },
    TWFG136: {
        name: 'TWFG Insurance Services, LLC',
        address: '2050 N. Loop W  Suite 120',
        city: 'Houston',
        state: 'TX',
        zip: '77018',
        email: 'kbridges@twfg.com',
        phone: '(713) 290-1600'
    },
    TWFG137: {
        name: 'TWFG Insurance Services, LLC',
        address: '4920 Westport Dr.',
        city: 'The Colony',
        state: 'TX',
        zip: '75056',
        email: 'lpowell@twfg.com',
        phone: '(972) 670-2903'
    },
    TWFG138: {
        name: 'TWFG Insurance Services, LLC',
        address: '2040 N Loop 336 W. Ste. 210',
        city: 'Conroe',
        state: 'TX',
        zip: '77304',
        email: 'cannon@twfg.com',
        phone: '(936) 445-9826'
    },
    TWFG139: {
        name: 'TWFG Insurance Services, LLC',
        address: '2625 W Pioneer Pkwy Ste 804',
        city: 'Grand Praire',
        state: 'TX',
        zip: '75051',
        email: 'ninh@twfg.com',
        phone: '(972) 975-5104'
    },
    TWFG140: {
        name: 'TWFG Insurance Services, LLC',
        address: '903 18th Street, Suite 226',
        city: 'Plano',
        state: 'TX',
        zip: '75074',
        email: 'munderwood@twfg.com',
        phone: '(972) 422-5625'
    },
    TWFG141: {
        name: 'TWFG Insurance Services, LLC',
        address: '204 Live Oak St',
        city: 'Marlin',
        state: 'TX',
        zip: '76661',
        email: 'jkeefer@twfg.com',
        phone: '(866) 587-1613'
    },
    TWFG142: {
        name: 'TWFG Insurance Services, LLC',
        address: '3000 Joe Dimaggio Blvd, Ste 43H',
        city: 'Round Rock',
        state: 'TX',
        zip: '78665',
        email: 'srosas@twfg.com',
        phone: '(512) 598-0120'
    },
    TWFG143: {
        name: 'TWFG Insurance Services, LLC',
        address: '9820 Gulf Freeway  Ste. A-809',
        city: 'Houston',
        state: 'TX',
        zip: '77034',
        email: 'pphan@twfg.com',
        phone: '(281) 962-4669'
    },
    TWFG144: {
        name: 'TWFG Insurance Services, LLC',
        address: '2050 North Loop West  Suite 120',
        city: 'Houston',
        state: 'TX',
        zip: '77018',
        email: 'msaunders@twfg.com',
        phone: '(713) 681-8400'
    },
    TWFG145: {
        name: 'TWFG Insurance Services, LLC',
        address: '1246 S Main St',
        city: 'Lumberton',
        state: 'TX',
        zip: '77657',
        email: 'khoffpauir@twfg.com',
        phone: '(409) 751-5400'
    },
    TWFG146: {
        name: 'TWFG Insurance Services, LLC',
        address: '8200 Westglen Suite F',
        city: 'Houston',
        state: 'TX',
        zip: '77063',
        email: 'danny.tran@twfg.com',
        phone: '(713) 814-5185'
    },
    TWFG147: {
        name: 'TWFG Insurance Services, LLC',
        address: '100 I-45 North, Ste 510',
        city: 'Conroe',
        state: 'TX',
        zip: '77301',
        email: 'smeyers@twfg.com',
        phone: '(936) 760-5963'
    },
    TWFG148: {
        name: 'TWFG Insurance Services, LLC',
        address: '6001 Summerside Dr. Ste 100',
        city: 'Dallas',
        state: 'TX',
        zip: '75252',
        email: 'ccantu@twfg.com',
        phone: '(972) 239-5727'
    },
    TWFG149: {
        name: 'TWFG Insurance Services, LLC',
        address: '804 Ferris Ave Suite 3',
        city: 'Waxahachie',
        state: 'TX',
        zip: '75165',
        email: 'jknapp@twfg.com',
        phone: '(972) 268-7175'
    },
    TWFG150: {
        name: 'TWFG Insurance Services, LLC',
        address: '820 W Spring Creek Parkway, Ste 400-1',
        city: 'Plano',
        state: 'TX',
        zip: '75023',
        email: 'hkaur@twfg.com',
        phone: '(972) 900-2203'
    },
    TWFG151: {
        name: 'TWFG Insurance Services, LLC',
        address: '101 West Renner Road Suite 270',
        city: 'Richardson',
        state: 'TX',
        zip: '75082',
        email: 'lnewman@twfg.com',
        phone: '(972) 495-6600'
    },
    TWFG152: {
        name: 'TWFG Insurance Services, LLC',
        address: '3301 N 3rd St., Ste. 107',
        city: 'Abilene',
        state: 'TX',
        zip: '79603',
        email: 'wbrooks@twfg.com',
        phone: '(325) 704-5177'
    },
    TWFG153: {
        name: 'TWFG Insurance Services, LLC',
        address: '137 National Highway',
        city: 'Lavale',
        state: 'MD',
        zip: '21502',
        email: 'dnorris@twfg.com',
        phone: '(240) 362-7195'
    },
    TWFG154: {
        name: 'TWFG Insurance Services, LLC',
        address: '955 Dairy Ashford Rd, Ste 221',
        city: 'Houston',
        state: 'TX',
        zip: '77079',
        email: 'dlocandro@twfg.com',
        phone: '(281) 506-8862'
    },
    TWFG155: {
        name: 'TWFG Insurance Services, LLC',
        address: '722 West Main St',
        city: 'Tomball',
        state: 'TX',
        zip: '77375',
        email: 'ddavis@twfg.com',
        phone: '(832) 559-1595'
    },
    TWFG156: {
        name: 'TWFG Insurance Services, LLC',
        address: '7825 Highway 6 N, Suite 106',
        city: 'Houston',
        state: 'TX',
        zip: '77095',
        email: 'lance@twfg.com',
        phone: '(832) 631-5382'
    },
    TWFG157: {
        name: 'TWFG Insurance Services, LLC',
        address: '1201 Lake Woodlands Dr. Suite 4020',
        city: 'The Woodlands',
        state: 'TX',
        zip: '77380',
        email: 'iurias@twfg.com',
        phone: '(726) 900-9124'
    },
    TWFG158: {
        name: 'TWFG Insurance Services, LLC',
        address: '16522 House & Hahl Rd. Ste F',
        city: 'Cypress',
        state: 'TX',
        zip: '77433',
        email: 'ekeenan@twfg.com',
        phone: '(281) 880-9964'
    },
    TWFG159: {
        name: 'TWFG Insurance Services, LLC',
        address: '1502 S. First St, Ste 3',
        city: 'Garland',
        state: 'TX',
        zip: '75040',
        email: 'iotto@twfg.com',
        phone: '(972) 272-0100'
    },
    TWFG160: {
        name: 'TWFG Insurance Services, LLC',
        address: '1201 Lake Woodlands Dr., Suite 4020',
        city: 'The Woodlands',
        state: 'TX',
        zip: '77380',
        email: 'cmeyers@twfg.com',
        phone: '(281) 367-3424'
    },
    TWFG161: {
        name: 'TWFG Insurance Services, LLC',
        address: '2911 A.W. Grimes Blvd. Ste. 610',
        city: 'Pflugerville',
        state: 'TX',
        zip: '78660',
        email: 'mrandazzo@twfg.com',
        phone: '(512) 252-2618'
    },
    TWFG162: {
        name: 'TWFG Insurance Services, LLC',
        address: '3600 N. 23rd Street, Suite 305',
        city: 'McAllen',
        state: 'TX',
        zip: '78501',
        email: 'tsalinas@twfg.com',
        phone: '(956) 682-4555'
    },
    TWFG163: {
        name: 'TWFG Insurance Services, LLC',
        address: '315 N. Travis  Suite C-7',
        city: 'Sherman',
        state: 'TX',
        zip: '75090',
        email: 'ktilghman@twfg.com',
        phone: '(903) 464-0007'
    },
    TWFG164: {
        name: 'TWFG Insurance Services, LLC',
        address: '9109 LBJ Freeway Suite 300  #17',
        city: 'Dallas',
        state: 'TX',
        zip: '75243',
        email: 'jansen.smith@twfg.com',
        phone: '(972) 777-5757'
    },
    TWFG165: {
        name: 'TWFG Insurance Services, LLC',
        address: '1035 Dairy Ashford  Suite 250',
        city: 'Houston',
        state: 'TX',
        zip: '77079',
        email: 'garmstrong@twfg.com',
        phone: '(281) 493-4126'
    },
    TWFG166: {
        name: 'TWFG Insurance Services ',
        address: '12112 Bellaire Blvd, Bldg A, Unit 3',
        city: 'Houston',
        state: 'TX',
        zip: '77072',
        email: 'tcao@twfg.com',
        phone: '(281) 440-1234'
    },
    TWFG167: {
        name: 'TWFG Insurance Services ',
        address: '5959 Westheimer Rd, Ste 141',
        city: 'Houston',
        state: 'TX',
        zip: '77057',
        email: 'greisy@twfg.com',
        phone: '(713) 955-5933'
    },
    TWFG168: {
        name: 'TWFG Insurance Services ',
        address: '308 17th St.',
        city: 'Canyon',
        state: 'TX',
        zip: '79015',
        email: 'mrampy@twfg.com',
        phone: '(806) 557-2100'
    },
    TWFG169: {
        name: 'TWFG Insurance Services ',
        address: '13100 Wortham Center Drive Suite 300',
        city: 'Houston',
        state: 'TX',
        zip: '77065',
        email: 'javier.chavez@twfg.com',
        phone: '(281) 819-5674'
    },
    TWFG170: {
        name: 'TWFG Insurance Services ',
        address: '7001 Corporate Dr  Ste 251',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'jwang@twfg.com',
        phone: '(713) 272-9996'
    },
    TWFG171: {
        name: 'TWFG Insurance Services ',
        address: '12454 Beechnut St.  Ste. 9B',
        city: 'Houston',
        state: 'TX',
        zip: '77072',
        email: 'tngo@twfg.com',
        phone: '(281) 715-0007'
    },
    TWFG172: {
        name: 'TWFG Insurance Services ',
        address: '4600 Hwy 6 N, Ste 230',
        city: 'Houston',
        state: 'TX',
        zip: '77084',
        email: 'wcooper@twfg.com',
        phone: '(713) 635-9076'
    },
    TWFG173: {
        name: 'TWFG Insurance Services ',
        address: '1414 Stonehollow Dr Ste 4 ',
        city: 'Kingwood',
        state: 'TX',
        zip: '77339',
        email: 'sstover@twfg.com',
        phone: '(281) 361-3000'
    },
    TWFG174: {
        name: 'TWFG Insurance Services ',
        address: '1010 S. Magnolia Blvd., Ste. A',
        city: 'Magnolia',
        state: 'TX',
        zip: '77355',
        email: 'syoung@twfg.com',
        phone: '(713) 417-6730'
    },
    TWFG175: {
        name: 'TWFG Insurance Services ',
        address: '11110 Bellaire Blvd, Suite 101',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'terry@twfg.com',
        phone: '(832) 598-5770'
    },
    TWFG176: {
        name: 'TWFG Insurance Services ',
        address: '1209 Ft Worth Ave #101',
        city: 'Dallas',
        state: 'TX',
        zip: '75208',
        email: 'rzires@twfg.com',
        phone: '(214) 339-2222'
    },
    TWFG177: {
        name: 'TWFG Insurance Services ',
        address: '704 N. Thompson St, Ste 165',
        city: 'Conroe',
        state: 'TX',
        zip: '77301',
        email: 'tmartin@twfg.com',
        phone: '(281) 466-1373'
    },
    TWFG178: {
        name: 'TWFG Insurance Services ',
        address: '808 Russell Palmer Rd, Ste 264',
        city: 'Kingwood',
        state: 'TX',
        zip: '77339',
        email: 'nguajardo@twfg.com',
        phone: '(713) 352-3064'
    },
    TWFG179: {
        name: 'TWFG Insurance Services ',
        address: '2711 LBJ Freeway #114',
        city: 'Dallas',
        state: 'TX',
        zip: '75234',
        email: 'hjumani@twfg.com',
        phone: '(972) 375-3327'
    },
    TWFG180: {
        name: 'TWFG Insurance Services ',
        address: '2828 Forest Ln Suite 1143',
        city: 'Dallas',
        state: 'TX',
        zip: '75234',
        email: 'nortega@twfg.com',
        phone: '(972) 243-3225'
    },
    TWFG181: {
        name: 'TWFG Insurance Services ',
        address: '6464 Savoy Dr, Suite 730 ',
        city: 'Houston',
        state: 'TX',
        zip: '77036',
        email: 'lkariuki@twfg.com',
        phone: '(832) 228-7884'
    },
    TWFG182: {
        name: 'TWFG Insurance Services ',
        address: '14550 Torrey Chase Blvd, Ste 255',
        city: 'Houston',
        state: 'TX',
        zip: '77014',
        email: 'dtravis@twfg.com',
        phone: '(832) 286-4689'
    },
    TWFG183: {
        name: 'TWFG',
        address: '22206 Highland Knolls Dr. Ste. B ',
        city: 'Katy',
        state: 'TX',
        zip: '77450',
        email: 'sflorez@twfg.com',
        phone: '(713) 377-2005'
    },
    TWFG184: {
        name: 'TWFG Insurance Services ',
        address: '1415 N Loop West Suite 720',
        city: 'Houston',
        state: 'TX',
        zip: '77008',
        email: 'jose.rodriguez@twfg.com',
        phone: '(832) 582-5892'
    },
    TWFG185: {
        name: 'TWFG Insurance Services ',
        address: '675 Town Square Blvd. Building 1A, Suite 200',
        city: 'Garland',
        state: 'TX',
        zip: '75040',
        email: 'emily.tran@twfg.com',
        phone: '(972) 325-9092'
    },
    TWFG186: {
        name: 'TWFG Insurance Services ',
        address: '3000 Brownsville Rd',
        city: 'Pittsburgh',
        state: 'PA',
        zip: '15227',
        email: 'udahal@twfg.com',
        phone: '(412) 228-3700'
    },
    TWFG187: {
        name: 'TWFG Insurance Services ',
        address: '3311 Preston Ave',
        city: 'Pasadena',
        state: 'TX',
        zip: '77505',
        email: 'sserrano@twfg.com',
        phone: '(281) 937-4388'
    },
    TXCL1: {
        name: 'Texas Classic Insurance',
        address: '4400 E US Hwy 377 ',
        city: 'Benbrook',
        state: 'TX',
        zip: '76049',
        email: 'service@txcins.com',
        phone: '817-279-7200'
    },
    UNQ1: {
        name: 'Unique Insurance Agency LLC',
        address: '255 Jean Dr',
        city: 'Pittsburgh ',
        state: 'PA',
        zip: '15236',
        email: 'ddahal@uniqueinsurancellc.com',
        phone: '412-822-4087'
    },
    VENS1: {
        name: 'Venus Insurance Group',
        address: '9901 Valley Ranch Pkwy E, Suite 2039',
        city: 'Irving',
        state: 'TX',
        zip: '75063',
        email: 'kris@venusins.com',
        phone: '765-577-5747'
    },
    VGHN1: {
        name: 'Vaughan Insurance Agency LLC',
        address: '712 Sawyer Dr.',
        city: 'Saginaw',
        state: 'TX',
        zip: '76179',
        email: 'dave@vaughaninsurance.net',
        phone: '817-379-4500'
    },
    VIN16: {
        name: 'Paradigm Insurance',
        address: '925 S Clinton St',
        city: 'Defiance',
        state: 'OH',
        zip: '43512',
        email: 'cheyenneb@paradigmins.co',
        phone: '419-930-1354'
    },
    VIN17: {
        name: 'Vienna Ly Insurance',
        address: '1818 Pioneer Pkwy STE 118',
        city: 'Arlington',
        state: 'TX',
        zip: '76010',
        email: 'viennaly8888@gmail.com',
        phone: '(817) 716-6282'
    },
    VIN18: {
        name: 'Great Rate Insurance Inc.',
        address: '10102 Angeles Rd',
        city: 'Peyton',
        state: 'CO',
        zip: '80831',
        email: 'jcox1473@yahoo.com',
        phone: '719-253-2886'
    },
    VIN19: {
        name: 'Saorsa Insurance Group LLC',
        address: '12066 Starcreat Drive, Suite 500',
        city: 'San Antonio',
        state: 'TX',
        zip: '78247',
        email: 'sarah@saorsainsurance.com',
        phone: '720-737-3000'
    },
    VIN20: {
        name: 'P.S. Insurance Agency LLC',
        address: '2172 Lincoln Way E',
        city: 'Chambersburg',
        state: 'PA',
        zip: '17202',
        email: 'office@psinsuranceagency.com',
        phone: '717-256-1333'
    },
    VIV1: {
        name: 'Vivint Insurance',
        address: '',
        city: '',
        state: '',
        zip: '',
        email: 'Insurancesupport@vivint.com'
    },
    VV2: {
        name: 'Vivint Insurance',
        address: '',
        city: '',
        state: '',
        zip: '',
        email: 'Insurancesupport@vivint.com'
    },
    VV3: {
        name: 'Vivint Insurance',
        address: '',
        city: '',
        state: '',
        zip: '',
        email: 'Insurancesupport@vivint.com'
    },
    WCI1: {
        name: 'White Clay Insurance',
        address: '630 Churchmans Rd, Ste 203',
        city: 'Newark',
        state: 'DE',
        zip: '19702',
        email: 'tjwolfer@whiteclayinsurance.com',
        phone: '302-525-6720'
    },
    WLGS1: {
        name: 'Wilgus Insurance Agency Inc.',
        address: '1203 Pemberton Dr.',
        city: 'Salisbury',
        state: 'MD',
        zip: '21801',
        email: 'susan@wilgusins.com',
        phone: '410-742-8251'
    },
    WSTX1: {
        name: 'West Texas Insurance Agency',
        address: '3702 mockingbird ln',
        city: 'amarillo',
        state: 'tx',
        zip: '79109',
        email: 'tgeorge@westtexasinsuranceagency.com',
        phone: '8063522090'
    },
    WXFRD1: {
        name: 'Wexford Insurance, LLC',
        address: '1083 Vicksburg South Drive',
        city: 'Greenwood',
        state: 'IN',
        zip: '46143',
        email: 'njones@wexfordins.com',
        phone: '317-910-9295'
    },
    YA1: {
        name: 'Young Alfred',
        address: '1700 Market Street Suite 1005',
        city: 'Philadelphia',
        state: 'PA',
        zip: '19103',
        email: 'alfred@youngalfred.com',
        phone: '800-640-5001'
    },
    YP1: {
        name: 'Your Policy',
        address: '101 Jonathan Suite 103',
        city: 'Liberty Hill',
        state: 'TX',
        zip: '78643',
        email: 'service@your-policy.com',
        phone: '512-515-0333'
    },
    VV1: {
        name: 'Vivint Insurance',
        email: 'Insurancesupport@vivint.com',
        phone: '877-314-1208'
    },
    ZB1: {
        name: 'The Zebra',
        address: '1801 E.6th Street',
        city: 'Austin',
        state: 'TX',
        zip: '78702',
        email: 'service@thezebra.com',
        phone: '888-444-8949'
    }
};
exports.default = agencyInformation;
